var Za = Object.defineProperty;
var Ki = (n) => {
  throw TypeError(n);
};
var Ka = (n, t, e) => t in n ? Za(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var E = (n, t, e) => Ka(n, typeof t != "symbol" ? t + "" : t, e), Zr = (n, t, e) => t.has(n) || Ki("Cannot " + e);
var I = (n, t, e) => (Zr(n, t, "read from private field"), e ? e.call(n) : t.get(n)), X = (n, t, e) => t.has(n) ? Ki("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(n) : t.set(n, e), K = (n, t, e, r) => (Zr(n, t, "write to private field"), r ? r.call(n, e) : t.set(n, e), e), tt = (n, t, e) => (Zr(n, t, "access private method"), e);
var Wi = (n, t, e, r) => ({
  set _(i) {
    K(n, t, i, e);
  },
  get _() {
    return I(n, t, r);
  }
});
import { g as Wa, c as Ja, a as Xa } from "./_commonjsHelpers-BVfed4GL.js";
import { N as O, b as Ya } from "./network-B7Rd_tuN.js";
import { e as Qa } from "./urls-A831vTmk.js";
import { a as R, b as $, d as z, c as wi, e as Fs, i as Dn, m as lr, r as jr, f as Ls } from "./errors-Jh6CB33H.js";
var bi = { exports: {} };
const ja = {}, to = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ja
}, Symbol.toStringTag, { value: "Module" })), eo = /* @__PURE__ */ Wa(to);
bi.exports;
(function(n) {
  (function(t, e) {
    function r(b, a) {
      if (!b) throw new Error(a || "Assertion failed");
    }
    function i(b, a) {
      b.super_ = a;
      var l = function() {
      };
      l.prototype = a.prototype, b.prototype = new l(), b.prototype.constructor = b;
    }
    function s(b, a, l) {
      if (s.isBN(b))
        return b;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, b !== null && ((a === "le" || a === "be") && (l = a, a = 10), this._init(b || 0, a || 10, l || "be"));
    }
    typeof t == "object" ? t.exports = s : e.BN = s, s.BN = s, s.wordSize = 26;
    var o;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? o = window.Buffer : o = eo.Buffer;
    } catch {
    }
    s.isBN = function(a) {
      return a instanceof s ? !0 : a !== null && typeof a == "object" && a.constructor.wordSize === s.wordSize && Array.isArray(a.words);
    }, s.max = function(a, l) {
      return a.cmp(l) > 0 ? a : l;
    }, s.min = function(a, l) {
      return a.cmp(l) < 0 ? a : l;
    }, s.prototype._init = function(a, l, p) {
      if (typeof a == "number")
        return this._initNumber(a, l, p);
      if (typeof a == "object")
        return this._initArray(a, l, p);
      l === "hex" && (l = 16), r(l === (l | 0) && l >= 2 && l <= 36), a = a.toString().replace(/\s+/g, "");
      var y = 0;
      a[0] === "-" && (y++, this.negative = 1), y < a.length && (l === 16 ? this._parseHex(a, y, p) : (this._parseBase(a, l, y), p === "le" && this._initArray(this.toArray(), l, p)));
    }, s.prototype._initNumber = function(a, l, p) {
      a < 0 && (this.negative = 1, a = -a), a < 67108864 ? (this.words = [a & 67108863], this.length = 1) : a < 4503599627370496 ? (this.words = [
        a & 67108863,
        a / 67108864 & 67108863
      ], this.length = 2) : (r(a < 9007199254740992), this.words = [
        a & 67108863,
        a / 67108864 & 67108863,
        1
      ], this.length = 3), p === "le" && this._initArray(this.toArray(), l, p);
    }, s.prototype._initArray = function(a, l, p) {
      if (r(typeof a.length == "number"), a.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(a.length / 3), this.words = new Array(this.length);
      for (var y = 0; y < this.length; y++)
        this.words[y] = 0;
      var w, T, M = 0;
      if (p === "be")
        for (y = a.length - 1, w = 0; y >= 0; y -= 3)
          T = a[y] | a[y - 1] << 8 | a[y - 2] << 16, this.words[w] |= T << M & 67108863, this.words[w + 1] = T >>> 26 - M & 67108863, M += 24, M >= 26 && (M -= 26, w++);
      else if (p === "le")
        for (y = 0, w = 0; y < a.length; y += 3)
          T = a[y] | a[y + 1] << 8 | a[y + 2] << 16, this.words[w] |= T << M & 67108863, this.words[w + 1] = T >>> 26 - M & 67108863, M += 24, M >= 26 && (M -= 26, w++);
      return this._strip();
    };
    function f(b, a) {
      var l = b.charCodeAt(a);
      if (l >= 48 && l <= 57)
        return l - 48;
      if (l >= 65 && l <= 70)
        return l - 55;
      if (l >= 97 && l <= 102)
        return l - 87;
      r(!1, "Invalid character in " + b);
    }
    function c(b, a, l) {
      var p = f(b, l);
      return l - 1 >= a && (p |= f(b, l - 1) << 4), p;
    }
    s.prototype._parseHex = function(a, l, p) {
      this.length = Math.ceil((a.length - l) / 6), this.words = new Array(this.length);
      for (var y = 0; y < this.length; y++)
        this.words[y] = 0;
      var w = 0, T = 0, M;
      if (p === "be")
        for (y = a.length - 1; y >= l; y -= 2)
          M = c(a, l, y) << w, this.words[T] |= M & 67108863, w >= 18 ? (w -= 18, T += 1, this.words[T] |= M >>> 26) : w += 8;
      else {
        var m = a.length - l;
        for (y = m % 2 === 0 ? l + 1 : l; y < a.length; y += 2)
          M = c(a, l, y) << w, this.words[T] |= M & 67108863, w >= 18 ? (w -= 18, T += 1, this.words[T] |= M >>> 26) : w += 8;
      }
      this._strip();
    };
    function d(b, a, l, p) {
      for (var y = 0, w = 0, T = Math.min(b.length, l), M = a; M < T; M++) {
        var m = b.charCodeAt(M) - 48;
        y *= p, m >= 49 ? w = m - 49 + 10 : m >= 17 ? w = m - 17 + 10 : w = m, r(m >= 0 && w < p, "Invalid character"), y += w;
      }
      return y;
    }
    s.prototype._parseBase = function(a, l, p) {
      this.words = [0], this.length = 1;
      for (var y = 0, w = 1; w <= 67108863; w *= l)
        y++;
      y--, w = w / l | 0;
      for (var T = a.length - p, M = T % y, m = Math.min(T, T - M) + p, u = 0, g = p; g < m; g += y)
        u = d(a, g, g + y, l), this.imuln(w), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
      if (M !== 0) {
        var L = 1;
        for (u = d(a, g, a.length, l), g = 0; g < M; g++)
          L *= l;
        this.imuln(L), this.words[0] + u < 67108864 ? this.words[0] += u : this._iaddn(u);
      }
      this._strip();
    }, s.prototype.copy = function(a) {
      a.words = new Array(this.length);
      for (var l = 0; l < this.length; l++)
        a.words[l] = this.words[l];
      a.length = this.length, a.negative = this.negative, a.red = this.red;
    };
    function h(b, a) {
      b.words = a.words, b.length = a.length, b.negative = a.negative, b.red = a.red;
    }
    if (s.prototype._move = function(a) {
      h(a, this);
    }, s.prototype.clone = function() {
      var a = new s(null);
      return this.copy(a), a;
    }, s.prototype._expand = function(a) {
      for (; this.length < a; )
        this.words[this.length++] = 0;
      return this;
    }, s.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, s.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        s.prototype[Symbol.for("nodejs.util.inspect.custom")] = v;
      } catch {
        s.prototype.inspect = v;
      }
    else
      s.prototype.inspect = v;
    function v() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var x = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], N = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], _ = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    s.prototype.toString = function(a, l) {
      a = a || 10, l = l | 0 || 1;
      var p;
      if (a === 16 || a === "hex") {
        p = "";
        for (var y = 0, w = 0, T = 0; T < this.length; T++) {
          var M = this.words[T], m = ((M << y | w) & 16777215).toString(16);
          w = M >>> 24 - y & 16777215, y += 2, y >= 26 && (y -= 26, T--), w !== 0 || T !== this.length - 1 ? p = x[6 - m.length] + m + p : p = m + p;
        }
        for (w !== 0 && (p = w.toString(16) + p); p.length % l !== 0; )
          p = "0" + p;
        return this.negative !== 0 && (p = "-" + p), p;
      }
      if (a === (a | 0) && a >= 2 && a <= 36) {
        var u = N[a], g = _[a];
        p = "";
        var L = this.clone();
        for (L.negative = 0; !L.isZero(); ) {
          var C = L.modrn(g).toString(a);
          L = L.idivn(g), L.isZero() ? p = C + p : p = x[u - C.length] + C + p;
        }
        for (this.isZero() && (p = "0" + p); p.length % l !== 0; )
          p = "0" + p;
        return this.negative !== 0 && (p = "-" + p), p;
      }
      r(!1, "Base should be between 2 and 36");
    }, s.prototype.toNumber = function() {
      var a = this.words[0];
      return this.length === 2 ? a += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? a += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && r(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -a : a;
    }, s.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, o && (s.prototype.toBuffer = function(a, l) {
      return this.toArrayLike(o, a, l);
    }), s.prototype.toArray = function(a, l) {
      return this.toArrayLike(Array, a, l);
    };
    var k = function(a, l) {
      return a.allocUnsafe ? a.allocUnsafe(l) : new a(l);
    };
    s.prototype.toArrayLike = function(a, l, p) {
      this._strip();
      var y = this.byteLength(), w = p || Math.max(1, y);
      r(y <= w, "byte array longer than desired length"), r(w > 0, "Requested array length <= 0");
      var T = k(a, w), M = l === "le" ? "LE" : "BE";
      return this["_toArrayLike" + M](T, y), T;
    }, s.prototype._toArrayLikeLE = function(a, l) {
      for (var p = 0, y = 0, w = 0, T = 0; w < this.length; w++) {
        var M = this.words[w] << T | y;
        a[p++] = M & 255, p < a.length && (a[p++] = M >> 8 & 255), p < a.length && (a[p++] = M >> 16 & 255), T === 6 ? (p < a.length && (a[p++] = M >> 24 & 255), y = 0, T = 0) : (y = M >>> 24, T += 2);
      }
      if (p < a.length)
        for (a[p++] = y; p < a.length; )
          a[p++] = 0;
    }, s.prototype._toArrayLikeBE = function(a, l) {
      for (var p = a.length - 1, y = 0, w = 0, T = 0; w < this.length; w++) {
        var M = this.words[w] << T | y;
        a[p--] = M & 255, p >= 0 && (a[p--] = M >> 8 & 255), p >= 0 && (a[p--] = M >> 16 & 255), T === 6 ? (p >= 0 && (a[p--] = M >> 24 & 255), y = 0, T = 0) : (y = M >>> 24, T += 2);
      }
      if (p >= 0)
        for (a[p--] = y; p >= 0; )
          a[p--] = 0;
    }, Math.clz32 ? s.prototype._countBits = function(a) {
      return 32 - Math.clz32(a);
    } : s.prototype._countBits = function(a) {
      var l = a, p = 0;
      return l >= 4096 && (p += 13, l >>>= 13), l >= 64 && (p += 7, l >>>= 7), l >= 8 && (p += 4, l >>>= 4), l >= 2 && (p += 2, l >>>= 2), p + l;
    }, s.prototype._zeroBits = function(a) {
      if (a === 0) return 26;
      var l = a, p = 0;
      return l & 8191 || (p += 13, l >>>= 13), l & 127 || (p += 7, l >>>= 7), l & 15 || (p += 4, l >>>= 4), l & 3 || (p += 2, l >>>= 2), l & 1 || p++, p;
    }, s.prototype.bitLength = function() {
      var a = this.words[this.length - 1], l = this._countBits(a);
      return (this.length - 1) * 26 + l;
    };
    function G(b) {
      for (var a = new Array(b.bitLength()), l = 0; l < a.length; l++) {
        var p = l / 26 | 0, y = l % 26;
        a[l] = b.words[p] >>> y & 1;
      }
      return a;
    }
    s.prototype.zeroBits = function() {
      if (this.isZero()) return 0;
      for (var a = 0, l = 0; l < this.length; l++) {
        var p = this._zeroBits(this.words[l]);
        if (a += p, p !== 26) break;
      }
      return a;
    }, s.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, s.prototype.toTwos = function(a) {
      return this.negative !== 0 ? this.abs().inotn(a).iaddn(1) : this.clone();
    }, s.prototype.fromTwos = function(a) {
      return this.testn(a - 1) ? this.notn(a).iaddn(1).ineg() : this.clone();
    }, s.prototype.isNeg = function() {
      return this.negative !== 0;
    }, s.prototype.neg = function() {
      return this.clone().ineg();
    }, s.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, s.prototype.iuor = function(a) {
      for (; this.length < a.length; )
        this.words[this.length++] = 0;
      for (var l = 0; l < a.length; l++)
        this.words[l] = this.words[l] | a.words[l];
      return this._strip();
    }, s.prototype.ior = function(a) {
      return r((this.negative | a.negative) === 0), this.iuor(a);
    }, s.prototype.or = function(a) {
      return this.length > a.length ? this.clone().ior(a) : a.clone().ior(this);
    }, s.prototype.uor = function(a) {
      return this.length > a.length ? this.clone().iuor(a) : a.clone().iuor(this);
    }, s.prototype.iuand = function(a) {
      var l;
      this.length > a.length ? l = a : l = this;
      for (var p = 0; p < l.length; p++)
        this.words[p] = this.words[p] & a.words[p];
      return this.length = l.length, this._strip();
    }, s.prototype.iand = function(a) {
      return r((this.negative | a.negative) === 0), this.iuand(a);
    }, s.prototype.and = function(a) {
      return this.length > a.length ? this.clone().iand(a) : a.clone().iand(this);
    }, s.prototype.uand = function(a) {
      return this.length > a.length ? this.clone().iuand(a) : a.clone().iuand(this);
    }, s.prototype.iuxor = function(a) {
      var l, p;
      this.length > a.length ? (l = this, p = a) : (l = a, p = this);
      for (var y = 0; y < p.length; y++)
        this.words[y] = l.words[y] ^ p.words[y];
      if (this !== l)
        for (; y < l.length; y++)
          this.words[y] = l.words[y];
      return this.length = l.length, this._strip();
    }, s.prototype.ixor = function(a) {
      return r((this.negative | a.negative) === 0), this.iuxor(a);
    }, s.prototype.xor = function(a) {
      return this.length > a.length ? this.clone().ixor(a) : a.clone().ixor(this);
    }, s.prototype.uxor = function(a) {
      return this.length > a.length ? this.clone().iuxor(a) : a.clone().iuxor(this);
    }, s.prototype.inotn = function(a) {
      r(typeof a == "number" && a >= 0);
      var l = Math.ceil(a / 26) | 0, p = a % 26;
      this._expand(l), p > 0 && l--;
      for (var y = 0; y < l; y++)
        this.words[y] = ~this.words[y] & 67108863;
      return p > 0 && (this.words[y] = ~this.words[y] & 67108863 >> 26 - p), this._strip();
    }, s.prototype.notn = function(a) {
      return this.clone().inotn(a);
    }, s.prototype.setn = function(a, l) {
      r(typeof a == "number" && a >= 0);
      var p = a / 26 | 0, y = a % 26;
      return this._expand(p + 1), l ? this.words[p] = this.words[p] | 1 << y : this.words[p] = this.words[p] & ~(1 << y), this._strip();
    }, s.prototype.iadd = function(a) {
      var l;
      if (this.negative !== 0 && a.negative === 0)
        return this.negative = 0, l = this.isub(a), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && a.negative !== 0)
        return a.negative = 0, l = this.isub(a), a.negative = 1, l._normSign();
      var p, y;
      this.length > a.length ? (p = this, y = a) : (p = a, y = this);
      for (var w = 0, T = 0; T < y.length; T++)
        l = (p.words[T] | 0) + (y.words[T] | 0) + w, this.words[T] = l & 67108863, w = l >>> 26;
      for (; w !== 0 && T < p.length; T++)
        l = (p.words[T] | 0) + w, this.words[T] = l & 67108863, w = l >>> 26;
      if (this.length = p.length, w !== 0)
        this.words[this.length] = w, this.length++;
      else if (p !== this)
        for (; T < p.length; T++)
          this.words[T] = p.words[T];
      return this;
    }, s.prototype.add = function(a) {
      var l;
      return a.negative !== 0 && this.negative === 0 ? (a.negative = 0, l = this.sub(a), a.negative ^= 1, l) : a.negative === 0 && this.negative !== 0 ? (this.negative = 0, l = a.sub(this), this.negative = 1, l) : this.length > a.length ? this.clone().iadd(a) : a.clone().iadd(this);
    }, s.prototype.isub = function(a) {
      if (a.negative !== 0) {
        a.negative = 0;
        var l = this.iadd(a);
        return a.negative = 1, l._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(a), this.negative = 1, this._normSign();
      var p = this.cmp(a);
      if (p === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var y, w;
      p > 0 ? (y = this, w = a) : (y = a, w = this);
      for (var T = 0, M = 0; M < w.length; M++)
        l = (y.words[M] | 0) - (w.words[M] | 0) + T, T = l >> 26, this.words[M] = l & 67108863;
      for (; T !== 0 && M < y.length; M++)
        l = (y.words[M] | 0) + T, T = l >> 26, this.words[M] = l & 67108863;
      if (T === 0 && M < y.length && y !== this)
        for (; M < y.length; M++)
          this.words[M] = y.words[M];
      return this.length = Math.max(this.length, M), y !== this && (this.negative = 1), this._strip();
    }, s.prototype.sub = function(a) {
      return this.clone().isub(a);
    };
    function U(b, a, l) {
      l.negative = a.negative ^ b.negative;
      var p = b.length + a.length | 0;
      l.length = p, p = p - 1 | 0;
      var y = b.words[0] | 0, w = a.words[0] | 0, T = y * w, M = T & 67108863, m = T / 67108864 | 0;
      l.words[0] = M;
      for (var u = 1; u < p; u++) {
        for (var g = m >>> 26, L = m & 67108863, C = Math.min(u, a.length - 1), D = Math.max(0, u - b.length + 1); D <= C; D++) {
          var Kt = u - D | 0;
          y = b.words[Kt] | 0, w = a.words[D] | 0, T = y * w + L, g += T / 67108864 | 0, L = T & 67108863;
        }
        l.words[u] = L | 0, m = g | 0;
      }
      return m !== 0 ? l.words[u] = m | 0 : l.length--, l._strip();
    }
    var J = function(a, l, p) {
      var y = a.words, w = l.words, T = p.words, M = 0, m, u, g, L = y[0] | 0, C = L & 8191, D = L >>> 13, Kt = y[1] | 0, Q = Kt & 8191, j = Kt >>> 13, ki = y[2] | 0, st = ki & 8191, at = ki >>> 13, Oi = y[3] | 0, ot = Oi & 8191, ut = Oi >>> 13, _i = y[4] | 0, lt = _i & 8191, ft = _i >>> 13, Si = y[5] | 0, ct = Si & 8191, dt = Si >>> 13, Pi = y[6] | 0, pt = Pi & 8191, ht = Pi >>> 13, Ui = y[7] | 0, mt = Ui & 8191, yt = Ui >>> 13, Bi = y[8] | 0, gt = Bi & 8191, wt = Bi >>> 13, Ci = y[9] | 0, bt = Ci & 8191, vt = Ci >>> 13, Fi = w[0] | 0, Tt = Fi & 8191, xt = Fi >>> 13, Li = w[1] | 0, Mt = Li & 8191, Et = Li >>> 13, Di = w[2] | 0, Nt = Di & 8191, At = Di >>> 13, $i = w[3] | 0, It = $i & 8191, Rt = $i >>> 13, Gi = w[4] | 0, kt = Gi & 8191, Ot = Gi >>> 13, Hi = w[5] | 0, _t = Hi & 8191, St = Hi >>> 13, Vi = w[6] | 0, Pt = Vi & 8191, Ut = Vi >>> 13, zi = w[7] | 0, Bt = zi & 8191, Ct = zi >>> 13, qi = w[8] | 0, Ft = qi & 8191, Lt = qi >>> 13, Zi = w[9] | 0, Dt = Zi & 8191, $t = Zi >>> 13;
      p.negative = a.negative ^ l.negative, p.length = 19, m = Math.imul(C, Tt), u = Math.imul(C, xt), u = u + Math.imul(D, Tt) | 0, g = Math.imul(D, xt);
      var Ir = (M + m | 0) + ((u & 8191) << 13) | 0;
      M = (g + (u >>> 13) | 0) + (Ir >>> 26) | 0, Ir &= 67108863, m = Math.imul(Q, Tt), u = Math.imul(Q, xt), u = u + Math.imul(j, Tt) | 0, g = Math.imul(j, xt), m = m + Math.imul(C, Mt) | 0, u = u + Math.imul(C, Et) | 0, u = u + Math.imul(D, Mt) | 0, g = g + Math.imul(D, Et) | 0;
      var Rr = (M + m | 0) + ((u & 8191) << 13) | 0;
      M = (g + (u >>> 13) | 0) + (Rr >>> 26) | 0, Rr &= 67108863, m = Math.imul(st, Tt), u = Math.imul(st, xt), u = u + Math.imul(at, Tt) | 0, g = Math.imul(at, xt), m = m + Math.imul(Q, Mt) | 0, u = u + Math.imul(Q, Et) | 0, u = u + Math.imul(j, Mt) | 0, g = g + Math.imul(j, Et) | 0, m = m + Math.imul(C, Nt) | 0, u = u + Math.imul(C, At) | 0, u = u + Math.imul(D, Nt) | 0, g = g + Math.imul(D, At) | 0;
      var kr = (M + m | 0) + ((u & 8191) << 13) | 0;
      M = (g + (u >>> 13) | 0) + (kr >>> 26) | 0, kr &= 67108863, m = Math.imul(ot, Tt), u = Math.imul(ot, xt), u = u + Math.imul(ut, Tt) | 0, g = Math.imul(ut, xt), m = m + Math.imul(st, Mt) | 0, u = u + Math.imul(st, Et) | 0, u = u + Math.imul(at, Mt) | 0, g = g + Math.imul(at, Et) | 0, m = m + Math.imul(Q, Nt) | 0, u = u + Math.imul(Q, At) | 0, u = u + Math.imul(j, Nt) | 0, g = g + Math.imul(j, At) | 0, m = m + Math.imul(C, It) | 0, u = u + Math.imul(C, Rt) | 0, u = u + Math.imul(D, It) | 0, g = g + Math.imul(D, Rt) | 0;
      var Or = (M + m | 0) + ((u & 8191) << 13) | 0;
      M = (g + (u >>> 13) | 0) + (Or >>> 26) | 0, Or &= 67108863, m = Math.imul(lt, Tt), u = Math.imul(lt, xt), u = u + Math.imul(ft, Tt) | 0, g = Math.imul(ft, xt), m = m + Math.imul(ot, Mt) | 0, u = u + Math.imul(ot, Et) | 0, u = u + Math.imul(ut, Mt) | 0, g = g + Math.imul(ut, Et) | 0, m = m + Math.imul(st, Nt) | 0, u = u + Math.imul(st, At) | 0, u = u + Math.imul(at, Nt) | 0, g = g + Math.imul(at, At) | 0, m = m + Math.imul(Q, It) | 0, u = u + Math.imul(Q, Rt) | 0, u = u + Math.imul(j, It) | 0, g = g + Math.imul(j, Rt) | 0, m = m + Math.imul(C, kt) | 0, u = u + Math.imul(C, Ot) | 0, u = u + Math.imul(D, kt) | 0, g = g + Math.imul(D, Ot) | 0;
      var _r = (M + m | 0) + ((u & 8191) << 13) | 0;
      M = (g + (u >>> 13) | 0) + (_r >>> 26) | 0, _r &= 67108863, m = Math.imul(ct, Tt), u = Math.imul(ct, xt), u = u + Math.imul(dt, Tt) | 0, g = Math.imul(dt, xt), m = m + Math.imul(lt, Mt) | 0, u = u + Math.imul(lt, Et) | 0, u = u + Math.imul(ft, Mt) | 0, g = g + Math.imul(ft, Et) | 0, m = m + Math.imul(ot, Nt) | 0, u = u + Math.imul(ot, At) | 0, u = u + Math.imul(ut, Nt) | 0, g = g + Math.imul(ut, At) | 0, m = m + Math.imul(st, It) | 0, u = u + Math.imul(st, Rt) | 0, u = u + Math.imul(at, It) | 0, g = g + Math.imul(at, Rt) | 0, m = m + Math.imul(Q, kt) | 0, u = u + Math.imul(Q, Ot) | 0, u = u + Math.imul(j, kt) | 0, g = g + Math.imul(j, Ot) | 0, m = m + Math.imul(C, _t) | 0, u = u + Math.imul(C, St) | 0, u = u + Math.imul(D, _t) | 0, g = g + Math.imul(D, St) | 0;
      var Sr = (M + m | 0) + ((u & 8191) << 13) | 0;
      M = (g + (u >>> 13) | 0) + (Sr >>> 26) | 0, Sr &= 67108863, m = Math.imul(pt, Tt), u = Math.imul(pt, xt), u = u + Math.imul(ht, Tt) | 0, g = Math.imul(ht, xt), m = m + Math.imul(ct, Mt) | 0, u = u + Math.imul(ct, Et) | 0, u = u + Math.imul(dt, Mt) | 0, g = g + Math.imul(dt, Et) | 0, m = m + Math.imul(lt, Nt) | 0, u = u + Math.imul(lt, At) | 0, u = u + Math.imul(ft, Nt) | 0, g = g + Math.imul(ft, At) | 0, m = m + Math.imul(ot, It) | 0, u = u + Math.imul(ot, Rt) | 0, u = u + Math.imul(ut, It) | 0, g = g + Math.imul(ut, Rt) | 0, m = m + Math.imul(st, kt) | 0, u = u + Math.imul(st, Ot) | 0, u = u + Math.imul(at, kt) | 0, g = g + Math.imul(at, Ot) | 0, m = m + Math.imul(Q, _t) | 0, u = u + Math.imul(Q, St) | 0, u = u + Math.imul(j, _t) | 0, g = g + Math.imul(j, St) | 0, m = m + Math.imul(C, Pt) | 0, u = u + Math.imul(C, Ut) | 0, u = u + Math.imul(D, Pt) | 0, g = g + Math.imul(D, Ut) | 0;
      var Pr = (M + m | 0) + ((u & 8191) << 13) | 0;
      M = (g + (u >>> 13) | 0) + (Pr >>> 26) | 0, Pr &= 67108863, m = Math.imul(mt, Tt), u = Math.imul(mt, xt), u = u + Math.imul(yt, Tt) | 0, g = Math.imul(yt, xt), m = m + Math.imul(pt, Mt) | 0, u = u + Math.imul(pt, Et) | 0, u = u + Math.imul(ht, Mt) | 0, g = g + Math.imul(ht, Et) | 0, m = m + Math.imul(ct, Nt) | 0, u = u + Math.imul(ct, At) | 0, u = u + Math.imul(dt, Nt) | 0, g = g + Math.imul(dt, At) | 0, m = m + Math.imul(lt, It) | 0, u = u + Math.imul(lt, Rt) | 0, u = u + Math.imul(ft, It) | 0, g = g + Math.imul(ft, Rt) | 0, m = m + Math.imul(ot, kt) | 0, u = u + Math.imul(ot, Ot) | 0, u = u + Math.imul(ut, kt) | 0, g = g + Math.imul(ut, Ot) | 0, m = m + Math.imul(st, _t) | 0, u = u + Math.imul(st, St) | 0, u = u + Math.imul(at, _t) | 0, g = g + Math.imul(at, St) | 0, m = m + Math.imul(Q, Pt) | 0, u = u + Math.imul(Q, Ut) | 0, u = u + Math.imul(j, Pt) | 0, g = g + Math.imul(j, Ut) | 0, m = m + Math.imul(C, Bt) | 0, u = u + Math.imul(C, Ct) | 0, u = u + Math.imul(D, Bt) | 0, g = g + Math.imul(D, Ct) | 0;
      var Ur = (M + m | 0) + ((u & 8191) << 13) | 0;
      M = (g + (u >>> 13) | 0) + (Ur >>> 26) | 0, Ur &= 67108863, m = Math.imul(gt, Tt), u = Math.imul(gt, xt), u = u + Math.imul(wt, Tt) | 0, g = Math.imul(wt, xt), m = m + Math.imul(mt, Mt) | 0, u = u + Math.imul(mt, Et) | 0, u = u + Math.imul(yt, Mt) | 0, g = g + Math.imul(yt, Et) | 0, m = m + Math.imul(pt, Nt) | 0, u = u + Math.imul(pt, At) | 0, u = u + Math.imul(ht, Nt) | 0, g = g + Math.imul(ht, At) | 0, m = m + Math.imul(ct, It) | 0, u = u + Math.imul(ct, Rt) | 0, u = u + Math.imul(dt, It) | 0, g = g + Math.imul(dt, Rt) | 0, m = m + Math.imul(lt, kt) | 0, u = u + Math.imul(lt, Ot) | 0, u = u + Math.imul(ft, kt) | 0, g = g + Math.imul(ft, Ot) | 0, m = m + Math.imul(ot, _t) | 0, u = u + Math.imul(ot, St) | 0, u = u + Math.imul(ut, _t) | 0, g = g + Math.imul(ut, St) | 0, m = m + Math.imul(st, Pt) | 0, u = u + Math.imul(st, Ut) | 0, u = u + Math.imul(at, Pt) | 0, g = g + Math.imul(at, Ut) | 0, m = m + Math.imul(Q, Bt) | 0, u = u + Math.imul(Q, Ct) | 0, u = u + Math.imul(j, Bt) | 0, g = g + Math.imul(j, Ct) | 0, m = m + Math.imul(C, Ft) | 0, u = u + Math.imul(C, Lt) | 0, u = u + Math.imul(D, Ft) | 0, g = g + Math.imul(D, Lt) | 0;
      var Br = (M + m | 0) + ((u & 8191) << 13) | 0;
      M = (g + (u >>> 13) | 0) + (Br >>> 26) | 0, Br &= 67108863, m = Math.imul(bt, Tt), u = Math.imul(bt, xt), u = u + Math.imul(vt, Tt) | 0, g = Math.imul(vt, xt), m = m + Math.imul(gt, Mt) | 0, u = u + Math.imul(gt, Et) | 0, u = u + Math.imul(wt, Mt) | 0, g = g + Math.imul(wt, Et) | 0, m = m + Math.imul(mt, Nt) | 0, u = u + Math.imul(mt, At) | 0, u = u + Math.imul(yt, Nt) | 0, g = g + Math.imul(yt, At) | 0, m = m + Math.imul(pt, It) | 0, u = u + Math.imul(pt, Rt) | 0, u = u + Math.imul(ht, It) | 0, g = g + Math.imul(ht, Rt) | 0, m = m + Math.imul(ct, kt) | 0, u = u + Math.imul(ct, Ot) | 0, u = u + Math.imul(dt, kt) | 0, g = g + Math.imul(dt, Ot) | 0, m = m + Math.imul(lt, _t) | 0, u = u + Math.imul(lt, St) | 0, u = u + Math.imul(ft, _t) | 0, g = g + Math.imul(ft, St) | 0, m = m + Math.imul(ot, Pt) | 0, u = u + Math.imul(ot, Ut) | 0, u = u + Math.imul(ut, Pt) | 0, g = g + Math.imul(ut, Ut) | 0, m = m + Math.imul(st, Bt) | 0, u = u + Math.imul(st, Ct) | 0, u = u + Math.imul(at, Bt) | 0, g = g + Math.imul(at, Ct) | 0, m = m + Math.imul(Q, Ft) | 0, u = u + Math.imul(Q, Lt) | 0, u = u + Math.imul(j, Ft) | 0, g = g + Math.imul(j, Lt) | 0, m = m + Math.imul(C, Dt) | 0, u = u + Math.imul(C, $t) | 0, u = u + Math.imul(D, Dt) | 0, g = g + Math.imul(D, $t) | 0;
      var Cr = (M + m | 0) + ((u & 8191) << 13) | 0;
      M = (g + (u >>> 13) | 0) + (Cr >>> 26) | 0, Cr &= 67108863, m = Math.imul(bt, Mt), u = Math.imul(bt, Et), u = u + Math.imul(vt, Mt) | 0, g = Math.imul(vt, Et), m = m + Math.imul(gt, Nt) | 0, u = u + Math.imul(gt, At) | 0, u = u + Math.imul(wt, Nt) | 0, g = g + Math.imul(wt, At) | 0, m = m + Math.imul(mt, It) | 0, u = u + Math.imul(mt, Rt) | 0, u = u + Math.imul(yt, It) | 0, g = g + Math.imul(yt, Rt) | 0, m = m + Math.imul(pt, kt) | 0, u = u + Math.imul(pt, Ot) | 0, u = u + Math.imul(ht, kt) | 0, g = g + Math.imul(ht, Ot) | 0, m = m + Math.imul(ct, _t) | 0, u = u + Math.imul(ct, St) | 0, u = u + Math.imul(dt, _t) | 0, g = g + Math.imul(dt, St) | 0, m = m + Math.imul(lt, Pt) | 0, u = u + Math.imul(lt, Ut) | 0, u = u + Math.imul(ft, Pt) | 0, g = g + Math.imul(ft, Ut) | 0, m = m + Math.imul(ot, Bt) | 0, u = u + Math.imul(ot, Ct) | 0, u = u + Math.imul(ut, Bt) | 0, g = g + Math.imul(ut, Ct) | 0, m = m + Math.imul(st, Ft) | 0, u = u + Math.imul(st, Lt) | 0, u = u + Math.imul(at, Ft) | 0, g = g + Math.imul(at, Lt) | 0, m = m + Math.imul(Q, Dt) | 0, u = u + Math.imul(Q, $t) | 0, u = u + Math.imul(j, Dt) | 0, g = g + Math.imul(j, $t) | 0;
      var Fr = (M + m | 0) + ((u & 8191) << 13) | 0;
      M = (g + (u >>> 13) | 0) + (Fr >>> 26) | 0, Fr &= 67108863, m = Math.imul(bt, Nt), u = Math.imul(bt, At), u = u + Math.imul(vt, Nt) | 0, g = Math.imul(vt, At), m = m + Math.imul(gt, It) | 0, u = u + Math.imul(gt, Rt) | 0, u = u + Math.imul(wt, It) | 0, g = g + Math.imul(wt, Rt) | 0, m = m + Math.imul(mt, kt) | 0, u = u + Math.imul(mt, Ot) | 0, u = u + Math.imul(yt, kt) | 0, g = g + Math.imul(yt, Ot) | 0, m = m + Math.imul(pt, _t) | 0, u = u + Math.imul(pt, St) | 0, u = u + Math.imul(ht, _t) | 0, g = g + Math.imul(ht, St) | 0, m = m + Math.imul(ct, Pt) | 0, u = u + Math.imul(ct, Ut) | 0, u = u + Math.imul(dt, Pt) | 0, g = g + Math.imul(dt, Ut) | 0, m = m + Math.imul(lt, Bt) | 0, u = u + Math.imul(lt, Ct) | 0, u = u + Math.imul(ft, Bt) | 0, g = g + Math.imul(ft, Ct) | 0, m = m + Math.imul(ot, Ft) | 0, u = u + Math.imul(ot, Lt) | 0, u = u + Math.imul(ut, Ft) | 0, g = g + Math.imul(ut, Lt) | 0, m = m + Math.imul(st, Dt) | 0, u = u + Math.imul(st, $t) | 0, u = u + Math.imul(at, Dt) | 0, g = g + Math.imul(at, $t) | 0;
      var Lr = (M + m | 0) + ((u & 8191) << 13) | 0;
      M = (g + (u >>> 13) | 0) + (Lr >>> 26) | 0, Lr &= 67108863, m = Math.imul(bt, It), u = Math.imul(bt, Rt), u = u + Math.imul(vt, It) | 0, g = Math.imul(vt, Rt), m = m + Math.imul(gt, kt) | 0, u = u + Math.imul(gt, Ot) | 0, u = u + Math.imul(wt, kt) | 0, g = g + Math.imul(wt, Ot) | 0, m = m + Math.imul(mt, _t) | 0, u = u + Math.imul(mt, St) | 0, u = u + Math.imul(yt, _t) | 0, g = g + Math.imul(yt, St) | 0, m = m + Math.imul(pt, Pt) | 0, u = u + Math.imul(pt, Ut) | 0, u = u + Math.imul(ht, Pt) | 0, g = g + Math.imul(ht, Ut) | 0, m = m + Math.imul(ct, Bt) | 0, u = u + Math.imul(ct, Ct) | 0, u = u + Math.imul(dt, Bt) | 0, g = g + Math.imul(dt, Ct) | 0, m = m + Math.imul(lt, Ft) | 0, u = u + Math.imul(lt, Lt) | 0, u = u + Math.imul(ft, Ft) | 0, g = g + Math.imul(ft, Lt) | 0, m = m + Math.imul(ot, Dt) | 0, u = u + Math.imul(ot, $t) | 0, u = u + Math.imul(ut, Dt) | 0, g = g + Math.imul(ut, $t) | 0;
      var Dr = (M + m | 0) + ((u & 8191) << 13) | 0;
      M = (g + (u >>> 13) | 0) + (Dr >>> 26) | 0, Dr &= 67108863, m = Math.imul(bt, kt), u = Math.imul(bt, Ot), u = u + Math.imul(vt, kt) | 0, g = Math.imul(vt, Ot), m = m + Math.imul(gt, _t) | 0, u = u + Math.imul(gt, St) | 0, u = u + Math.imul(wt, _t) | 0, g = g + Math.imul(wt, St) | 0, m = m + Math.imul(mt, Pt) | 0, u = u + Math.imul(mt, Ut) | 0, u = u + Math.imul(yt, Pt) | 0, g = g + Math.imul(yt, Ut) | 0, m = m + Math.imul(pt, Bt) | 0, u = u + Math.imul(pt, Ct) | 0, u = u + Math.imul(ht, Bt) | 0, g = g + Math.imul(ht, Ct) | 0, m = m + Math.imul(ct, Ft) | 0, u = u + Math.imul(ct, Lt) | 0, u = u + Math.imul(dt, Ft) | 0, g = g + Math.imul(dt, Lt) | 0, m = m + Math.imul(lt, Dt) | 0, u = u + Math.imul(lt, $t) | 0, u = u + Math.imul(ft, Dt) | 0, g = g + Math.imul(ft, $t) | 0;
      var $r = (M + m | 0) + ((u & 8191) << 13) | 0;
      M = (g + (u >>> 13) | 0) + ($r >>> 26) | 0, $r &= 67108863, m = Math.imul(bt, _t), u = Math.imul(bt, St), u = u + Math.imul(vt, _t) | 0, g = Math.imul(vt, St), m = m + Math.imul(gt, Pt) | 0, u = u + Math.imul(gt, Ut) | 0, u = u + Math.imul(wt, Pt) | 0, g = g + Math.imul(wt, Ut) | 0, m = m + Math.imul(mt, Bt) | 0, u = u + Math.imul(mt, Ct) | 0, u = u + Math.imul(yt, Bt) | 0, g = g + Math.imul(yt, Ct) | 0, m = m + Math.imul(pt, Ft) | 0, u = u + Math.imul(pt, Lt) | 0, u = u + Math.imul(ht, Ft) | 0, g = g + Math.imul(ht, Lt) | 0, m = m + Math.imul(ct, Dt) | 0, u = u + Math.imul(ct, $t) | 0, u = u + Math.imul(dt, Dt) | 0, g = g + Math.imul(dt, $t) | 0;
      var Gr = (M + m | 0) + ((u & 8191) << 13) | 0;
      M = (g + (u >>> 13) | 0) + (Gr >>> 26) | 0, Gr &= 67108863, m = Math.imul(bt, Pt), u = Math.imul(bt, Ut), u = u + Math.imul(vt, Pt) | 0, g = Math.imul(vt, Ut), m = m + Math.imul(gt, Bt) | 0, u = u + Math.imul(gt, Ct) | 0, u = u + Math.imul(wt, Bt) | 0, g = g + Math.imul(wt, Ct) | 0, m = m + Math.imul(mt, Ft) | 0, u = u + Math.imul(mt, Lt) | 0, u = u + Math.imul(yt, Ft) | 0, g = g + Math.imul(yt, Lt) | 0, m = m + Math.imul(pt, Dt) | 0, u = u + Math.imul(pt, $t) | 0, u = u + Math.imul(ht, Dt) | 0, g = g + Math.imul(ht, $t) | 0;
      var Hr = (M + m | 0) + ((u & 8191) << 13) | 0;
      M = (g + (u >>> 13) | 0) + (Hr >>> 26) | 0, Hr &= 67108863, m = Math.imul(bt, Bt), u = Math.imul(bt, Ct), u = u + Math.imul(vt, Bt) | 0, g = Math.imul(vt, Ct), m = m + Math.imul(gt, Ft) | 0, u = u + Math.imul(gt, Lt) | 0, u = u + Math.imul(wt, Ft) | 0, g = g + Math.imul(wt, Lt) | 0, m = m + Math.imul(mt, Dt) | 0, u = u + Math.imul(mt, $t) | 0, u = u + Math.imul(yt, Dt) | 0, g = g + Math.imul(yt, $t) | 0;
      var Vr = (M + m | 0) + ((u & 8191) << 13) | 0;
      M = (g + (u >>> 13) | 0) + (Vr >>> 26) | 0, Vr &= 67108863, m = Math.imul(bt, Ft), u = Math.imul(bt, Lt), u = u + Math.imul(vt, Ft) | 0, g = Math.imul(vt, Lt), m = m + Math.imul(gt, Dt) | 0, u = u + Math.imul(gt, $t) | 0, u = u + Math.imul(wt, Dt) | 0, g = g + Math.imul(wt, $t) | 0;
      var zr = (M + m | 0) + ((u & 8191) << 13) | 0;
      M = (g + (u >>> 13) | 0) + (zr >>> 26) | 0, zr &= 67108863, m = Math.imul(bt, Dt), u = Math.imul(bt, $t), u = u + Math.imul(vt, Dt) | 0, g = Math.imul(vt, $t);
      var qr = (M + m | 0) + ((u & 8191) << 13) | 0;
      return M = (g + (u >>> 13) | 0) + (qr >>> 26) | 0, qr &= 67108863, T[0] = Ir, T[1] = Rr, T[2] = kr, T[3] = Or, T[4] = _r, T[5] = Sr, T[6] = Pr, T[7] = Ur, T[8] = Br, T[9] = Cr, T[10] = Fr, T[11] = Lr, T[12] = Dr, T[13] = $r, T[14] = Gr, T[15] = Hr, T[16] = Vr, T[17] = zr, T[18] = qr, M !== 0 && (T[19] = M, p.length++), p;
    };
    Math.imul || (J = U);
    function H(b, a, l) {
      l.negative = a.negative ^ b.negative, l.length = b.length + a.length;
      for (var p = 0, y = 0, w = 0; w < l.length - 1; w++) {
        var T = y;
        y = 0;
        for (var M = p & 67108863, m = Math.min(w, a.length - 1), u = Math.max(0, w - b.length + 1); u <= m; u++) {
          var g = w - u, L = b.words[g] | 0, C = a.words[u] | 0, D = L * C, Kt = D & 67108863;
          T = T + (D / 67108864 | 0) | 0, Kt = Kt + M | 0, M = Kt & 67108863, T = T + (Kt >>> 26) | 0, y += T >>> 26, T &= 67108863;
        }
        l.words[w] = M, p = T, T = y;
      }
      return p !== 0 ? l.words[w] = p : l.length--, l._strip();
    }
    function it(b, a, l) {
      return H(b, a, l);
    }
    s.prototype.mulTo = function(a, l) {
      var p, y = this.length + a.length;
      return this.length === 10 && a.length === 10 ? p = J(this, a, l) : y < 63 ? p = U(this, a, l) : y < 1024 ? p = H(this, a, l) : p = it(this, a, l), p;
    }, s.prototype.mul = function(a) {
      var l = new s(null);
      return l.words = new Array(this.length + a.length), this.mulTo(a, l);
    }, s.prototype.mulf = function(a) {
      var l = new s(null);
      return l.words = new Array(this.length + a.length), it(this, a, l);
    }, s.prototype.imul = function(a) {
      return this.clone().mulTo(a, this);
    }, s.prototype.imuln = function(a) {
      var l = a < 0;
      l && (a = -a), r(typeof a == "number"), r(a < 67108864);
      for (var p = 0, y = 0; y < this.length; y++) {
        var w = (this.words[y] | 0) * a, T = (w & 67108863) + (p & 67108863);
        p >>= 26, p += w / 67108864 | 0, p += T >>> 26, this.words[y] = T & 67108863;
      }
      return p !== 0 && (this.words[y] = p, this.length++), l ? this.ineg() : this;
    }, s.prototype.muln = function(a) {
      return this.clone().imuln(a);
    }, s.prototype.sqr = function() {
      return this.mul(this);
    }, s.prototype.isqr = function() {
      return this.imul(this.clone());
    }, s.prototype.pow = function(a) {
      var l = G(a);
      if (l.length === 0) return new s(1);
      for (var p = this, y = 0; y < l.length && l[y] === 0; y++, p = p.sqr())
        ;
      if (++y < l.length)
        for (var w = p.sqr(); y < l.length; y++, w = w.sqr())
          l[y] !== 0 && (p = p.mul(w));
      return p;
    }, s.prototype.iushln = function(a) {
      r(typeof a == "number" && a >= 0);
      var l = a % 26, p = (a - l) / 26, y = 67108863 >>> 26 - l << 26 - l, w;
      if (l !== 0) {
        var T = 0;
        for (w = 0; w < this.length; w++) {
          var M = this.words[w] & y, m = (this.words[w] | 0) - M << l;
          this.words[w] = m | T, T = M >>> 26 - l;
        }
        T && (this.words[w] = T, this.length++);
      }
      if (p !== 0) {
        for (w = this.length - 1; w >= 0; w--)
          this.words[w + p] = this.words[w];
        for (w = 0; w < p; w++)
          this.words[w] = 0;
        this.length += p;
      }
      return this._strip();
    }, s.prototype.ishln = function(a) {
      return r(this.negative === 0), this.iushln(a);
    }, s.prototype.iushrn = function(a, l, p) {
      r(typeof a == "number" && a >= 0);
      var y;
      l ? y = (l - l % 26) / 26 : y = 0;
      var w = a % 26, T = Math.min((a - w) / 26, this.length), M = 67108863 ^ 67108863 >>> w << w, m = p;
      if (y -= T, y = Math.max(0, y), m) {
        for (var u = 0; u < T; u++)
          m.words[u] = this.words[u];
        m.length = T;
      }
      if (T !== 0) if (this.length > T)
        for (this.length -= T, u = 0; u < this.length; u++)
          this.words[u] = this.words[u + T];
      else
        this.words[0] = 0, this.length = 1;
      var g = 0;
      for (u = this.length - 1; u >= 0 && (g !== 0 || u >= y); u--) {
        var L = this.words[u] | 0;
        this.words[u] = g << 26 - w | L >>> w, g = L & M;
      }
      return m && g !== 0 && (m.words[m.length++] = g), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, s.prototype.ishrn = function(a, l, p) {
      return r(this.negative === 0), this.iushrn(a, l, p);
    }, s.prototype.shln = function(a) {
      return this.clone().ishln(a);
    }, s.prototype.ushln = function(a) {
      return this.clone().iushln(a);
    }, s.prototype.shrn = function(a) {
      return this.clone().ishrn(a);
    }, s.prototype.ushrn = function(a) {
      return this.clone().iushrn(a);
    }, s.prototype.testn = function(a) {
      r(typeof a == "number" && a >= 0);
      var l = a % 26, p = (a - l) / 26, y = 1 << l;
      if (this.length <= p) return !1;
      var w = this.words[p];
      return !!(w & y);
    }, s.prototype.imaskn = function(a) {
      r(typeof a == "number" && a >= 0);
      var l = a % 26, p = (a - l) / 26;
      if (r(this.negative === 0, "imaskn works only with positive numbers"), this.length <= p)
        return this;
      if (l !== 0 && p++, this.length = Math.min(p, this.length), l !== 0) {
        var y = 67108863 ^ 67108863 >>> l << l;
        this.words[this.length - 1] &= y;
      }
      return this._strip();
    }, s.prototype.maskn = function(a) {
      return this.clone().imaskn(a);
    }, s.prototype.iaddn = function(a) {
      return r(typeof a == "number"), r(a < 67108864), a < 0 ? this.isubn(-a) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= a ? (this.words[0] = a - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(a), this.negative = 1, this) : this._iaddn(a);
    }, s.prototype._iaddn = function(a) {
      this.words[0] += a;
      for (var l = 0; l < this.length && this.words[l] >= 67108864; l++)
        this.words[l] -= 67108864, l === this.length - 1 ? this.words[l + 1] = 1 : this.words[l + 1]++;
      return this.length = Math.max(this.length, l + 1), this;
    }, s.prototype.isubn = function(a) {
      if (r(typeof a == "number"), r(a < 67108864), a < 0) return this.iaddn(-a);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(a), this.negative = 1, this;
      if (this.words[0] -= a, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var l = 0; l < this.length && this.words[l] < 0; l++)
          this.words[l] += 67108864, this.words[l + 1] -= 1;
      return this._strip();
    }, s.prototype.addn = function(a) {
      return this.clone().iaddn(a);
    }, s.prototype.subn = function(a) {
      return this.clone().isubn(a);
    }, s.prototype.iabs = function() {
      return this.negative = 0, this;
    }, s.prototype.abs = function() {
      return this.clone().iabs();
    }, s.prototype._ishlnsubmul = function(a, l, p) {
      var y = a.length + p, w;
      this._expand(y);
      var T, M = 0;
      for (w = 0; w < a.length; w++) {
        T = (this.words[w + p] | 0) + M;
        var m = (a.words[w] | 0) * l;
        T -= m & 67108863, M = (T >> 26) - (m / 67108864 | 0), this.words[w + p] = T & 67108863;
      }
      for (; w < this.length - p; w++)
        T = (this.words[w + p] | 0) + M, M = T >> 26, this.words[w + p] = T & 67108863;
      if (M === 0) return this._strip();
      for (r(M === -1), M = 0, w = 0; w < this.length; w++)
        T = -(this.words[w] | 0) + M, M = T >> 26, this.words[w] = T & 67108863;
      return this.negative = 1, this._strip();
    }, s.prototype._wordDiv = function(a, l) {
      var p = this.length - a.length, y = this.clone(), w = a, T = w.words[w.length - 1] | 0, M = this._countBits(T);
      p = 26 - M, p !== 0 && (w = w.ushln(p), y.iushln(p), T = w.words[w.length - 1] | 0);
      var m = y.length - w.length, u;
      if (l !== "mod") {
        u = new s(null), u.length = m + 1, u.words = new Array(u.length);
        for (var g = 0; g < u.length; g++)
          u.words[g] = 0;
      }
      var L = y.clone()._ishlnsubmul(w, 1, m);
      L.negative === 0 && (y = L, u && (u.words[m] = 1));
      for (var C = m - 1; C >= 0; C--) {
        var D = (y.words[w.length + C] | 0) * 67108864 + (y.words[w.length + C - 1] | 0);
        for (D = Math.min(D / T | 0, 67108863), y._ishlnsubmul(w, D, C); y.negative !== 0; )
          D--, y.negative = 0, y._ishlnsubmul(w, 1, C), y.isZero() || (y.negative ^= 1);
        u && (u.words[C] = D);
      }
      return u && u._strip(), y._strip(), l !== "div" && p !== 0 && y.iushrn(p), {
        div: u || null,
        mod: y
      };
    }, s.prototype.divmod = function(a, l, p) {
      if (r(!a.isZero()), this.isZero())
        return {
          div: new s(0),
          mod: new s(0)
        };
      var y, w, T;
      return this.negative !== 0 && a.negative === 0 ? (T = this.neg().divmod(a, l), l !== "mod" && (y = T.div.neg()), l !== "div" && (w = T.mod.neg(), p && w.negative !== 0 && w.iadd(a)), {
        div: y,
        mod: w
      }) : this.negative === 0 && a.negative !== 0 ? (T = this.divmod(a.neg(), l), l !== "mod" && (y = T.div.neg()), {
        div: y,
        mod: T.mod
      }) : this.negative & a.negative ? (T = this.neg().divmod(a.neg(), l), l !== "div" && (w = T.mod.neg(), p && w.negative !== 0 && w.isub(a)), {
        div: T.div,
        mod: w
      }) : a.length > this.length || this.cmp(a) < 0 ? {
        div: new s(0),
        mod: this
      } : a.length === 1 ? l === "div" ? {
        div: this.divn(a.words[0]),
        mod: null
      } : l === "mod" ? {
        div: null,
        mod: new s(this.modrn(a.words[0]))
      } : {
        div: this.divn(a.words[0]),
        mod: new s(this.modrn(a.words[0]))
      } : this._wordDiv(a, l);
    }, s.prototype.div = function(a) {
      return this.divmod(a, "div", !1).div;
    }, s.prototype.mod = function(a) {
      return this.divmod(a, "mod", !1).mod;
    }, s.prototype.umod = function(a) {
      return this.divmod(a, "mod", !0).mod;
    }, s.prototype.divRound = function(a) {
      var l = this.divmod(a);
      if (l.mod.isZero()) return l.div;
      var p = l.div.negative !== 0 ? l.mod.isub(a) : l.mod, y = a.ushrn(1), w = a.andln(1), T = p.cmp(y);
      return T < 0 || w === 1 && T === 0 ? l.div : l.div.negative !== 0 ? l.div.isubn(1) : l.div.iaddn(1);
    }, s.prototype.modrn = function(a) {
      var l = a < 0;
      l && (a = -a), r(a <= 67108863);
      for (var p = (1 << 26) % a, y = 0, w = this.length - 1; w >= 0; w--)
        y = (p * y + (this.words[w] | 0)) % a;
      return l ? -y : y;
    }, s.prototype.modn = function(a) {
      return this.modrn(a);
    }, s.prototype.idivn = function(a) {
      var l = a < 0;
      l && (a = -a), r(a <= 67108863);
      for (var p = 0, y = this.length - 1; y >= 0; y--) {
        var w = (this.words[y] | 0) + p * 67108864;
        this.words[y] = w / a | 0, p = w % a;
      }
      return this._strip(), l ? this.ineg() : this;
    }, s.prototype.divn = function(a) {
      return this.clone().idivn(a);
    }, s.prototype.egcd = function(a) {
      r(a.negative === 0), r(!a.isZero());
      var l = this, p = a.clone();
      l.negative !== 0 ? l = l.umod(a) : l = l.clone();
      for (var y = new s(1), w = new s(0), T = new s(0), M = new s(1), m = 0; l.isEven() && p.isEven(); )
        l.iushrn(1), p.iushrn(1), ++m;
      for (var u = p.clone(), g = l.clone(); !l.isZero(); ) {
        for (var L = 0, C = 1; !(l.words[0] & C) && L < 26; ++L, C <<= 1) ;
        if (L > 0)
          for (l.iushrn(L); L-- > 0; )
            (y.isOdd() || w.isOdd()) && (y.iadd(u), w.isub(g)), y.iushrn(1), w.iushrn(1);
        for (var D = 0, Kt = 1; !(p.words[0] & Kt) && D < 26; ++D, Kt <<= 1) ;
        if (D > 0)
          for (p.iushrn(D); D-- > 0; )
            (T.isOdd() || M.isOdd()) && (T.iadd(u), M.isub(g)), T.iushrn(1), M.iushrn(1);
        l.cmp(p) >= 0 ? (l.isub(p), y.isub(T), w.isub(M)) : (p.isub(l), T.isub(y), M.isub(w));
      }
      return {
        a: T,
        b: M,
        gcd: p.iushln(m)
      };
    }, s.prototype._invmp = function(a) {
      r(a.negative === 0), r(!a.isZero());
      var l = this, p = a.clone();
      l.negative !== 0 ? l = l.umod(a) : l = l.clone();
      for (var y = new s(1), w = new s(0), T = p.clone(); l.cmpn(1) > 0 && p.cmpn(1) > 0; ) {
        for (var M = 0, m = 1; !(l.words[0] & m) && M < 26; ++M, m <<= 1) ;
        if (M > 0)
          for (l.iushrn(M); M-- > 0; )
            y.isOdd() && y.iadd(T), y.iushrn(1);
        for (var u = 0, g = 1; !(p.words[0] & g) && u < 26; ++u, g <<= 1) ;
        if (u > 0)
          for (p.iushrn(u); u-- > 0; )
            w.isOdd() && w.iadd(T), w.iushrn(1);
        l.cmp(p) >= 0 ? (l.isub(p), y.isub(w)) : (p.isub(l), w.isub(y));
      }
      var L;
      return l.cmpn(1) === 0 ? L = y : L = w, L.cmpn(0) < 0 && L.iadd(a), L;
    }, s.prototype.gcd = function(a) {
      if (this.isZero()) return a.abs();
      if (a.isZero()) return this.abs();
      var l = this.clone(), p = a.clone();
      l.negative = 0, p.negative = 0;
      for (var y = 0; l.isEven() && p.isEven(); y++)
        l.iushrn(1), p.iushrn(1);
      do {
        for (; l.isEven(); )
          l.iushrn(1);
        for (; p.isEven(); )
          p.iushrn(1);
        var w = l.cmp(p);
        if (w < 0) {
          var T = l;
          l = p, p = T;
        } else if (w === 0 || p.cmpn(1) === 0)
          break;
        l.isub(p);
      } while (!0);
      return p.iushln(y);
    }, s.prototype.invm = function(a) {
      return this.egcd(a).a.umod(a);
    }, s.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, s.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, s.prototype.andln = function(a) {
      return this.words[0] & a;
    }, s.prototype.bincn = function(a) {
      r(typeof a == "number");
      var l = a % 26, p = (a - l) / 26, y = 1 << l;
      if (this.length <= p)
        return this._expand(p + 1), this.words[p] |= y, this;
      for (var w = y, T = p; w !== 0 && T < this.length; T++) {
        var M = this.words[T] | 0;
        M += w, w = M >>> 26, M &= 67108863, this.words[T] = M;
      }
      return w !== 0 && (this.words[T] = w, this.length++), this;
    }, s.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, s.prototype.cmpn = function(a) {
      var l = a < 0;
      if (this.negative !== 0 && !l) return -1;
      if (this.negative === 0 && l) return 1;
      this._strip();
      var p;
      if (this.length > 1)
        p = 1;
      else {
        l && (a = -a), r(a <= 67108863, "Number is too big");
        var y = this.words[0] | 0;
        p = y === a ? 0 : y < a ? -1 : 1;
      }
      return this.negative !== 0 ? -p | 0 : p;
    }, s.prototype.cmp = function(a) {
      if (this.negative !== 0 && a.negative === 0) return -1;
      if (this.negative === 0 && a.negative !== 0) return 1;
      var l = this.ucmp(a);
      return this.negative !== 0 ? -l | 0 : l;
    }, s.prototype.ucmp = function(a) {
      if (this.length > a.length) return 1;
      if (this.length < a.length) return -1;
      for (var l = 0, p = this.length - 1; p >= 0; p--) {
        var y = this.words[p] | 0, w = a.words[p] | 0;
        if (y !== w) {
          y < w ? l = -1 : y > w && (l = 1);
          break;
        }
      }
      return l;
    }, s.prototype.gtn = function(a) {
      return this.cmpn(a) === 1;
    }, s.prototype.gt = function(a) {
      return this.cmp(a) === 1;
    }, s.prototype.gten = function(a) {
      return this.cmpn(a) >= 0;
    }, s.prototype.gte = function(a) {
      return this.cmp(a) >= 0;
    }, s.prototype.ltn = function(a) {
      return this.cmpn(a) === -1;
    }, s.prototype.lt = function(a) {
      return this.cmp(a) === -1;
    }, s.prototype.lten = function(a) {
      return this.cmpn(a) <= 0;
    }, s.prototype.lte = function(a) {
      return this.cmp(a) <= 0;
    }, s.prototype.eqn = function(a) {
      return this.cmpn(a) === 0;
    }, s.prototype.eq = function(a) {
      return this.cmp(a) === 0;
    }, s.red = function(a) {
      return new Z(a);
    }, s.prototype.toRed = function(a) {
      return r(!this.red, "Already a number in reduction context"), r(this.negative === 0, "red works only with positives"), a.convertTo(this)._forceRed(a);
    }, s.prototype.fromRed = function() {
      return r(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, s.prototype._forceRed = function(a) {
      return this.red = a, this;
    }, s.prototype.forceRed = function(a) {
      return r(!this.red, "Already a number in reduction context"), this._forceRed(a);
    }, s.prototype.redAdd = function(a) {
      return r(this.red, "redAdd works only with red numbers"), this.red.add(this, a);
    }, s.prototype.redIAdd = function(a) {
      return r(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, a);
    }, s.prototype.redSub = function(a) {
      return r(this.red, "redSub works only with red numbers"), this.red.sub(this, a);
    }, s.prototype.redISub = function(a) {
      return r(this.red, "redISub works only with red numbers"), this.red.isub(this, a);
    }, s.prototype.redShl = function(a) {
      return r(this.red, "redShl works only with red numbers"), this.red.shl(this, a);
    }, s.prototype.redMul = function(a) {
      return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, a), this.red.mul(this, a);
    }, s.prototype.redIMul = function(a) {
      return r(this.red, "redMul works only with red numbers"), this.red._verify2(this, a), this.red.imul(this, a);
    }, s.prototype.redSqr = function() {
      return r(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, s.prototype.redISqr = function() {
      return r(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, s.prototype.redSqrt = function() {
      return r(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, s.prototype.redInvm = function() {
      return r(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, s.prototype.redNeg = function() {
      return r(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, s.prototype.redPow = function(a) {
      return r(this.red && !a.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, a);
    };
    var $e = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function nt(b, a) {
      this.name = b, this.p = new s(a, 16), this.n = this.p.bitLength(), this.k = new s(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    nt.prototype._tmp = function() {
      var a = new s(null);
      return a.words = new Array(Math.ceil(this.n / 13)), a;
    }, nt.prototype.ireduce = function(a) {
      var l = a, p;
      do
        this.split(l, this.tmp), l = this.imulK(l), l = l.iadd(this.tmp), p = l.bitLength();
      while (p > this.n);
      var y = p < this.n ? -1 : l.ucmp(this.p);
      return y === 0 ? (l.words[0] = 0, l.length = 1) : y > 0 ? l.isub(this.p) : l.strip !== void 0 ? l.strip() : l._strip(), l;
    }, nt.prototype.split = function(a, l) {
      a.iushrn(this.n, 0, l);
    }, nt.prototype.imulK = function(a) {
      return a.imul(this.k);
    };
    function Ge() {
      nt.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    i(Ge, nt), Ge.prototype.split = function(a, l) {
      for (var p = 4194303, y = Math.min(a.length, 9), w = 0; w < y; w++)
        l.words[w] = a.words[w];
      if (l.length = y, a.length <= 9) {
        a.words[0] = 0, a.length = 1;
        return;
      }
      var T = a.words[9];
      for (l.words[l.length++] = T & p, w = 10; w < a.length; w++) {
        var M = a.words[w] | 0;
        a.words[w - 10] = (M & p) << 4 | T >>> 22, T = M;
      }
      T >>>= 22, a.words[w - 10] = T, T === 0 && a.length > 10 ? a.length -= 10 : a.length -= 9;
    }, Ge.prototype.imulK = function(a) {
      a.words[a.length] = 0, a.words[a.length + 1] = 0, a.length += 2;
      for (var l = 0, p = 0; p < a.length; p++) {
        var y = a.words[p] | 0;
        l += y * 977, a.words[p] = l & 67108863, l = y * 64 + (l / 67108864 | 0);
      }
      return a.words[a.length - 1] === 0 && (a.length--, a.words[a.length - 1] === 0 && a.length--), a;
    };
    function en() {
      nt.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    i(en, nt);
    function He() {
      nt.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    i(He, nt);
    function nn() {
      nt.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    i(nn, nt), nn.prototype.imulK = function(a) {
      for (var l = 0, p = 0; p < a.length; p++) {
        var y = (a.words[p] | 0) * 19 + l, w = y & 67108863;
        y >>>= 26, a.words[p] = w, l = y;
      }
      return l !== 0 && (a.words[a.length++] = l), a;
    }, s._prime = function(a) {
      if ($e[a]) return $e[a];
      var l;
      if (a === "k256")
        l = new Ge();
      else if (a === "p224")
        l = new en();
      else if (a === "p192")
        l = new He();
      else if (a === "p25519")
        l = new nn();
      else
        throw new Error("Unknown prime " + a);
      return $e[a] = l, l;
    };
    function Z(b) {
      if (typeof b == "string") {
        var a = s._prime(b);
        this.m = a.p, this.prime = a;
      } else
        r(b.gtn(1), "modulus must be greater than 1"), this.m = b, this.prime = null;
    }
    Z.prototype._verify1 = function(a) {
      r(a.negative === 0, "red works only with positives"), r(a.red, "red works only with red numbers");
    }, Z.prototype._verify2 = function(a, l) {
      r((a.negative | l.negative) === 0, "red works only with positives"), r(
        a.red && a.red === l.red,
        "red works only with red numbers"
      );
    }, Z.prototype.imod = function(a) {
      return this.prime ? this.prime.ireduce(a)._forceRed(this) : (h(a, a.umod(this.m)._forceRed(this)), a);
    }, Z.prototype.neg = function(a) {
      return a.isZero() ? a.clone() : this.m.sub(a)._forceRed(this);
    }, Z.prototype.add = function(a, l) {
      this._verify2(a, l);
      var p = a.add(l);
      return p.cmp(this.m) >= 0 && p.isub(this.m), p._forceRed(this);
    }, Z.prototype.iadd = function(a, l) {
      this._verify2(a, l);
      var p = a.iadd(l);
      return p.cmp(this.m) >= 0 && p.isub(this.m), p;
    }, Z.prototype.sub = function(a, l) {
      this._verify2(a, l);
      var p = a.sub(l);
      return p.cmpn(0) < 0 && p.iadd(this.m), p._forceRed(this);
    }, Z.prototype.isub = function(a, l) {
      this._verify2(a, l);
      var p = a.isub(l);
      return p.cmpn(0) < 0 && p.iadd(this.m), p;
    }, Z.prototype.shl = function(a, l) {
      return this._verify1(a), this.imod(a.ushln(l));
    }, Z.prototype.imul = function(a, l) {
      return this._verify2(a, l), this.imod(a.imul(l));
    }, Z.prototype.mul = function(a, l) {
      return this._verify2(a, l), this.imod(a.mul(l));
    }, Z.prototype.isqr = function(a) {
      return this.imul(a, a.clone());
    }, Z.prototype.sqr = function(a) {
      return this.mul(a, a);
    }, Z.prototype.sqrt = function(a) {
      if (a.isZero()) return a.clone();
      var l = this.m.andln(3);
      if (r(l % 2 === 1), l === 3) {
        var p = this.m.add(new s(1)).iushrn(2);
        return this.pow(a, p);
      }
      for (var y = this.m.subn(1), w = 0; !y.isZero() && y.andln(1) === 0; )
        w++, y.iushrn(1);
      r(!y.isZero());
      var T = new s(1).toRed(this), M = T.redNeg(), m = this.m.subn(1).iushrn(1), u = this.m.bitLength();
      for (u = new s(2 * u * u).toRed(this); this.pow(u, m).cmp(M) !== 0; )
        u.redIAdd(M);
      for (var g = this.pow(u, y), L = this.pow(a, y.addn(1).iushrn(1)), C = this.pow(a, y), D = w; C.cmp(T) !== 0; ) {
        for (var Kt = C, Q = 0; Kt.cmp(T) !== 0; Q++)
          Kt = Kt.redSqr();
        r(Q < D);
        var j = this.pow(g, new s(1).iushln(D - Q - 1));
        L = L.redMul(j), g = j.redSqr(), C = C.redMul(g), D = Q;
      }
      return L;
    }, Z.prototype.invm = function(a) {
      var l = a._invmp(this.m);
      return l.negative !== 0 ? (l.negative = 0, this.imod(l).redNeg()) : this.imod(l);
    }, Z.prototype.pow = function(a, l) {
      if (l.isZero()) return new s(1).toRed(this);
      if (l.cmpn(1) === 0) return a.clone();
      var p = 4, y = new Array(1 << p);
      y[0] = new s(1).toRed(this), y[1] = a;
      for (var w = 2; w < y.length; w++)
        y[w] = this.mul(y[w - 1], a);
      var T = y[0], M = 0, m = 0, u = l.bitLength() % 26;
      for (u === 0 && (u = 26), w = l.length - 1; w >= 0; w--) {
        for (var g = l.words[w], L = u - 1; L >= 0; L--) {
          var C = g >> L & 1;
          if (T !== y[0] && (T = this.sqr(T)), C === 0 && M === 0) {
            m = 0;
            continue;
          }
          M <<= 1, M |= C, m++, !(m !== p && (w !== 0 || L !== 0)) && (T = this.mul(T, y[M]), m = 0, M = 0);
        }
        u = 26;
      }
      return T;
    }, Z.prototype.convertTo = function(a) {
      var l = a.umod(this.m);
      return l === a ? l.clone() : l;
    }, Z.prototype.convertFrom = function(a) {
      var l = a.clone();
      return l.red = null, l;
    }, s.mont = function(a) {
      return new oe(a);
    };
    function oe(b) {
      Z.call(this, b), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new s(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    i(oe, Z), oe.prototype.convertTo = function(a) {
      return this.imod(a.ushln(this.shift));
    }, oe.prototype.convertFrom = function(a) {
      var l = this.imod(a.mul(this.rinv));
      return l.red = null, l;
    }, oe.prototype.imul = function(a, l) {
      if (a.isZero() || l.isZero())
        return a.words[0] = 0, a.length = 1, a;
      var p = a.imul(l), y = p.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), w = p.isub(y).iushrn(this.shift), T = w;
      return w.cmp(this.m) >= 0 ? T = w.isub(this.m) : w.cmpn(0) < 0 && (T = w.iadd(this.m)), T._forceRed(this);
    }, oe.prototype.mul = function(a, l) {
      if (a.isZero() || l.isZero()) return new s(0)._forceRed(this);
      var p = a.mul(l), y = p.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), w = p.isub(y).iushrn(this.shift), T = w;
      return w.cmp(this.m) >= 0 ? T = w.isub(this.m) : w.cmpn(0) < 0 && (T = w.iadd(this.m)), T._forceRed(this);
    }, oe.prototype.invm = function(a) {
      var l = this.imod(a._invmp(this.m).mul(this.r2));
      return l._forceRed(this);
    };
  })(n, Ja);
})(bi);
var no = bi.exports;
const ro = /* @__PURE__ */ Xa(no), io = "logger/5.7.0";
let Ji = !1, Xi = !1;
const er = { debug: 1, default: 2, info: 2, warning: 3, error: 4, off: 5 };
let Yi = er.default, Kr = null;
function so() {
  try {
    const n = [];
    if (["NFD", "NFC", "NFKD", "NFKC"].forEach((t) => {
      try {
        if ("test".normalize(t) !== "test")
          throw new Error("bad normalize");
      } catch {
        n.push(t);
      }
    }), n.length)
      throw new Error("missing " + n.join(", "));
    if ("é".normalize("NFD") !== "é")
      throw new Error("broken implementation");
  } catch (n) {
    return n.message;
  }
  return null;
}
const Qi = so();
var ti;
(function(n) {
  n.DEBUG = "DEBUG", n.INFO = "INFO", n.WARNING = "WARNING", n.ERROR = "ERROR", n.OFF = "OFF";
})(ti || (ti = {}));
var ce;
(function(n) {
  n.UNKNOWN_ERROR = "UNKNOWN_ERROR", n.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", n.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", n.NETWORK_ERROR = "NETWORK_ERROR", n.SERVER_ERROR = "SERVER_ERROR", n.TIMEOUT = "TIMEOUT", n.BUFFER_OVERRUN = "BUFFER_OVERRUN", n.NUMERIC_FAULT = "NUMERIC_FAULT", n.MISSING_NEW = "MISSING_NEW", n.INVALID_ARGUMENT = "INVALID_ARGUMENT", n.MISSING_ARGUMENT = "MISSING_ARGUMENT", n.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", n.CALL_EXCEPTION = "CALL_EXCEPTION", n.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", n.NONCE_EXPIRED = "NONCE_EXPIRED", n.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", n.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", n.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", n.ACTION_REJECTED = "ACTION_REJECTED";
})(ce || (ce = {}));
const ji = "0123456789abcdef";
class q {
  constructor(t) {
    Object.defineProperty(this, "version", {
      enumerable: !0,
      value: t,
      writable: !1
    });
  }
  _log(t, e) {
    const r = t.toLowerCase();
    er[r] == null && this.throwArgumentError("invalid log level name", "logLevel", t), !(Yi > er[r]) && console.log.apply(console, e);
  }
  debug(...t) {
    this._log(q.levels.DEBUG, t);
  }
  info(...t) {
    this._log(q.levels.INFO, t);
  }
  warn(...t) {
    this._log(q.levels.WARNING, t);
  }
  makeError(t, e, r) {
    if (Xi)
      return this.makeError("censored error", e, {});
    e || (e = q.errors.UNKNOWN_ERROR), r || (r = {});
    const i = [];
    Object.keys(r).forEach((c) => {
      const d = r[c];
      try {
        if (d instanceof Uint8Array) {
          let h = "";
          for (let v = 0; v < d.length; v++)
            h += ji[d[v] >> 4], h += ji[d[v] & 15];
          i.push(c + "=Uint8Array(0x" + h + ")");
        } else
          i.push(c + "=" + JSON.stringify(d));
      } catch {
        i.push(c + "=" + JSON.stringify(r[c].toString()));
      }
    }), i.push(`code=${e}`), i.push(`version=${this.version}`);
    const s = t;
    let o = "";
    switch (e) {
      case ce.NUMERIC_FAULT: {
        o = "NUMERIC_FAULT";
        const c = t;
        switch (c) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            o += "-" + c;
            break;
          case "negative-power":
          case "negative-width":
            o += "-unsupported";
            break;
          case "unbound-bitwise-result":
            o += "-unbound-result";
            break;
        }
        break;
      }
      case ce.CALL_EXCEPTION:
      case ce.INSUFFICIENT_FUNDS:
      case ce.MISSING_NEW:
      case ce.NONCE_EXPIRED:
      case ce.REPLACEMENT_UNDERPRICED:
      case ce.TRANSACTION_REPLACED:
      case ce.UNPREDICTABLE_GAS_LIMIT:
        o = e;
        break;
    }
    o && (t += " [ See: https://links.ethers.org/v5-errors-" + o + " ]"), i.length && (t += " (" + i.join(", ") + ")");
    const f = new Error(t);
    return f.reason = s, f.code = e, Object.keys(r).forEach(function(c) {
      f[c] = r[c];
    }), f;
  }
  throwError(t, e, r) {
    throw this.makeError(t, e, r);
  }
  throwArgumentError(t, e, r) {
    return this.throwError(t, q.errors.INVALID_ARGUMENT, {
      argument: e,
      value: r
    });
  }
  assert(t, e, r, i) {
    t || this.throwError(e, r, i);
  }
  assertArgument(t, e, r, i) {
    t || this.throwArgumentError(e, r, i);
  }
  checkNormalize(t) {
    Qi && this.throwError("platform missing String.prototype.normalize", q.errors.UNSUPPORTED_OPERATION, {
      operation: "String.prototype.normalize",
      form: Qi
    });
  }
  checkSafeUint53(t, e) {
    typeof t == "number" && (e == null && (e = "value not safe"), (t < 0 || t >= 9007199254740991) && this.throwError(e, q.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "out-of-safe-range",
      value: t
    }), t % 1 && this.throwError(e, q.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "non-integer",
      value: t
    }));
  }
  checkArgumentCount(t, e, r) {
    r ? r = ": " + r : r = "", t < e && this.throwError("missing argument" + r, q.errors.MISSING_ARGUMENT, {
      count: t,
      expectedCount: e
    }), t > e && this.throwError("too many arguments" + r, q.errors.UNEXPECTED_ARGUMENT, {
      count: t,
      expectedCount: e
    });
  }
  checkNew(t, e) {
    (t === Object || t == null) && this.throwError("missing new", q.errors.MISSING_NEW, { name: e.name });
  }
  checkAbstract(t, e) {
    t === e ? this.throwError("cannot instantiate abstract class " + JSON.stringify(e.name) + " directly; use a sub-class", q.errors.UNSUPPORTED_OPERATION, { name: t.name, operation: "new" }) : (t === Object || t == null) && this.throwError("missing new", q.errors.MISSING_NEW, { name: e.name });
  }
  static globalLogger() {
    return Kr || (Kr = new q(io)), Kr;
  }
  static setCensorship(t, e) {
    if (!t && e && this.globalLogger().throwError("cannot permanently disable censorship", q.errors.UNSUPPORTED_OPERATION, {
      operation: "setCensorship"
    }), Ji) {
      if (!t)
        return;
      this.globalLogger().throwError("error censorship permanent", q.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    Xi = !!t, Ji = !!e;
  }
  static setLogLevel(t) {
    const e = er[t.toLowerCase()];
    if (e == null) {
      q.globalLogger().warn("invalid log level - " + t);
      return;
    }
    Yi = e;
  }
  static from(t) {
    return new q(t);
  }
}
q.errors = ce;
q.levels = ti;
const ao = "bytes/5.7.0", We = new q(ao);
function Ds(n) {
  return !!n.toHexString;
}
function nr(n) {
  return n.slice || (n.slice = function() {
    const t = Array.prototype.slice.call(arguments);
    return nr(new Uint8Array(Array.prototype.slice.apply(n, t)));
  }), n;
}
function ts(n) {
  return typeof n == "number" && n == n && n % 1 === 0;
}
function Jn(n) {
  if (n == null)
    return !1;
  if (n.constructor === Uint8Array)
    return !0;
  if (typeof n == "string" || !ts(n.length) || n.length < 0)
    return !1;
  for (let t = 0; t < n.length; t++) {
    const e = n[t];
    if (!ts(e) || e < 0 || e >= 256)
      return !1;
  }
  return !0;
}
function oo(n, t) {
  if (t || (t = {}), typeof n == "number") {
    We.checkSafeUint53(n, "invalid arrayify value");
    const e = [];
    for (; n; )
      e.unshift(n & 255), n = parseInt(String(n / 256));
    return e.length === 0 && e.push(0), nr(new Uint8Array(e));
  }
  if (t.allowMissingPrefix && typeof n == "string" && n.substring(0, 2) !== "0x" && (n = "0x" + n), Ds(n) && (n = n.toHexString()), kn(n)) {
    let e = n.substring(2);
    e.length % 2 && (t.hexPad === "left" ? e = "0" + e : t.hexPad === "right" ? e += "0" : We.throwArgumentError("hex data is odd-length", "value", n));
    const r = [];
    for (let i = 0; i < e.length; i += 2)
      r.push(parseInt(e.substring(i, i + 2), 16));
    return nr(new Uint8Array(r));
  }
  return Jn(n) ? nr(new Uint8Array(n)) : We.throwArgumentError("invalid arrayify value", "value", n);
}
function kn(n, t) {
  return !(typeof n != "string" || !n.match(/^0x[0-9A-Fa-f]*$/));
}
const Wr = "0123456789abcdef";
function $s(n, t) {
  if (t || (t = {}), typeof n == "number") {
    We.checkSafeUint53(n, "invalid hexlify value");
    let e = "";
    for (; n; )
      e = Wr[n & 15] + e, n = Math.floor(n / 16);
    return e.length ? (e.length % 2 && (e = "0" + e), "0x" + e) : "0x00";
  }
  if (typeof n == "bigint")
    return n = n.toString(16), n.length % 2 ? "0x0" + n : "0x" + n;
  if (t.allowMissingPrefix && typeof n == "string" && n.substring(0, 2) !== "0x" && (n = "0x" + n), Ds(n))
    return n.toHexString();
  if (kn(n))
    return n.length % 2 && (t.hexPad === "left" ? n = "0x0" + n.substring(2) : t.hexPad === "right" ? n += "0" : We.throwArgumentError("hex data is odd-length", "value", n)), n.toLowerCase();
  if (Jn(n)) {
    let e = "0x";
    for (let r = 0; r < n.length; r++) {
      let i = n[r];
      e += Wr[(i & 240) >> 4] + Wr[i & 15];
    }
    return e;
  }
  return We.throwArgumentError("invalid hexlify value", "value", n);
}
function es(n, t) {
  for (typeof n != "string" ? n = $s(n) : kn(n) || We.throwArgumentError("invalid hex string", "value", n), n.length > 2 * t + 2 && We.throwArgumentError("value out of range", "value", arguments[1]); n.length < 2 * t + 2; )
    n = "0x0" + n.substring(2);
  return n;
}
const Gs = "bignumber/5.7.0";
var ei = ro.BN;
const Ie = new q(Gs), Jr = {}, ns = 9007199254740991;
function uo(n) {
  return n != null && (rt.isBigNumber(n) || typeof n == "number" && n % 1 === 0 || typeof n == "string" && !!n.match(/^-?[0-9]+$/) || kn(n) || typeof n == "bigint" || Jn(n));
}
let rs = !1;
class rt {
  constructor(t, e) {
    t !== Jr && Ie.throwError("cannot call constructor directly; use BigNumber.from", q.errors.UNSUPPORTED_OPERATION, {
      operation: "new (BigNumber)"
    }), this._hex = e, this._isBigNumber = !0, Object.freeze(this);
  }
  fromTwos(t) {
    return te(V(this).fromTwos(t));
  }
  toTwos(t) {
    return te(V(this).toTwos(t));
  }
  abs() {
    return this._hex[0] === "-" ? rt.from(this._hex.substring(1)) : this;
  }
  add(t) {
    return te(V(this).add(V(t)));
  }
  sub(t) {
    return te(V(this).sub(V(t)));
  }
  div(t) {
    return rt.from(t).isZero() && ue("division-by-zero", "div"), te(V(this).div(V(t)));
  }
  mul(t) {
    return te(V(this).mul(V(t)));
  }
  mod(t) {
    const e = V(t);
    return e.isNeg() && ue("division-by-zero", "mod"), te(V(this).umod(e));
  }
  pow(t) {
    const e = V(t);
    return e.isNeg() && ue("negative-power", "pow"), te(V(this).pow(e));
  }
  and(t) {
    const e = V(t);
    return (this.isNegative() || e.isNeg()) && ue("unbound-bitwise-result", "and"), te(V(this).and(e));
  }
  or(t) {
    const e = V(t);
    return (this.isNegative() || e.isNeg()) && ue("unbound-bitwise-result", "or"), te(V(this).or(e));
  }
  xor(t) {
    const e = V(t);
    return (this.isNegative() || e.isNeg()) && ue("unbound-bitwise-result", "xor"), te(V(this).xor(e));
  }
  mask(t) {
    return (this.isNegative() || t < 0) && ue("negative-width", "mask"), te(V(this).maskn(t));
  }
  shl(t) {
    return (this.isNegative() || t < 0) && ue("negative-width", "shl"), te(V(this).shln(t));
  }
  shr(t) {
    return (this.isNegative() || t < 0) && ue("negative-width", "shr"), te(V(this).shrn(t));
  }
  eq(t) {
    return V(this).eq(V(t));
  }
  lt(t) {
    return V(this).lt(V(t));
  }
  lte(t) {
    return V(this).lte(V(t));
  }
  gt(t) {
    return V(this).gt(V(t));
  }
  gte(t) {
    return V(this).gte(V(t));
  }
  isNegative() {
    return this._hex[0] === "-";
  }
  isZero() {
    return V(this).isZero();
  }
  toNumber() {
    try {
      return V(this).toNumber();
    } catch {
      ue("overflow", "toNumber", this.toString());
    }
    return null;
  }
  toBigInt() {
    try {
      return BigInt(this.toString());
    } catch {
    }
    return Ie.throwError("this platform does not support BigInt", q.errors.UNSUPPORTED_OPERATION, {
      value: this.toString()
    });
  }
  toString() {
    return arguments.length > 0 && (arguments[0] === 10 ? rs || (rs = !0, Ie.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : arguments[0] === 16 ? Ie.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", q.errors.UNEXPECTED_ARGUMENT, {}) : Ie.throwError("BigNumber.toString does not accept parameters", q.errors.UNEXPECTED_ARGUMENT, {})), V(this).toString(10);
  }
  toHexString() {
    return this._hex;
  }
  toJSON(t) {
    return { type: "BigNumber", hex: this.toHexString() };
  }
  static from(t) {
    if (t instanceof rt)
      return t;
    if (typeof t == "string")
      return t.match(/^-?0x[0-9a-f]+$/i) ? new rt(Jr, $n(t)) : t.match(/^-?[0-9]+$/) ? new rt(Jr, $n(new ei(t))) : Ie.throwArgumentError("invalid BigNumber string", "value", t);
    if (typeof t == "number")
      return t % 1 && ue("underflow", "BigNumber.from", t), (t >= ns || t <= -ns) && ue("overflow", "BigNumber.from", t), rt.from(String(t));
    const e = t;
    if (typeof e == "bigint")
      return rt.from(e.toString());
    if (Jn(e))
      return rt.from($s(e));
    if (e)
      if (e.toHexString) {
        const r = e.toHexString();
        if (typeof r == "string")
          return rt.from(r);
      } else {
        let r = e._hex;
        if (r == null && e.type === "BigNumber" && (r = e.hex), typeof r == "string" && (kn(r) || r[0] === "-" && kn(r.substring(1))))
          return rt.from(r);
      }
    return Ie.throwArgumentError("invalid BigNumber value", "value", t);
  }
  static isBigNumber(t) {
    return !!(t && t._isBigNumber);
  }
}
function $n(n) {
  if (typeof n != "string")
    return $n(n.toString(16));
  if (n[0] === "-")
    return n = n.substring(1), n[0] === "-" && Ie.throwArgumentError("invalid hex", "value", n), n = $n(n), n === "0x00" ? n : "-" + n;
  if (n.substring(0, 2) !== "0x" && (n = "0x" + n), n === "0x")
    return "0x00";
  for (n.length % 2 && (n = "0x0" + n.substring(2)); n.length > 4 && n.substring(0, 4) === "0x00"; )
    n = "0x" + n.substring(4);
  return n;
}
function te(n) {
  return rt.from($n(n));
}
function V(n) {
  const t = rt.from(n).toHexString();
  return t[0] === "-" ? new ei("-" + t.substring(3), 16) : new ei(t.substring(2), 16);
}
function ue(n, t, e) {
  const r = { fault: n, operation: t };
  return e != null && (r.value = e), Ie.throwError(n, q.errors.NUMERIC_FAULT, r);
}
const Yt = new q(Gs), Cn = {}, Hs = rt.from(0), Vs = rt.from(-1);
function zs(n, t, e, r) {
  const i = { fault: t, operation: e };
  return r !== void 0 && (i.value = r), Yt.throwError(n, q.errors.NUMERIC_FAULT, i);
}
let Fn = "0";
for (; Fn.length < 256; )
  Fn += Fn;
function vi(n) {
  if (typeof n != "number")
    try {
      n = rt.from(n).toNumber();
    } catch {
    }
  return typeof n == "number" && n >= 0 && n <= 256 && !(n % 1) ? "1" + Fn.substring(0, n) : Yt.throwArgumentError("invalid decimal size", "decimals", n);
}
function rr(n, t) {
  t == null && (t = 0);
  const e = vi(t);
  n = rt.from(n);
  const r = n.lt(Hs);
  r && (n = n.mul(Vs));
  let i = n.mod(e).toString();
  for (; i.length < e.length - 1; )
    i = "0" + i;
  i = i.match(/^([0-9]*[1-9]|0)(0*)/)[1];
  const s = n.div(e).toString();
  return e.length === 1 ? n = s : n = s + "." + i, r && (n = "-" + n), n;
}
function Ae(n, t) {
  t == null && (t = 0);
  const e = vi(t);
  (typeof n != "string" || !n.match(/^-?[0-9.]+$/)) && Yt.throwArgumentError("invalid decimal value", "value", n);
  const r = n.substring(0, 1) === "-";
  r && (n = n.substring(1)), n === "." && Yt.throwArgumentError("missing value", "value", n);
  const i = n.split(".");
  i.length > 2 && Yt.throwArgumentError("too many decimal points", "value", n);
  let s = i[0], o = i[1];
  for (s || (s = "0"), o || (o = "0"); o[o.length - 1] === "0"; )
    o = o.substring(0, o.length - 1);
  for (o.length > e.length - 1 && zs("fractional component exceeds decimals", "underflow", "parseFixed"), o === "" && (o = "0"); o.length < e.length - 1; )
    o += "0";
  const f = rt.from(s), c = rt.from(o);
  let d = f.mul(e).add(c);
  return r && (d = d.mul(Vs)), d;
}
class xn {
  constructor(t, e, r, i) {
    t !== Cn && Yt.throwError("cannot use FixedFormat constructor; use FixedFormat.from", q.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.signed = e, this.width = r, this.decimals = i, this.name = (e ? "" : "u") + "fixed" + String(r) + "x" + String(i), this._multiplier = vi(i), Object.freeze(this);
  }
  static from(t) {
    if (t instanceof xn)
      return t;
    typeof t == "number" && (t = `fixed128x${t}`);
    let e = !0, r = 128, i = 18;
    if (typeof t == "string") {
      if (t !== "fixed") if (t === "ufixed")
        e = !1;
      else {
        const s = t.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
        s || Yt.throwArgumentError("invalid fixed format", "format", t), e = s[1] !== "u", r = parseInt(s[2]), i = parseInt(s[3]);
      }
    } else if (t) {
      const s = (o, f, c) => t[o] == null ? c : (typeof t[o] !== f && Yt.throwArgumentError("invalid fixed format (" + o + " not " + f + ")", "format." + o, t[o]), t[o]);
      e = s("signed", "boolean", e), r = s("width", "number", r), i = s("decimals", "number", i);
    }
    return r % 8 && Yt.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", r), i > 80 && Yt.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", i), new xn(Cn, e, r, i);
  }
}
class Vt {
  constructor(t, e, r, i) {
    t !== Cn && Yt.throwError("cannot use FixedNumber constructor; use FixedNumber.from", q.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.format = i, this._hex = e, this._value = r, this._isFixedNumber = !0, Object.freeze(this);
  }
  _checkFormat(t) {
    this.format.name !== t.format.name && Yt.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", t);
  }
  addUnsafe(t) {
    this._checkFormat(t);
    const e = Ae(this._value, this.format.decimals), r = Ae(t._value, t.format.decimals);
    return Vt.fromValue(e.add(r), this.format.decimals, this.format);
  }
  subUnsafe(t) {
    this._checkFormat(t);
    const e = Ae(this._value, this.format.decimals), r = Ae(t._value, t.format.decimals);
    return Vt.fromValue(e.sub(r), this.format.decimals, this.format);
  }
  mulUnsafe(t) {
    this._checkFormat(t);
    const e = Ae(this._value, this.format.decimals), r = Ae(t._value, t.format.decimals);
    return Vt.fromValue(e.mul(r).div(this.format._multiplier), this.format.decimals, this.format);
  }
  divUnsafe(t) {
    this._checkFormat(t);
    const e = Ae(this._value, this.format.decimals), r = Ae(t._value, t.format.decimals);
    return Vt.fromValue(e.mul(this.format._multiplier).div(r), this.format.decimals, this.format);
  }
  floor() {
    const t = this.toString().split(".");
    t.length === 1 && t.push("0");
    let e = Vt.from(t[0], this.format);
    const r = !t[1].match(/^(0*)$/);
    return this.isNegative() && r && (e = e.subUnsafe(is.toFormat(e.format))), e;
  }
  ceiling() {
    const t = this.toString().split(".");
    t.length === 1 && t.push("0");
    let e = Vt.from(t[0], this.format);
    const r = !t[1].match(/^(0*)$/);
    return !this.isNegative() && r && (e = e.addUnsafe(is.toFormat(e.format))), e;
  }
  // @TODO: Support other rounding algorithms
  round(t) {
    t == null && (t = 0);
    const e = this.toString().split(".");
    if (e.length === 1 && e.push("0"), (t < 0 || t > 80 || t % 1) && Yt.throwArgumentError("invalid decimal count", "decimals", t), e[1].length <= t)
      return this;
    const r = Vt.from("1" + Fn.substring(0, t), this.format), i = lo.toFormat(this.format);
    return this.mulUnsafe(r).addUnsafe(i).floor().divUnsafe(r);
  }
  isZero() {
    return this._value === "0.0" || this._value === "0";
  }
  isNegative() {
    return this._value[0] === "-";
  }
  toString() {
    return this._value;
  }
  toHexString(t) {
    if (t == null)
      return this._hex;
    t % 8 && Yt.throwArgumentError("invalid byte width", "width", t);
    const e = rt.from(this._hex).fromTwos(this.format.width).toTwos(t).toHexString();
    return es(e, t / 8);
  }
  toUnsafeFloat() {
    return parseFloat(this.toString());
  }
  toFormat(t) {
    return Vt.fromString(this._value, t);
  }
  static fromValue(t, e, r) {
    return r == null && e != null && !uo(e) && (r = e, e = null), e == null && (e = 0), r == null && (r = "fixed"), Vt.fromString(rr(t, e), xn.from(r));
  }
  static fromString(t, e) {
    e == null && (e = "fixed");
    const r = xn.from(e), i = Ae(t, r.decimals);
    !r.signed && i.lt(Hs) && zs("unsigned value cannot be negative", "overflow", "value", t);
    let s = null;
    r.signed ? s = i.toTwos(r.width).toHexString() : (s = i.toHexString(), s = es(s, r.width / 8));
    const o = rr(i, r.decimals);
    return new Vt(Cn, s, o, r);
  }
  static fromBytes(t, e) {
    e == null && (e = "fixed");
    const r = xn.from(e);
    if (oo(t).length > r.width / 8)
      throw new Error("overflow");
    let i = rt.from(t);
    r.signed && (i = i.fromTwos(r.width));
    const s = i.toTwos((r.signed ? 0 : 1) + r.width).toHexString(), o = rr(i, r.decimals);
    return new Vt(Cn, s, o, r);
  }
  static from(t, e) {
    if (typeof t == "string")
      return Vt.fromString(t, e);
    if (Jn(t))
      return Vt.fromBytes(t, e);
    try {
      return Vt.fromValue(t, 0, e);
    } catch (r) {
      if (r.code !== q.errors.INVALID_ARGUMENT)
        throw r;
    }
    return Yt.throwArgumentError("invalid FixedNumber value", "value", t);
  }
  static isFixedNumber(t) {
    return !!(t && t._isFixedNumber);
  }
}
const is = Vt.from(1), lo = Vt.from("0.5"), fo = "units/5.7.0", co = new q(fo), po = [
  "wei",
  "kwei",
  "mwei",
  "gwei",
  "szabo",
  "finney",
  "ether"
];
function ho(n) {
  const t = String(n).split(".");
  (t.length > 2 || !t[0].match(/^-?[0-9]*$/) || t[1] && !t[1].match(/^[0-9]*$/) || n === "." || n === "-.") && co.throwArgumentError("invalid value", "value", n);
  let e = t[0], r = "";
  for (e.substring(0, 1) === "-" && (r = "-", e = e.substring(1)); e.substring(0, 1) === "0"; )
    e = e.substring(1);
  e === "" && (e = "0");
  let i = "";
  for (t.length === 2 && (i = "." + (t[1] || "0")); i.length > 2 && i[i.length - 1] === "0"; )
    i = i.substring(0, i.length - 1);
  const s = [];
  for (; e.length; )
    if (e.length <= 3) {
      s.unshift(e);
      break;
    } else {
      const o = e.length - 3;
      s.unshift(e.substring(o)), e = e.substring(0, o);
    }
  return r + s.join(",") + i;
}
function ss(n, t) {
  if (typeof t == "string") {
    const e = po.indexOf(t);
    e !== -1 && (t = 3 * e);
  }
  return rr(n, t ?? 18);
}
/*!
 *  decimal.js v10.4.3
 *  An arbitrary-precision Decimal type for JavaScript.
 *  https://github.com/MikeMcl/decimal.js
 *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *  MIT Licence
 */
var bn = 9e15, Qe = 1e9, ni = "0123456789abcdef", fr = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", cr = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", ri = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed at run-time using the `Decimal.config` method.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used when rounding to `precision`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The modulo mode used when calculating the modulus: a mod n.
  // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
  // The remainder (r) is calculated as: r = a - n * q.
  //
  // UP         0 The remainder is positive if the dividend is negative, else is negative.
  // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
  // FLOOR      3 The remainder has the same sign as the divisor (Python %).
  // HALF_EVEN  6 The IEEE 754 remainder function.
  // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
  //
  // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
  // division (9) are commonly used for the modulus operation. The other rounding modes can also
  // be used, but they may not give useful results.
  modulo: 1,
  // 0 to 9
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -EXP_LIMIT
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to EXP_LIMIT
  // The minimum exponent value, beneath which underflow to zero occurs.
  // JavaScript numbers: -324  (5e-324)
  minE: -bn,
  // -1 to -EXP_LIMIT
  // The maximum exponent value, above which overflow to Infinity occurs.
  // JavaScript numbers: 308  (1.7976931348623157e+308)
  maxE: bn,
  // 1 to EXP_LIMIT
  // Whether to use cryptographically-secure random number generation, if available.
  crypto: !1
  // true/false
}, qs, Se, F = !0, gr = "[DecimalError] ", Je = gr + "Invalid argument: ", Zs = gr + "Precision limit exceeded", Ks = gr + "crypto unavailable", Ws = "[object Decimal]", Xt = Math.floor, Gt = Math.pow, mo = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, yo = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, go = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, Js = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, me = 1e7, B = 7, wo = 9007199254740991, bo = fr.length - 1, ii = cr.length - 1, A = { toStringTag: Ws };
A.absoluteValue = A.abs = function() {
  var n = new this.constructor(this);
  return n.s < 0 && (n.s = 1), P(n);
};
A.ceil = function() {
  return P(new this.constructor(this), this.e + 1, 2);
};
A.clampedTo = A.clamp = function(n, t) {
  var e, r = this, i = r.constructor;
  if (n = new i(n), t = new i(t), !n.s || !t.s) return new i(NaN);
  if (n.gt(t)) throw Error(Je + t);
  return e = r.cmp(n), e < 0 ? n : r.cmp(t) > 0 ? t : new i(r);
};
A.comparedTo = A.cmp = function(n) {
  var t, e, r, i, s = this, o = s.d, f = (n = new s.constructor(n)).d, c = s.s, d = n.s;
  if (!o || !f)
    return !c || !d ? NaN : c !== d ? c : o === f ? 0 : !o ^ c < 0 ? 1 : -1;
  if (!o[0] || !f[0]) return o[0] ? c : f[0] ? -d : 0;
  if (c !== d) return c;
  if (s.e !== n.e) return s.e > n.e ^ c < 0 ? 1 : -1;
  for (r = o.length, i = f.length, t = 0, e = r < i ? r : i; t < e; ++t)
    if (o[t] !== f[t]) return o[t] > f[t] ^ c < 0 ? 1 : -1;
  return r === i ? 0 : r > i ^ c < 0 ? 1 : -1;
};
A.cosine = A.cos = function() {
  var n, t, e = this, r = e.constructor;
  return e.d ? e.d[0] ? (n = r.precision, t = r.rounding, r.precision = n + Math.max(e.e, e.sd()) + B, r.rounding = 1, e = vo(r, ta(r, e)), r.precision = n, r.rounding = t, P(Se == 2 || Se == 3 ? e.neg() : e, n, t, !0)) : new r(1) : new r(NaN);
};
A.cubeRoot = A.cbrt = function() {
  var n, t, e, r, i, s, o, f, c, d, h = this, v = h.constructor;
  if (!h.isFinite() || h.isZero()) return new v(h);
  for (F = !1, s = h.s * Gt(h.s * h, 1 / 3), !s || Math.abs(s) == 1 / 0 ? (e = qt(h.d), n = h.e, (s = (n - e.length + 1) % 3) && (e += s == 1 || s == -2 ? "0" : "00"), s = Gt(e, 1 / 3), n = Xt((n + 1) / 3) - (n % 3 == (n < 0 ? -1 : 2)), s == 1 / 0 ? e = "5e" + n : (e = s.toExponential(), e = e.slice(0, e.indexOf("e") + 1) + n), r = new v(e), r.s = h.s) : r = new v(s.toString()), o = (n = v.precision) + 3; ; )
    if (f = r, c = f.times(f).times(f), d = c.plus(h), r = Y(d.plus(h).times(f), d.plus(c), o + 2, 1), qt(f.d).slice(0, o) === (e = qt(r.d)).slice(0, o))
      if (e = e.slice(o - 3, o + 1), e == "9999" || !i && e == "4999") {
        if (!i && (P(f, n + 1, 0), f.times(f).times(f).eq(h))) {
          r = f;
          break;
        }
        o += 4, i = 1;
      } else {
        (!+e || !+e.slice(1) && e.charAt(0) == "5") && (P(r, n + 1, 1), t = !r.times(r).times(r).eq(h));
        break;
      }
  return F = !0, P(r, n, v.rounding, t);
};
A.decimalPlaces = A.dp = function() {
  var n, t = this.d, e = NaN;
  if (t) {
    if (n = t.length - 1, e = (n - Xt(this.e / B)) * B, n = t[n], n) for (; n % 10 == 0; n /= 10) e--;
    e < 0 && (e = 0);
  }
  return e;
};
A.dividedBy = A.div = function(n) {
  return Y(this, new this.constructor(n));
};
A.dividedToIntegerBy = A.divToInt = function(n) {
  var t = this, e = t.constructor;
  return P(Y(t, new e(n), 0, 1, 1), e.precision, e.rounding);
};
A.equals = A.eq = function(n) {
  return this.cmp(n) === 0;
};
A.floor = function() {
  return P(new this.constructor(this), this.e + 1, 3);
};
A.greaterThan = A.gt = function(n) {
  return this.cmp(n) > 0;
};
A.greaterThanOrEqualTo = A.gte = function(n) {
  var t = this.cmp(n);
  return t == 1 || t === 0;
};
A.hyperbolicCosine = A.cosh = function() {
  var n, t, e, r, i, s = this, o = s.constructor, f = new o(1);
  if (!s.isFinite()) return new o(s.s ? 1 / 0 : NaN);
  if (s.isZero()) return f;
  e = o.precision, r = o.rounding, o.precision = e + Math.max(s.e, s.sd()) + 4, o.rounding = 1, i = s.d.length, i < 32 ? (n = Math.ceil(i / 3), t = (1 / br(4, n)).toString()) : (n = 16, t = "2.3283064365386962890625e-10"), s = On(o, 1, s.times(t), new o(1), !0);
  for (var c, d = n, h = new o(8); d--; )
    c = s.times(s), s = f.minus(c.times(h.minus(c.times(h))));
  return P(s, o.precision = e, o.rounding = r, !0);
};
A.hyperbolicSine = A.sinh = function() {
  var n, t, e, r, i = this, s = i.constructor;
  if (!i.isFinite() || i.isZero()) return new s(i);
  if (t = s.precision, e = s.rounding, s.precision = t + Math.max(i.e, i.sd()) + 4, s.rounding = 1, r = i.d.length, r < 3)
    i = On(s, 2, i, i, !0);
  else {
    n = 1.4 * Math.sqrt(r), n = n > 16 ? 16 : n | 0, i = i.times(1 / br(5, n)), i = On(s, 2, i, i, !0);
    for (var o, f = new s(5), c = new s(16), d = new s(20); n--; )
      o = i.times(i), i = i.times(f.plus(o.times(c.times(o).plus(d))));
  }
  return s.precision = t, s.rounding = e, P(i, t, e, !0);
};
A.hyperbolicTangent = A.tanh = function() {
  var n, t, e = this, r = e.constructor;
  return e.isFinite() ? e.isZero() ? new r(e) : (n = r.precision, t = r.rounding, r.precision = n + 7, r.rounding = 1, Y(e.sinh(), e.cosh(), r.precision = n, r.rounding = t)) : new r(e.s);
};
A.inverseCosine = A.acos = function() {
  var n, t = this, e = t.constructor, r = t.abs().cmp(1), i = e.precision, s = e.rounding;
  return r !== -1 ? r === 0 ? t.isNeg() ? he(e, i, s) : new e(0) : new e(NaN) : t.isZero() ? he(e, i + 4, s).times(0.5) : (e.precision = i + 6, e.rounding = 1, t = t.asin(), n = he(e, i + 4, s).times(0.5), e.precision = i, e.rounding = s, n.minus(t));
};
A.inverseHyperbolicCosine = A.acosh = function() {
  var n, t, e = this, r = e.constructor;
  return e.lte(1) ? new r(e.eq(1) ? 0 : NaN) : e.isFinite() ? (n = r.precision, t = r.rounding, r.precision = n + Math.max(Math.abs(e.e), e.sd()) + 4, r.rounding = 1, F = !1, e = e.times(e).minus(1).sqrt().plus(e), F = !0, r.precision = n, r.rounding = t, e.ln()) : new r(e);
};
A.inverseHyperbolicSine = A.asinh = function() {
  var n, t, e = this, r = e.constructor;
  return !e.isFinite() || e.isZero() ? new r(e) : (n = r.precision, t = r.rounding, r.precision = n + 2 * Math.max(Math.abs(e.e), e.sd()) + 6, r.rounding = 1, F = !1, e = e.times(e).plus(1).sqrt().plus(e), F = !0, r.precision = n, r.rounding = t, e.ln());
};
A.inverseHyperbolicTangent = A.atanh = function() {
  var n, t, e, r, i = this, s = i.constructor;
  return i.isFinite() ? i.e >= 0 ? new s(i.abs().eq(1) ? i.s / 0 : i.isZero() ? i : NaN) : (n = s.precision, t = s.rounding, r = i.sd(), Math.max(r, n) < 2 * -i.e - 1 ? P(new s(i), n, t, !0) : (s.precision = e = r - i.e, i = Y(i.plus(1), new s(1).minus(i), e + n, 1), s.precision = n + 4, s.rounding = 1, i = i.ln(), s.precision = n, s.rounding = t, i.times(0.5))) : new s(NaN);
};
A.inverseSine = A.asin = function() {
  var n, t, e, r, i = this, s = i.constructor;
  return i.isZero() ? new s(i) : (t = i.abs().cmp(1), e = s.precision, r = s.rounding, t !== -1 ? t === 0 ? (n = he(s, e + 4, r).times(0.5), n.s = i.s, n) : new s(NaN) : (s.precision = e + 6, s.rounding = 1, i = i.div(new s(1).minus(i.times(i)).sqrt().plus(1)).atan(), s.precision = e, s.rounding = r, i.times(2)));
};
A.inverseTangent = A.atan = function() {
  var n, t, e, r, i, s, o, f, c, d = this, h = d.constructor, v = h.precision, x = h.rounding;
  if (d.isFinite()) {
    if (d.isZero())
      return new h(d);
    if (d.abs().eq(1) && v + 4 <= ii)
      return o = he(h, v + 4, x).times(0.25), o.s = d.s, o;
  } else {
    if (!d.s) return new h(NaN);
    if (v + 4 <= ii)
      return o = he(h, v + 4, x).times(0.5), o.s = d.s, o;
  }
  for (h.precision = f = v + 10, h.rounding = 1, e = Math.min(28, f / B + 2 | 0), n = e; n; --n) d = d.div(d.times(d).plus(1).sqrt().plus(1));
  for (F = !1, t = Math.ceil(f / B), r = 1, c = d.times(d), o = new h(d), i = d; n !== -1; )
    if (i = i.times(c), s = o.minus(i.div(r += 2)), i = i.times(c), o = s.plus(i.div(r += 2)), o.d[t] !== void 0) for (n = t; o.d[n] === s.d[n] && n--; ) ;
  return e && (o = o.times(2 << e - 1)), F = !0, P(o, h.precision = v, h.rounding = x, !0);
};
A.isFinite = function() {
  return !!this.d;
};
A.isInteger = A.isInt = function() {
  return !!this.d && Xt(this.e / B) > this.d.length - 2;
};
A.isNaN = function() {
  return !this.s;
};
A.isNegative = A.isNeg = function() {
  return this.s < 0;
};
A.isPositive = A.isPos = function() {
  return this.s > 0;
};
A.isZero = function() {
  return !!this.d && this.d[0] === 0;
};
A.lessThan = A.lt = function(n) {
  return this.cmp(n) < 0;
};
A.lessThanOrEqualTo = A.lte = function(n) {
  return this.cmp(n) < 1;
};
A.logarithm = A.log = function(n) {
  var t, e, r, i, s, o, f, c, d = this, h = d.constructor, v = h.precision, x = h.rounding, N = 5;
  if (n == null)
    n = new h(10), t = !0;
  else {
    if (n = new h(n), e = n.d, n.s < 0 || !e || !e[0] || n.eq(1)) return new h(NaN);
    t = n.eq(10);
  }
  if (e = d.d, d.s < 0 || !e || !e[0] || d.eq(1))
    return new h(e && !e[0] ? -1 / 0 : d.s != 1 ? NaN : e ? 0 : 1 / 0);
  if (t)
    if (e.length > 1)
      s = !0;
    else {
      for (i = e[0]; i % 10 === 0; ) i /= 10;
      s = i !== 1;
    }
  if (F = !1, f = v + N, o = Ke(d, f), r = t ? dr(h, f + 10) : Ke(n, f), c = Y(o, r, f, 1), Gn(c.d, i = v, x))
    do
      if (f += 10, o = Ke(d, f), r = t ? dr(h, f + 10) : Ke(n, f), c = Y(o, r, f, 1), !s) {
        +qt(c.d).slice(i + 1, i + 15) + 1 == 1e14 && (c = P(c, v + 1, 0));
        break;
      }
    while (Gn(c.d, i += 10, x));
  return F = !0, P(c, v, x);
};
A.minus = A.sub = function(n) {
  var t, e, r, i, s, o, f, c, d, h, v, x, N = this, _ = N.constructor;
  if (n = new _(n), !N.d || !n.d)
    return !N.s || !n.s ? n = new _(NaN) : N.d ? n.s = -n.s : n = new _(n.d || N.s !== n.s ? N : NaN), n;
  if (N.s != n.s)
    return n.s = -n.s, N.plus(n);
  if (d = N.d, x = n.d, f = _.precision, c = _.rounding, !d[0] || !x[0]) {
    if (x[0]) n.s = -n.s;
    else if (d[0]) n = new _(N);
    else return new _(c === 3 ? -0 : 0);
    return F ? P(n, f, c) : n;
  }
  if (e = Xt(n.e / B), h = Xt(N.e / B), d = d.slice(), s = h - e, s) {
    for (v = s < 0, v ? (t = d, s = -s, o = x.length) : (t = x, e = h, o = d.length), r = Math.max(Math.ceil(f / B), o) + 2, s > r && (s = r, t.length = 1), t.reverse(), r = s; r--; ) t.push(0);
    t.reverse();
  } else {
    for (r = d.length, o = x.length, v = r < o, v && (o = r), r = 0; r < o; r++)
      if (d[r] != x[r]) {
        v = d[r] < x[r];
        break;
      }
    s = 0;
  }
  for (v && (t = d, d = x, x = t, n.s = -n.s), o = d.length, r = x.length - o; r > 0; --r) d[o++] = 0;
  for (r = x.length; r > s; ) {
    if (d[--r] < x[r]) {
      for (i = r; i && d[--i] === 0; ) d[i] = me - 1;
      --d[i], d[r] += me;
    }
    d[r] -= x[r];
  }
  for (; d[--o] === 0; ) d.pop();
  for (; d[0] === 0; d.shift()) --e;
  return d[0] ? (n.d = d, n.e = wr(d, e), F ? P(n, f, c) : n) : new _(c === 3 ? -0 : 0);
};
A.modulo = A.mod = function(n) {
  var t, e = this, r = e.constructor;
  return n = new r(n), !e.d || !n.s || n.d && !n.d[0] ? new r(NaN) : !n.d || e.d && !e.d[0] ? P(new r(e), r.precision, r.rounding) : (F = !1, r.modulo == 9 ? (t = Y(e, n.abs(), 0, 3, 1), t.s *= n.s) : t = Y(e, n, 0, r.modulo, 1), t = t.times(n), F = !0, e.minus(t));
};
A.naturalExponential = A.exp = function() {
  return si(this);
};
A.naturalLogarithm = A.ln = function() {
  return Ke(this);
};
A.negated = A.neg = function() {
  var n = new this.constructor(this);
  return n.s = -n.s, P(n);
};
A.plus = A.add = function(n) {
  var t, e, r, i, s, o, f, c, d, h, v = this, x = v.constructor;
  if (n = new x(n), !v.d || !n.d)
    return !v.s || !n.s ? n = new x(NaN) : v.d || (n = new x(n.d || v.s === n.s ? v : NaN)), n;
  if (v.s != n.s)
    return n.s = -n.s, v.minus(n);
  if (d = v.d, h = n.d, f = x.precision, c = x.rounding, !d[0] || !h[0])
    return h[0] || (n = new x(v)), F ? P(n, f, c) : n;
  if (s = Xt(v.e / B), r = Xt(n.e / B), d = d.slice(), i = s - r, i) {
    for (i < 0 ? (e = d, i = -i, o = h.length) : (e = h, r = s, o = d.length), s = Math.ceil(f / B), o = s > o ? s + 1 : o + 1, i > o && (i = o, e.length = 1), e.reverse(); i--; ) e.push(0);
    e.reverse();
  }
  for (o = d.length, i = h.length, o - i < 0 && (i = o, e = h, h = d, d = e), t = 0; i; )
    t = (d[--i] = d[i] + h[i] + t) / me | 0, d[i] %= me;
  for (t && (d.unshift(t), ++r), o = d.length; d[--o] == 0; ) d.pop();
  return n.d = d, n.e = wr(d, r), F ? P(n, f, c) : n;
};
A.precision = A.sd = function(n) {
  var t, e = this;
  if (n !== void 0 && n !== !!n && n !== 1 && n !== 0) throw Error(Je + n);
  return e.d ? (t = Xs(e.d), n && e.e + 1 > t && (t = e.e + 1)) : t = NaN, t;
};
A.round = function() {
  var n = this, t = n.constructor;
  return P(new t(n), n.e + 1, t.rounding);
};
A.sine = A.sin = function() {
  var n, t, e = this, r = e.constructor;
  return e.isFinite() ? e.isZero() ? new r(e) : (n = r.precision, t = r.rounding, r.precision = n + Math.max(e.e, e.sd()) + B, r.rounding = 1, e = xo(r, ta(r, e)), r.precision = n, r.rounding = t, P(Se > 2 ? e.neg() : e, n, t, !0)) : new r(NaN);
};
A.squareRoot = A.sqrt = function() {
  var n, t, e, r, i, s, o = this, f = o.d, c = o.e, d = o.s, h = o.constructor;
  if (d !== 1 || !f || !f[0])
    return new h(!d || d < 0 && (!f || f[0]) ? NaN : f ? o : 1 / 0);
  for (F = !1, d = Math.sqrt(+o), d == 0 || d == 1 / 0 ? (t = qt(f), (t.length + c) % 2 == 0 && (t += "0"), d = Math.sqrt(t), c = Xt((c + 1) / 2) - (c < 0 || c % 2), d == 1 / 0 ? t = "5e" + c : (t = d.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + c), r = new h(t)) : r = new h(d.toString()), e = (c = h.precision) + 3; ; )
    if (s = r, r = s.plus(Y(o, s, e + 2, 1)).times(0.5), qt(s.d).slice(0, e) === (t = qt(r.d)).slice(0, e))
      if (t = t.slice(e - 3, e + 1), t == "9999" || !i && t == "4999") {
        if (!i && (P(s, c + 1, 0), s.times(s).eq(o))) {
          r = s;
          break;
        }
        e += 4, i = 1;
      } else {
        (!+t || !+t.slice(1) && t.charAt(0) == "5") && (P(r, c + 1, 1), n = !r.times(r).eq(o));
        break;
      }
  return F = !0, P(r, c, h.rounding, n);
};
A.tangent = A.tan = function() {
  var n, t, e = this, r = e.constructor;
  return e.isFinite() ? e.isZero() ? new r(e) : (n = r.precision, t = r.rounding, r.precision = n + 10, r.rounding = 1, e = e.sin(), e.s = 1, e = Y(e, new r(1).minus(e.times(e)).sqrt(), n + 10, 0), r.precision = n, r.rounding = t, P(Se == 2 || Se == 4 ? e.neg() : e, n, t, !0)) : new r(NaN);
};
A.times = A.mul = function(n) {
  var t, e, r, i, s, o, f, c, d, h = this, v = h.constructor, x = h.d, N = (n = new v(n)).d;
  if (n.s *= h.s, !x || !x[0] || !N || !N[0])
    return new v(!n.s || x && !x[0] && !N || N && !N[0] && !x ? NaN : !x || !N ? n.s / 0 : n.s * 0);
  for (e = Xt(h.e / B) + Xt(n.e / B), c = x.length, d = N.length, c < d && (s = x, x = N, N = s, o = c, c = d, d = o), s = [], o = c + d, r = o; r--; ) s.push(0);
  for (r = d; --r >= 0; ) {
    for (t = 0, i = c + r; i > r; )
      f = s[i] + N[r] * x[i - r - 1] + t, s[i--] = f % me | 0, t = f / me | 0;
    s[i] = (s[i] + t) % me | 0;
  }
  for (; !s[--o]; ) s.pop();
  return t ? ++e : s.shift(), n.d = s, n.e = wr(s, e), F ? P(n, v.precision, v.rounding) : n;
};
A.toBinary = function(n, t) {
  return Ti(this, 2, n, t);
};
A.toDecimalPlaces = A.toDP = function(n, t) {
  var e = this, r = e.constructor;
  return e = new r(e), n === void 0 ? e : (re(n, 0, Qe), t === void 0 ? t = r.rounding : re(t, 0, 8), P(e, n + e.e + 1, t));
};
A.toExponential = function(n, t) {
  var e, r = this, i = r.constructor;
  return n === void 0 ? e = Ne(r, !0) : (re(n, 0, Qe), t === void 0 ? t = i.rounding : re(t, 0, 8), r = P(new i(r), n + 1, t), e = Ne(r, !0, n + 1)), r.isNeg() && !r.isZero() ? "-" + e : e;
};
A.toFixed = function(n, t) {
  var e, r, i = this, s = i.constructor;
  return n === void 0 ? e = Ne(i) : (re(n, 0, Qe), t === void 0 ? t = s.rounding : re(t, 0, 8), r = P(new s(i), n + i.e + 1, t), e = Ne(r, !1, n + r.e + 1)), i.isNeg() && !i.isZero() ? "-" + e : e;
};
A.toFraction = function(n) {
  var t, e, r, i, s, o, f, c, d, h, v, x, N = this, _ = N.d, k = N.constructor;
  if (!_) return new k(N);
  if (d = e = new k(1), r = c = new k(0), t = new k(r), s = t.e = Xs(_) - N.e - 1, o = s % B, t.d[0] = Gt(10, o < 0 ? B + o : o), n == null)
    n = s > 0 ? t : d;
  else {
    if (f = new k(n), !f.isInt() || f.lt(d)) throw Error(Je + f);
    n = f.gt(t) ? s > 0 ? t : d : f;
  }
  for (F = !1, f = new k(qt(_)), h = k.precision, k.precision = s = _.length * B * 2; v = Y(f, t, 0, 1, 1), i = e.plus(v.times(r)), i.cmp(n) != 1; )
    e = r, r = i, i = d, d = c.plus(v.times(i)), c = i, i = t, t = f.minus(v.times(i)), f = i;
  return i = Y(n.minus(e), r, 0, 1, 1), c = c.plus(i.times(d)), e = e.plus(i.times(r)), c.s = d.s = N.s, x = Y(d, r, s, 1).minus(N).abs().cmp(Y(c, e, s, 1).minus(N).abs()) < 1 ? [d, r] : [c, e], k.precision = h, F = !0, x;
};
A.toHexadecimal = A.toHex = function(n, t) {
  return Ti(this, 16, n, t);
};
A.toNearest = function(n, t) {
  var e = this, r = e.constructor;
  if (e = new r(e), n == null) {
    if (!e.d) return e;
    n = new r(1), t = r.rounding;
  } else {
    if (n = new r(n), t === void 0 ? t = r.rounding : re(t, 0, 8), !e.d) return n.s ? e : n;
    if (!n.d)
      return n.s && (n.s = e.s), n;
  }
  return n.d[0] ? (F = !1, e = Y(e, n, 0, t, 1).times(n), F = !0, P(e)) : (n.s = e.s, e = n), e;
};
A.toNumber = function() {
  return +this;
};
A.toOctal = function(n, t) {
  return Ti(this, 8, n, t);
};
A.toPower = A.pow = function(n) {
  var t, e, r, i, s, o, f = this, c = f.constructor, d = +(n = new c(n));
  if (!f.d || !n.d || !f.d[0] || !n.d[0]) return new c(Gt(+f, d));
  if (f = new c(f), f.eq(1)) return f;
  if (r = c.precision, s = c.rounding, n.eq(1)) return P(f, r, s);
  if (t = Xt(n.e / B), t >= n.d.length - 1 && (e = d < 0 ? -d : d) <= wo)
    return i = Ys(c, f, e, r), n.s < 0 ? new c(1).div(i) : P(i, r, s);
  if (o = f.s, o < 0) {
    if (t < n.d.length - 1) return new c(NaN);
    if (n.d[t] & 1 || (o = 1), f.e == 0 && f.d[0] == 1 && f.d.length == 1)
      return f.s = o, f;
  }
  return e = Gt(+f, d), t = e == 0 || !isFinite(e) ? Xt(d * (Math.log("0." + qt(f.d)) / Math.LN10 + f.e + 1)) : new c(e + "").e, t > c.maxE + 1 || t < c.minE - 1 ? new c(t > 0 ? o / 0 : 0) : (F = !1, c.rounding = f.s = 1, e = Math.min(12, (t + "").length), i = si(n.times(Ke(f, r + e)), r), i.d && (i = P(i, r + 5, 1), Gn(i.d, r, s) && (t = r + 10, i = P(si(n.times(Ke(f, t + e)), t), t + 5, 1), +qt(i.d).slice(r + 1, r + 15) + 1 == 1e14 && (i = P(i, r + 1, 0)))), i.s = o, F = !0, c.rounding = s, P(i, r, s));
};
A.toPrecision = function(n, t) {
  var e, r = this, i = r.constructor;
  return n === void 0 ? e = Ne(r, r.e <= i.toExpNeg || r.e >= i.toExpPos) : (re(n, 1, Qe), t === void 0 ? t = i.rounding : re(t, 0, 8), r = P(new i(r), n, t), e = Ne(r, n <= r.e || r.e <= i.toExpNeg, n)), r.isNeg() && !r.isZero() ? "-" + e : e;
};
A.toSignificantDigits = A.toSD = function(n, t) {
  var e = this, r = e.constructor;
  return n === void 0 ? (n = r.precision, t = r.rounding) : (re(n, 1, Qe), t === void 0 ? t = r.rounding : re(t, 0, 8)), P(new r(e), n, t);
};
A.toString = function() {
  var n = this, t = n.constructor, e = Ne(n, n.e <= t.toExpNeg || n.e >= t.toExpPos);
  return n.isNeg() && !n.isZero() ? "-" + e : e;
};
A.truncated = A.trunc = function() {
  return P(new this.constructor(this), this.e + 1, 1);
};
A.valueOf = A.toJSON = function() {
  var n = this, t = n.constructor, e = Ne(n, n.e <= t.toExpNeg || n.e >= t.toExpPos);
  return n.isNeg() ? "-" + e : e;
};
function qt(n) {
  var t, e, r, i = n.length - 1, s = "", o = n[0];
  if (i > 0) {
    for (s += o, t = 1; t < i; t++)
      r = n[t] + "", e = B - r.length, e && (s += Ve(e)), s += r;
    o = n[t], r = o + "", e = B - r.length, e && (s += Ve(e));
  } else if (o === 0)
    return "0";
  for (; o % 10 === 0; ) o /= 10;
  return s + o;
}
function re(n, t, e) {
  if (n !== ~~n || n < t || n > e)
    throw Error(Je + n);
}
function Gn(n, t, e, r) {
  var i, s, o, f;
  for (s = n[0]; s >= 10; s /= 10) --t;
  return --t < 0 ? (t += B, i = 0) : (i = Math.ceil((t + 1) / B), t %= B), s = Gt(10, B - t), f = n[i] % s | 0, r == null ? t < 3 ? (t == 0 ? f = f / 100 | 0 : t == 1 && (f = f / 10 | 0), o = e < 4 && f == 99999 || e > 3 && f == 49999 || f == 5e4 || f == 0) : o = (e < 4 && f + 1 == s || e > 3 && f + 1 == s / 2) && (n[i + 1] / s / 100 | 0) == Gt(10, t - 2) - 1 || (f == s / 2 || f == 0) && (n[i + 1] / s / 100 | 0) == 0 : t < 4 ? (t == 0 ? f = f / 1e3 | 0 : t == 1 ? f = f / 100 | 0 : t == 2 && (f = f / 10 | 0), o = (r || e < 4) && f == 9999 || !r && e > 3 && f == 4999) : o = ((r || e < 4) && f + 1 == s || !r && e > 3 && f + 1 == s / 2) && (n[i + 1] / s / 1e3 | 0) == Gt(10, t - 3) - 1, o;
}
function ir(n, t, e) {
  for (var r, i = [0], s, o = 0, f = n.length; o < f; ) {
    for (s = i.length; s--; ) i[s] *= t;
    for (i[0] += ni.indexOf(n.charAt(o++)), r = 0; r < i.length; r++)
      i[r] > e - 1 && (i[r + 1] === void 0 && (i[r + 1] = 0), i[r + 1] += i[r] / e | 0, i[r] %= e);
  }
  return i.reverse();
}
function vo(n, t) {
  var e, r, i;
  if (t.isZero()) return t;
  r = t.d.length, r < 32 ? (e = Math.ceil(r / 3), i = (1 / br(4, e)).toString()) : (e = 16, i = "2.3283064365386962890625e-10"), n.precision += e, t = On(n, 1, t.times(i), new n(1));
  for (var s = e; s--; ) {
    var o = t.times(t);
    t = o.times(o).minus(o).times(8).plus(1);
  }
  return n.precision -= e, t;
}
var Y = /* @__PURE__ */ function() {
  function n(r, i, s) {
    var o, f = 0, c = r.length;
    for (r = r.slice(); c--; )
      o = r[c] * i + f, r[c] = o % s | 0, f = o / s | 0;
    return f && r.unshift(f), r;
  }
  function t(r, i, s, o) {
    var f, c;
    if (s != o)
      c = s > o ? 1 : -1;
    else
      for (f = c = 0; f < s; f++)
        if (r[f] != i[f]) {
          c = r[f] > i[f] ? 1 : -1;
          break;
        }
    return c;
  }
  function e(r, i, s, o) {
    for (var f = 0; s--; )
      r[s] -= f, f = r[s] < i[s] ? 1 : 0, r[s] = f * o + r[s] - i[s];
    for (; !r[0] && r.length > 1; ) r.shift();
  }
  return function(r, i, s, o, f, c) {
    var d, h, v, x, N, _, k, G, U, J, H, it, $e, nt, Ge, en, He, nn, Z, oe, b = r.constructor, a = r.s == i.s ? 1 : -1, l = r.d, p = i.d;
    if (!l || !l[0] || !p || !p[0])
      return new b(
        // Return NaN if either NaN, or both Infinity or 0.
        !r.s || !i.s || (l ? p && l[0] == p[0] : !p) ? NaN : (
          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
          l && l[0] == 0 || !p ? a * 0 : a / 0
        )
      );
    for (c ? (N = 1, h = r.e - i.e) : (c = me, N = B, h = Xt(r.e / N) - Xt(i.e / N)), Z = p.length, He = l.length, U = new b(a), J = U.d = [], v = 0; p[v] == (l[v] || 0); v++) ;
    if (p[v] > (l[v] || 0) && h--, s == null ? (nt = s = b.precision, o = b.rounding) : f ? nt = s + (r.e - i.e) + 1 : nt = s, nt < 0)
      J.push(1), _ = !0;
    else {
      if (nt = nt / N + 2 | 0, v = 0, Z == 1) {
        for (x = 0, p = p[0], nt++; (v < He || x) && nt--; v++)
          Ge = x * c + (l[v] || 0), J[v] = Ge / p | 0, x = Ge % p | 0;
        _ = x || v < He;
      } else {
        for (x = c / (p[0] + 1) | 0, x > 1 && (p = n(p, x, c), l = n(l, x, c), Z = p.length, He = l.length), en = Z, H = l.slice(0, Z), it = H.length; it < Z; ) H[it++] = 0;
        oe = p.slice(), oe.unshift(0), nn = p[0], p[1] >= c / 2 && ++nn;
        do
          x = 0, d = t(p, H, Z, it), d < 0 ? ($e = H[0], Z != it && ($e = $e * c + (H[1] || 0)), x = $e / nn | 0, x > 1 ? (x >= c && (x = c - 1), k = n(p, x, c), G = k.length, it = H.length, d = t(k, H, G, it), d == 1 && (x--, e(k, Z < G ? oe : p, G, c))) : (x == 0 && (d = x = 1), k = p.slice()), G = k.length, G < it && k.unshift(0), e(H, k, it, c), d == -1 && (it = H.length, d = t(p, H, Z, it), d < 1 && (x++, e(H, Z < it ? oe : p, it, c))), it = H.length) : d === 0 && (x++, H = [0]), J[v++] = x, d && H[0] ? H[it++] = l[en] || 0 : (H = [l[en]], it = 1);
        while ((en++ < He || H[0] !== void 0) && nt--);
        _ = H[0] !== void 0;
      }
      J[0] || J.shift();
    }
    if (N == 1)
      U.e = h, qs = _;
    else {
      for (v = 1, x = J[0]; x >= 10; x /= 10) v++;
      U.e = v + h * N - 1, P(U, f ? s + U.e + 1 : s, o, _);
    }
    return U;
  };
}();
function P(n, t, e, r) {
  var i, s, o, f, c, d, h, v, x, N = n.constructor;
  t: if (t != null) {
    if (v = n.d, !v) return n;
    for (i = 1, f = v[0]; f >= 10; f /= 10) i++;
    if (s = t - i, s < 0)
      s += B, o = t, h = v[x = 0], c = h / Gt(10, i - o - 1) % 10 | 0;
    else if (x = Math.ceil((s + 1) / B), f = v.length, x >= f)
      if (r) {
        for (; f++ <= x; ) v.push(0);
        h = c = 0, i = 1, s %= B, o = s - B + 1;
      } else
        break t;
    else {
      for (h = f = v[x], i = 1; f >= 10; f /= 10) i++;
      s %= B, o = s - B + i, c = o < 0 ? 0 : h / Gt(10, i - o - 1) % 10 | 0;
    }
    if (r = r || t < 0 || v[x + 1] !== void 0 || (o < 0 ? h : h % Gt(10, i - o - 1)), d = e < 4 ? (c || r) && (e == 0 || e == (n.s < 0 ? 3 : 2)) : c > 5 || c == 5 && (e == 4 || r || e == 6 && // Check whether the digit to the left of the rounding digit is odd.
    (s > 0 ? o > 0 ? h / Gt(10, i - o) : 0 : v[x - 1]) % 10 & 1 || e == (n.s < 0 ? 8 : 7)), t < 1 || !v[0])
      return v.length = 0, d ? (t -= n.e + 1, v[0] = Gt(10, (B - t % B) % B), n.e = -t || 0) : v[0] = n.e = 0, n;
    if (s == 0 ? (v.length = x, f = 1, x--) : (v.length = x + 1, f = Gt(10, B - s), v[x] = o > 0 ? (h / Gt(10, i - o) % Gt(10, o) | 0) * f : 0), d)
      for (; ; )
        if (x == 0) {
          for (s = 1, o = v[0]; o >= 10; o /= 10) s++;
          for (o = v[0] += f, f = 1; o >= 10; o /= 10) f++;
          s != f && (n.e++, v[0] == me && (v[0] = 1));
          break;
        } else {
          if (v[x] += f, v[x] != me) break;
          v[x--] = 0, f = 1;
        }
    for (s = v.length; v[--s] === 0; ) v.pop();
  }
  return F && (n.e > N.maxE ? (n.d = null, n.e = NaN) : n.e < N.minE && (n.e = 0, n.d = [0])), n;
}
function Ne(n, t, e) {
  if (!n.isFinite()) return js(n);
  var r, i = n.e, s = qt(n.d), o = s.length;
  return t ? (e && (r = e - o) > 0 ? s = s.charAt(0) + "." + s.slice(1) + Ve(r) : o > 1 && (s = s.charAt(0) + "." + s.slice(1)), s = s + (n.e < 0 ? "e" : "e+") + n.e) : i < 0 ? (s = "0." + Ve(-i - 1) + s, e && (r = e - o) > 0 && (s += Ve(r))) : i >= o ? (s += Ve(i + 1 - o), e && (r = e - i - 1) > 0 && (s = s + "." + Ve(r))) : ((r = i + 1) < o && (s = s.slice(0, r) + "." + s.slice(r)), e && (r = e - o) > 0 && (i + 1 === o && (s += "."), s += Ve(r))), s;
}
function wr(n, t) {
  var e = n[0];
  for (t *= B; e >= 10; e /= 10) t++;
  return t;
}
function dr(n, t, e) {
  if (t > bo)
    throw F = !0, e && (n.precision = e), Error(Zs);
  return P(new n(fr), t, 1, !0);
}
function he(n, t, e) {
  if (t > ii) throw Error(Zs);
  return P(new n(cr), t, e, !0);
}
function Xs(n) {
  var t = n.length - 1, e = t * B + 1;
  if (t = n[t], t) {
    for (; t % 10 == 0; t /= 10) e--;
    for (t = n[0]; t >= 10; t /= 10) e++;
  }
  return e;
}
function Ve(n) {
  for (var t = ""; n--; ) t += "0";
  return t;
}
function Ys(n, t, e, r) {
  var i, s = new n(1), o = Math.ceil(r / B + 4);
  for (F = !1; ; ) {
    if (e % 2 && (s = s.times(t), os(s.d, o) && (i = !0)), e = Xt(e / 2), e === 0) {
      e = s.d.length - 1, i && s.d[e] === 0 && ++s.d[e];
      break;
    }
    t = t.times(t), os(t.d, o);
  }
  return F = !0, s;
}
function as(n) {
  return n.d[n.d.length - 1] & 1;
}
function Qs(n, t, e) {
  for (var r, i = new n(t[0]), s = 0; ++s < t.length; )
    if (r = new n(t[s]), r.s)
      i[e](r) && (i = r);
    else {
      i = r;
      break;
    }
  return i;
}
function si(n, t) {
  var e, r, i, s, o, f, c, d = 0, h = 0, v = 0, x = n.constructor, N = x.rounding, _ = x.precision;
  if (!n.d || !n.d[0] || n.e > 17)
    return new x(n.d ? n.d[0] ? n.s < 0 ? 0 : 1 / 0 : 1 : n.s ? n.s < 0 ? 0 : n : NaN);
  for (t == null ? (F = !1, c = _) : c = t, f = new x(0.03125); n.e > -2; )
    n = n.times(f), v += 5;
  for (r = Math.log(Gt(2, v)) / Math.LN10 * 2 + 5 | 0, c += r, e = s = o = new x(1), x.precision = c; ; ) {
    if (s = P(s.times(n), c, 1), e = e.times(++h), f = o.plus(Y(s, e, c, 1)), qt(f.d).slice(0, c) === qt(o.d).slice(0, c)) {
      for (i = v; i--; ) o = P(o.times(o), c, 1);
      if (t == null)
        if (d < 3 && Gn(o.d, c - r, N, d))
          x.precision = c += 10, e = s = f = new x(1), h = 0, d++;
        else
          return P(o, x.precision = _, N, F = !0);
      else
        return x.precision = _, o;
    }
    o = f;
  }
}
function Ke(n, t) {
  var e, r, i, s, o, f, c, d, h, v, x, N = 1, _ = 10, k = n, G = k.d, U = k.constructor, J = U.rounding, H = U.precision;
  if (k.s < 0 || !G || !G[0] || !k.e && G[0] == 1 && G.length == 1)
    return new U(G && !G[0] ? -1 / 0 : k.s != 1 ? NaN : G ? 0 : k);
  if (t == null ? (F = !1, h = H) : h = t, U.precision = h += _, e = qt(G), r = e.charAt(0), Math.abs(s = k.e) < 15e14) {
    for (; r < 7 && r != 1 || r == 1 && e.charAt(1) > 3; )
      k = k.times(n), e = qt(k.d), r = e.charAt(0), N++;
    s = k.e, r > 1 ? (k = new U("0." + e), s++) : k = new U(r + "." + e.slice(1));
  } else
    return d = dr(U, h + 2, H).times(s + ""), k = Ke(new U(r + "." + e.slice(1)), h - _).plus(d), U.precision = H, t == null ? P(k, H, J, F = !0) : k;
  for (v = k, c = o = k = Y(k.minus(1), k.plus(1), h, 1), x = P(k.times(k), h, 1), i = 3; ; ) {
    if (o = P(o.times(x), h, 1), d = c.plus(Y(o, new U(i), h, 1)), qt(d.d).slice(0, h) === qt(c.d).slice(0, h))
      if (c = c.times(2), s !== 0 && (c = c.plus(dr(U, h + 2, H).times(s + ""))), c = Y(c, new U(N), h, 1), t == null)
        if (Gn(c.d, h - _, J, f))
          U.precision = h += _, d = o = k = Y(v.minus(1), v.plus(1), h, 1), x = P(k.times(k), h, 1), i = f = 1;
        else
          return P(c, U.precision = H, J, F = !0);
      else
        return U.precision = H, c;
    c = d, i += 2;
  }
}
function js(n) {
  return String(n.s * n.s / 0);
}
function ai(n, t) {
  var e, r, i;
  for ((e = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (r = t.search(/e/i)) > 0 ? (e < 0 && (e = r), e += +t.slice(r + 1), t = t.substring(0, r)) : e < 0 && (e = t.length), r = 0; t.charCodeAt(r) === 48; r++) ;
  for (i = t.length; t.charCodeAt(i - 1) === 48; --i) ;
  if (t = t.slice(r, i), t) {
    if (i -= r, n.e = e = e - r - 1, n.d = [], r = (e + 1) % B, e < 0 && (r += B), r < i) {
      for (r && n.d.push(+t.slice(0, r)), i -= B; r < i; ) n.d.push(+t.slice(r, r += B));
      t = t.slice(r), r = B - t.length;
    } else
      r -= i;
    for (; r--; ) t += "0";
    n.d.push(+t), F && (n.e > n.constructor.maxE ? (n.d = null, n.e = NaN) : n.e < n.constructor.minE && (n.e = 0, n.d = [0]));
  } else
    n.e = 0, n.d = [0];
  return n;
}
function To(n, t) {
  var e, r, i, s, o, f, c, d, h;
  if (t.indexOf("_") > -1) {
    if (t = t.replace(/(\d)_(?=\d)/g, "$1"), Js.test(t)) return ai(n, t);
  } else if (t === "Infinity" || t === "NaN")
    return +t || (n.s = NaN), n.e = NaN, n.d = null, n;
  if (yo.test(t))
    e = 16, t = t.toLowerCase();
  else if (mo.test(t))
    e = 2;
  else if (go.test(t))
    e = 8;
  else
    throw Error(Je + t);
  for (s = t.search(/p/i), s > 0 ? (c = +t.slice(s + 1), t = t.substring(2, s)) : t = t.slice(2), s = t.indexOf("."), o = s >= 0, r = n.constructor, o && (t = t.replace(".", ""), f = t.length, s = f - s, i = Ys(r, new r(e), s, s * 2)), d = ir(t, e, me), h = d.length - 1, s = h; d[s] === 0; --s) d.pop();
  return s < 0 ? new r(n.s * 0) : (n.e = wr(d, h), n.d = d, F = !1, o && (n = Y(n, i, f * 4)), c && (n = n.times(Math.abs(c) < 54 ? Gt(2, c) : _n.pow(2, c))), F = !0, n);
}
function xo(n, t) {
  var e, r = t.d.length;
  if (r < 3)
    return t.isZero() ? t : On(n, 2, t, t);
  e = 1.4 * Math.sqrt(r), e = e > 16 ? 16 : e | 0, t = t.times(1 / br(5, e)), t = On(n, 2, t, t);
  for (var i, s = new n(5), o = new n(16), f = new n(20); e--; )
    i = t.times(t), t = t.times(s.plus(i.times(o.times(i).minus(f))));
  return t;
}
function On(n, t, e, r, i) {
  var s, o, f, c, d = n.precision, h = Math.ceil(d / B);
  for (F = !1, c = e.times(e), f = new n(r); ; ) {
    if (o = Y(f.times(c), new n(t++ * t++), d, 1), f = i ? r.plus(o) : r.minus(o), r = Y(o.times(c), new n(t++ * t++), d, 1), o = f.plus(r), o.d[h] !== void 0) {
      for (s = h; o.d[s] === f.d[s] && s--; ) ;
      if (s == -1) break;
    }
    s = f, f = r, r = o, o = s;
  }
  return F = !0, o.d.length = h + 1, o;
}
function br(n, t) {
  for (var e = n; --t; ) e *= n;
  return e;
}
function ta(n, t) {
  var e, r = t.s < 0, i = he(n, n.precision, 1), s = i.times(0.5);
  if (t = t.abs(), t.lte(s))
    return Se = r ? 4 : 1, t;
  if (e = t.divToInt(i), e.isZero())
    Se = r ? 3 : 2;
  else {
    if (t = t.minus(e.times(i)), t.lte(s))
      return Se = as(e) ? r ? 2 : 3 : r ? 4 : 1, t;
    Se = as(e) ? r ? 1 : 4 : r ? 3 : 2;
  }
  return t.minus(i).abs();
}
function Ti(n, t, e, r) {
  var i, s, o, f, c, d, h, v, x, N = n.constructor, _ = e !== void 0;
  if (_ ? (re(e, 1, Qe), r === void 0 ? r = N.rounding : re(r, 0, 8)) : (e = N.precision, r = N.rounding), !n.isFinite())
    h = js(n);
  else {
    for (h = Ne(n), o = h.indexOf("."), _ ? (i = 2, t == 16 ? e = e * 4 - 3 : t == 8 && (e = e * 3 - 2)) : i = t, o >= 0 && (h = h.replace(".", ""), x = new N(1), x.e = h.length - o, x.d = ir(Ne(x), 10, i), x.e = x.d.length), v = ir(h, 10, i), s = c = v.length; v[--c] == 0; ) v.pop();
    if (!v[0])
      h = _ ? "0p+0" : "0";
    else {
      if (o < 0 ? s-- : (n = new N(n), n.d = v, n.e = s, n = Y(n, x, e, r, 0, i), v = n.d, s = n.e, d = qs), o = v[e], f = i / 2, d = d || v[e + 1] !== void 0, d = r < 4 ? (o !== void 0 || d) && (r === 0 || r === (n.s < 0 ? 3 : 2)) : o > f || o === f && (r === 4 || d || r === 6 && v[e - 1] & 1 || r === (n.s < 0 ? 8 : 7)), v.length = e, d)
        for (; ++v[--e] > i - 1; )
          v[e] = 0, e || (++s, v.unshift(1));
      for (c = v.length; !v[c - 1]; --c) ;
      for (o = 0, h = ""; o < c; o++) h += ni.charAt(v[o]);
      if (_) {
        if (c > 1)
          if (t == 16 || t == 8) {
            for (o = t == 16 ? 4 : 3, --c; c % o; c++) h += "0";
            for (v = ir(h, i, t), c = v.length; !v[c - 1]; --c) ;
            for (o = 1, h = "1."; o < c; o++) h += ni.charAt(v[o]);
          } else
            h = h.charAt(0) + "." + h.slice(1);
        h = h + (s < 0 ? "p" : "p+") + s;
      } else if (s < 0) {
        for (; ++s; ) h = "0" + h;
        h = "0." + h;
      } else if (++s > c) for (s -= c; s--; ) h += "0";
      else s < c && (h = h.slice(0, s) + "." + h.slice(s));
    }
    h = (t == 16 ? "0x" : t == 2 ? "0b" : t == 8 ? "0o" : "") + h;
  }
  return n.s < 0 ? "-" + h : h;
}
function os(n, t) {
  if (n.length > t)
    return n.length = t, !0;
}
function Mo(n) {
  return new this(n).abs();
}
function Eo(n) {
  return new this(n).acos();
}
function No(n) {
  return new this(n).acosh();
}
function Ao(n, t) {
  return new this(n).plus(t);
}
function Io(n) {
  return new this(n).asin();
}
function Ro(n) {
  return new this(n).asinh();
}
function ko(n) {
  return new this(n).atan();
}
function Oo(n) {
  return new this(n).atanh();
}
function _o(n, t) {
  n = new this(n), t = new this(t);
  var e, r = this.precision, i = this.rounding, s = r + 4;
  return !n.s || !t.s ? e = new this(NaN) : !n.d && !t.d ? (e = he(this, s, 1).times(t.s > 0 ? 0.25 : 0.75), e.s = n.s) : !t.d || n.isZero() ? (e = t.s < 0 ? he(this, r, i) : new this(0), e.s = n.s) : !n.d || t.isZero() ? (e = he(this, s, 1).times(0.5), e.s = n.s) : t.s < 0 ? (this.precision = s, this.rounding = 1, e = this.atan(Y(n, t, s, 1)), t = he(this, s, 1), this.precision = r, this.rounding = i, e = n.s < 0 ? e.minus(t) : e.plus(t)) : e = this.atan(Y(n, t, s, 1)), e;
}
function So(n) {
  return new this(n).cbrt();
}
function Po(n) {
  return P(n = new this(n), n.e + 1, 2);
}
function Uo(n, t, e) {
  return new this(n).clamp(t, e);
}
function Bo(n) {
  if (!n || typeof n != "object") throw Error(gr + "Object expected");
  var t, e, r, i = n.defaults === !0, s = [
    "precision",
    1,
    Qe,
    "rounding",
    0,
    8,
    "toExpNeg",
    -bn,
    0,
    "toExpPos",
    0,
    bn,
    "maxE",
    0,
    bn,
    "minE",
    -bn,
    0,
    "modulo",
    0,
    9
  ];
  for (t = 0; t < s.length; t += 3)
    if (e = s[t], i && (this[e] = ri[e]), (r = n[e]) !== void 0)
      if (Xt(r) === r && r >= s[t + 1] && r <= s[t + 2]) this[e] = r;
      else throw Error(Je + e + ": " + r);
  if (e = "crypto", i && (this[e] = ri[e]), (r = n[e]) !== void 0)
    if (r === !0 || r === !1 || r === 0 || r === 1)
      if (r)
        if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
          this[e] = !0;
        else
          throw Error(Ks);
      else
        this[e] = !1;
    else
      throw Error(Je + e + ": " + r);
  return this;
}
function Co(n) {
  return new this(n).cos();
}
function Fo(n) {
  return new this(n).cosh();
}
function ea(n) {
  var t, e, r;
  function i(s) {
    var o, f, c, d = this;
    if (!(d instanceof i)) return new i(s);
    if (d.constructor = i, us(s)) {
      d.s = s.s, F ? !s.d || s.e > i.maxE ? (d.e = NaN, d.d = null) : s.e < i.minE ? (d.e = 0, d.d = [0]) : (d.e = s.e, d.d = s.d.slice()) : (d.e = s.e, d.d = s.d ? s.d.slice() : s.d);
      return;
    }
    if (c = typeof s, c === "number") {
      if (s === 0) {
        d.s = 1 / s < 0 ? -1 : 1, d.e = 0, d.d = [0];
        return;
      }
      if (s < 0 ? (s = -s, d.s = -1) : d.s = 1, s === ~~s && s < 1e7) {
        for (o = 0, f = s; f >= 10; f /= 10) o++;
        F ? o > i.maxE ? (d.e = NaN, d.d = null) : o < i.minE ? (d.e = 0, d.d = [0]) : (d.e = o, d.d = [s]) : (d.e = o, d.d = [s]);
        return;
      } else if (s * 0 !== 0) {
        s || (d.s = NaN), d.e = NaN, d.d = null;
        return;
      }
      return ai(d, s.toString());
    } else if (c !== "string")
      throw Error(Je + s);
    return (f = s.charCodeAt(0)) === 45 ? (s = s.slice(1), d.s = -1) : (f === 43 && (s = s.slice(1)), d.s = 1), Js.test(s) ? ai(d, s) : To(d, s);
  }
  if (i.prototype = A, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.EUCLID = 9, i.config = i.set = Bo, i.clone = ea, i.isDecimal = us, i.abs = Mo, i.acos = Eo, i.acosh = No, i.add = Ao, i.asin = Io, i.asinh = Ro, i.atan = ko, i.atanh = Oo, i.atan2 = _o, i.cbrt = So, i.ceil = Po, i.clamp = Uo, i.cos = Co, i.cosh = Fo, i.div = Lo, i.exp = Do, i.floor = $o, i.hypot = Go, i.ln = Ho, i.log = Vo, i.log10 = qo, i.log2 = zo, i.max = Zo, i.min = Ko, i.mod = Wo, i.mul = Jo, i.pow = Xo, i.random = Yo, i.round = Qo, i.sign = jo, i.sin = tu, i.sinh = eu, i.sqrt = nu, i.sub = ru, i.sum = iu, i.tan = su, i.tanh = au, i.trunc = ou, n === void 0 && (n = {}), n && n.defaults !== !0)
    for (r = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], t = 0; t < r.length; ) n.hasOwnProperty(e = r[t++]) || (n[e] = this[e]);
  return i.config(n), i;
}
function Lo(n, t) {
  return new this(n).div(t);
}
function Do(n) {
  return new this(n).exp();
}
function $o(n) {
  return P(n = new this(n), n.e + 1, 3);
}
function Go() {
  var n, t, e = new this(0);
  for (F = !1, n = 0; n < arguments.length; )
    if (t = new this(arguments[n++]), t.d)
      e.d && (e = e.plus(t.times(t)));
    else {
      if (t.s)
        return F = !0, new this(1 / 0);
      e = t;
    }
  return F = !0, e.sqrt();
}
function us(n) {
  return n instanceof _n || n && n.toStringTag === Ws || !1;
}
function Ho(n) {
  return new this(n).ln();
}
function Vo(n, t) {
  return new this(n).log(t);
}
function zo(n) {
  return new this(n).log(2);
}
function qo(n) {
  return new this(n).log(10);
}
function Zo() {
  return Qs(this, arguments, "lt");
}
function Ko() {
  return Qs(this, arguments, "gt");
}
function Wo(n, t) {
  return new this(n).mod(t);
}
function Jo(n, t) {
  return new this(n).mul(t);
}
function Xo(n, t) {
  return new this(n).pow(t);
}
function Yo(n) {
  var t, e, r, i, s = 0, o = new this(1), f = [];
  if (n === void 0 ? n = this.precision : re(n, 1, Qe), r = Math.ceil(n / B), this.crypto)
    if (crypto.getRandomValues)
      for (t = crypto.getRandomValues(new Uint32Array(r)); s < r; )
        i = t[s], i >= 429e7 ? t[s] = crypto.getRandomValues(new Uint32Array(1))[0] : f[s++] = i % 1e7;
    else if (crypto.randomBytes) {
      for (t = crypto.randomBytes(r *= 4); s < r; )
        i = t[s] + (t[s + 1] << 8) + (t[s + 2] << 16) + ((t[s + 3] & 127) << 24), i >= 214e7 ? crypto.randomBytes(4).copy(t, s) : (f.push(i % 1e7), s += 4);
      s = r / 4;
    } else
      throw Error(Ks);
  else for (; s < r; ) f[s++] = Math.random() * 1e7 | 0;
  for (r = f[--s], n %= B, r && n && (i = Gt(10, B - n), f[s] = (r / i | 0) * i); f[s] === 0; s--) f.pop();
  if (s < 0)
    e = 0, f = [0];
  else {
    for (e = -1; f[0] === 0; e -= B) f.shift();
    for (r = 1, i = f[0]; i >= 10; i /= 10) r++;
    r < B && (e -= B - r);
  }
  return o.e = e, o.d = f, o;
}
function Qo(n) {
  return P(n = new this(n), n.e + 1, this.rounding);
}
function jo(n) {
  return n = new this(n), n.d ? n.d[0] ? n.s : 0 * n.s : n.s || NaN;
}
function tu(n) {
  return new this(n).sin();
}
function eu(n) {
  return new this(n).sinh();
}
function nu(n) {
  return new this(n).sqrt();
}
function ru(n, t) {
  return new this(n).sub(t);
}
function iu() {
  var n = 0, t = arguments, e = new this(t[n]);
  for (F = !1; e.s && ++n < t.length; ) e = e.plus(t[n]);
  return F = !0, P(e, this.precision, this.rounding);
}
function su(n) {
  return new this(n).tan();
}
function au(n) {
  return new this(n).tanh();
}
function ou(n) {
  return P(n = new this(n), n.e + 1, 1);
}
A[Symbol.for("nodejs.util.inspect.custom")] = A.toString;
A[Symbol.toStringTag] = "Decimal";
var _n = A.constructor = ea(ri);
fr = new _n(fr);
cr = new _n(cr);
function na(n, t, e) {
  if (n instanceof Uint8Array)
    return e ? new Uint8Array(n) : n;
  if (typeof n == "string" && n.match(/^0x(?:[0-9a-f][0-9a-f])*$/i)) {
    const r = new Uint8Array((n.length - 2) / 2);
    let i = 2;
    for (let s = 0; s < r.length; s++)
      r[s] = parseInt(n.substring(i, i + 2), 16), i += 2;
    return r;
  }
  R(!1, "invalid BytesLike value", t || "value", n);
}
function Ce(n, t) {
  return na(n, t, !1);
}
function Me(n, t) {
  return na(n, t, !0);
}
function Pe(n, t) {
  return !(typeof n != "string" || !n.match(/^0x[0-9A-Fa-f]*$/) || typeof t == "number" && n.length !== 2 + 2 * t || t === !0 && n.length % 2 !== 0);
}
function uu(n) {
  return Pe(n, !0) || n instanceof Uint8Array;
}
const ls = "0123456789abcdef";
function Ht(n) {
  const t = Ce(n);
  let e = "0x";
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    e += ls[(i & 240) >> 4] + ls[i & 15];
  }
  return e;
}
function Mn(n) {
  return "0x" + n.map((t) => Ht(t).substring(2)).join("");
}
function yn(n, t, e) {
  const r = Ce(n);
  return e != null && e > r.length && $(!1, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
    buffer: r,
    length: r.length,
    offset: e
  }), Ht(r.slice(t ?? 0, e ?? r.length));
}
function ra(n, t, e) {
  const r = Ce(n);
  $(t >= r.length, "padding exceeds data length", "BUFFER_OVERRUN", {
    buffer: new Uint8Array(r),
    length: t,
    offset: t + 1
  });
  const i = new Uint8Array(t);
  return i.fill(0), e ? i.set(r, t - r.length) : i.set(r, 0), Ht(i);
}
function lu(n, t) {
  return ra(n, t, !0);
}
function fu(n, t) {
  return ra(n, t, !1);
}
const vr = BigInt(0), pe = BigInt(1), vn = 9007199254740991;
function cu(n, t) {
  const e = Tr(n, "value"), r = BigInt(Le(t, "width"));
  if ($(e >> r === vr, "overflow", "NUMERIC_FAULT", {
    operation: "fromTwos",
    fault: "overflow",
    value: n
  }), e >> r - pe) {
    const i = (pe << r) - pe;
    return -((~e & i) + pe);
  }
  return e;
}
function du(n, t) {
  let e = je(n, "value");
  const r = BigInt(Le(t, "width")), i = pe << r - pe;
  if (e < vr) {
    e = -e, $(e <= i, "too low", "NUMERIC_FAULT", {
      operation: "toTwos",
      fault: "overflow",
      value: n
    });
    const s = (pe << r) - pe;
    return (~e & s) + pe;
  } else
    $(e < i, "too high", "NUMERIC_FAULT", {
      operation: "toTwos",
      fault: "overflow",
      value: n
    });
  return e;
}
function Xn(n, t) {
  const e = Tr(n, "value"), r = BigInt(Le(t, "bits"));
  return e & (pe << r) - pe;
}
function je(n, t) {
  switch (typeof n) {
    case "bigint":
      return n;
    case "number":
      return R(Number.isInteger(n), "underflow", t || "value", n), R(n >= -vn && n <= vn, "overflow", t || "value", n), BigInt(n);
    case "string":
      try {
        if (n === "")
          throw new Error("empty string");
        return n[0] === "-" && n[1] !== "-" ? -BigInt(n.substring(1)) : BigInt(n);
      } catch (e) {
        R(!1, `invalid BigNumberish string: ${e.message}`, t || "value", n);
      }
  }
  R(!1, "invalid BigNumberish value", t || "value", n);
}
function Tr(n, t) {
  const e = je(n, t);
  return $(e >= vr, "unsigned value cannot be negative", "NUMERIC_FAULT", {
    fault: "overflow",
    operation: "getUint",
    value: n
  }), e;
}
const fs = "0123456789abcdef";
function ia(n) {
  if (n instanceof Uint8Array) {
    let t = "0x0";
    for (const e of n)
      t += fs[e >> 4], t += fs[e & 15];
    return BigInt(t);
  }
  return je(n);
}
function Le(n, t) {
  switch (typeof n) {
    case "bigint":
      return R(n >= -vn && n <= vn, "overflow", t || "value", n), Number(n);
    case "number":
      return R(Number.isInteger(n), "underflow", t || "value", n), R(n >= -vn && n <= vn, "overflow", t || "value", n), n;
    case "string":
      try {
        if (n === "")
          throw new Error("empty string");
        return Le(BigInt(n), t);
      } catch (e) {
        R(!1, `invalid numeric string: ${e.message}`, t || "value", n);
      }
  }
  R(!1, "invalid numeric value", t || "value", n);
}
function pu(n) {
  return Le(ia(n));
}
function sa(n, t) {
  let r = Tr(n, "value").toString(16);
  if (t == null)
    r.length % 2 && (r = "0" + r);
  else {
    const i = Le(t, "width");
    for ($(i * 2 >= r.length, `value exceeds width (${i} bytes)`, "NUMERIC_FAULT", {
      operation: "toBeHex",
      fault: "overflow",
      value: n
    }); r.length < i * 2; )
      r = "0" + r;
  }
  return "0x" + r;
}
function hu(n) {
  const t = Tr(n, "value");
  if (t === vr)
    return new Uint8Array([]);
  let e = t.toString(16);
  e.length % 2 && (e = "0" + e);
  const r = new Uint8Array(e.length / 2);
  for (let i = 0; i < r.length; i++) {
    const s = i * 2;
    r[i] = parseInt(e.substring(s, s + 2), 16);
  }
  return r;
}
var En;
class mu {
  /**
   *  Create a new **EventPayload** for %%emitter%% with
   *  the %%listener%% and for %%filter%%.
   */
  constructor(t, e, r) {
    /**
     *  The event filter.
     */
    E(this, "filter");
    /**
     *  The **EventEmitterable**.
     */
    E(this, "emitter");
    X(this, En);
    K(this, En, e), z(this, { emitter: t, filter: r });
  }
  /**
   *  Unregister the triggered listener for future events.
   */
  async removeListener() {
    I(this, En) != null && await this.emitter.off(this.filter, I(this, En));
  }
}
En = new WeakMap();
function yu(n, t, e, r, i) {
  R(!1, `invalid codepoint at offset ${t}; ${n}`, "bytes", e);
}
function aa(n, t, e, r, i) {
  if (n === "BAD_PREFIX" || n === "UNEXPECTED_CONTINUE") {
    let s = 0;
    for (let o = t + 1; o < e.length && e[o] >> 6 === 2; o++)
      s++;
    return s;
  }
  return n === "OVERRUN" ? e.length - t - 1 : 0;
}
function gu(n, t, e, r, i) {
  return n === "OVERLONG" ? (R(typeof i == "number", "invalid bad code point for replacement", "badCodepoint", i), r.push(i), 0) : (r.push(65533), aa(n, t, e));
}
const wu = Object.freeze({
  error: yu,
  ignore: aa,
  replace: gu
});
function bu(n, t) {
  t == null && (t = wu.error);
  const e = Ce(n, "bytes"), r = [];
  let i = 0;
  for (; i < e.length; ) {
    const s = e[i++];
    if (!(s >> 7)) {
      r.push(s);
      continue;
    }
    let o = null, f = null;
    if ((s & 224) === 192)
      o = 1, f = 127;
    else if ((s & 240) === 224)
      o = 2, f = 2047;
    else if ((s & 248) === 240)
      o = 3, f = 65535;
    else {
      (s & 192) === 128 ? i += t("UNEXPECTED_CONTINUE", i - 1, e, r) : i += t("BAD_PREFIX", i - 1, e, r);
      continue;
    }
    if (i - 1 + o >= e.length) {
      i += t("OVERRUN", i - 1, e, r);
      continue;
    }
    let c = s & (1 << 8 - o - 1) - 1;
    for (let d = 0; d < o; d++) {
      let h = e[i];
      if ((h & 192) != 128) {
        i += t("MISSING_CONTINUE", i, e, r), c = null;
        break;
      }
      c = c << 6 | h & 63, i++;
    }
    if (c !== null) {
      if (c > 1114111) {
        i += t("OUT_OF_RANGE", i - 1 - o, e, r, c);
        continue;
      }
      if (c >= 55296 && c <= 57343) {
        i += t("UTF16_SURROGATE", i - 1 - o, e, r, c);
        continue;
      }
      if (c <= f) {
        i += t("OVERLONG", i - 1 - o, e, r, c);
        continue;
      }
      r.push(c);
    }
  }
  return r;
}
function oa(n, t) {
  R(typeof n == "string", "invalid string value", "str", n);
  let e = [];
  for (let r = 0; r < n.length; r++) {
    const i = n.charCodeAt(r);
    if (i < 128)
      e.push(i);
    else if (i < 2048)
      e.push(i >> 6 | 192), e.push(i & 63 | 128);
    else if ((i & 64512) == 55296) {
      r++;
      const s = n.charCodeAt(r);
      R(r < n.length && (s & 64512) === 56320, "invalid surrogate pair", "str", n);
      const o = 65536 + ((i & 1023) << 10) + (s & 1023);
      e.push(o >> 18 | 240), e.push(o >> 12 & 63 | 128), e.push(o >> 6 & 63 | 128), e.push(o & 63 | 128);
    } else
      e.push(i >> 12 | 224), e.push(i >> 6 & 63 | 128), e.push(i & 63 | 128);
  }
  return new Uint8Array(e);
}
function vu(n) {
  return n.map((t) => t <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode((t >> 10 & 1023) + 55296, (t & 1023) + 56320))).join("");
}
function Tu(n, t) {
  return vu(bu(n, t));
}
const Qt = 32, oi = new Uint8Array(Qt), xu = ["then"], Yn = {}, ua = /* @__PURE__ */ new WeakMap();
function rn(n) {
  return ua.get(n);
}
function cs(n, t) {
  ua.set(n, t);
}
function Pn(n, t) {
  const e = new Error(`deferred error during ABI decoding triggered accessing ${n}`);
  throw e.error = t, e;
}
function ui(n, t, e) {
  return n.indexOf(null) >= 0 ? t.map((r, i) => r instanceof Sn ? ui(rn(r), r, e) : r) : n.reduce((r, i, s) => {
    let o = t.getValue(i);
    return i in r || (e && o instanceof Sn && (o = ui(rn(o), o, e)), r[i] = o), r;
  }, {});
}
var Nn;
const Tn = class Tn extends Array {
  /**
   *  @private
   */
  constructor(...e) {
    const r = e[0];
    let i = e[1], s = (e[2] || []).slice(), o = !0;
    r !== Yn && (i = e, s = [], o = !1);
    super(i.length);
    // No longer used; but cannot be removed as it will remove the
    // #private field from the .d.ts which may break backwards
    // compatibility
    X(this, Nn);
    i.forEach((d, h) => {
      this[h] = d;
    });
    const f = s.reduce((d, h) => (typeof h == "string" && d.set(h, (d.get(h) || 0) + 1), d), /* @__PURE__ */ new Map());
    if (cs(this, Object.freeze(i.map((d, h) => {
      const v = s[h];
      return v != null && f.get(v) === 1 ? v : null;
    }))), K(this, Nn, []), I(this, Nn) == null && I(this, Nn), !o)
      return;
    Object.freeze(this);
    const c = new Proxy(this, {
      get: (d, h, v) => {
        if (typeof h == "string") {
          if (h.match(/^[0-9]+$/)) {
            const N = Le(h, "%index");
            if (N < 0 || N >= this.length)
              throw new RangeError("out of result range");
            const _ = d[N];
            return _ instanceof Error && Pn(`index ${N}`, _), _;
          }
          if (xu.indexOf(h) >= 0)
            return Reflect.get(d, h, v);
          const x = d[h];
          if (x instanceof Function)
            return function(...N) {
              return x.apply(this === v ? d : this, N);
            };
          if (!(h in d))
            return d.getValue.apply(this === v ? d : this, [h]);
        }
        return Reflect.get(d, h, v);
      }
    });
    return cs(c, rn(this)), c;
  }
  /**
   *  Returns the Result as a normal Array. If %%deep%%, any children
   *  which are Result objects are also converted to a normal Array.
   *
   *  This will throw if there are any outstanding deferred
   *  errors.
   */
  toArray(e) {
    const r = [];
    return this.forEach((i, s) => {
      i instanceof Error && Pn(`index ${s}`, i), e && i instanceof Tn && (i = i.toArray(e)), r.push(i);
    }), r;
  }
  /**
   *  Returns the Result as an Object with each name-value pair. If
   *  %%deep%%, any children which are Result objects are also
   *  converted to an Object.
   *
   *  This will throw if any value is unnamed, or if there are
   *  any outstanding deferred errors.
   */
  toObject(e) {
    const r = rn(this);
    return r.reduce((i, s, o) => ($(s != null, `value at index ${o} unnamed`, "UNSUPPORTED_OPERATION", {
      operation: "toObject()"
    }), ui(r, this, e)), {});
  }
  /**
   *  @_ignore
   */
  slice(e, r) {
    e == null && (e = 0), e < 0 && (e += this.length, e < 0 && (e = 0)), r == null && (r = this.length), r < 0 && (r += this.length, r < 0 && (r = 0)), r > this.length && (r = this.length);
    const i = rn(this), s = [], o = [];
    for (let f = e; f < r; f++)
      s.push(this[f]), o.push(i[f]);
    return new Tn(Yn, s, o);
  }
  /**
   *  @_ignore
   */
  filter(e, r) {
    const i = rn(this), s = [], o = [];
    for (let f = 0; f < this.length; f++) {
      const c = this[f];
      c instanceof Error && Pn(`index ${f}`, c), e.call(r, c, f, this) && (s.push(c), o.push(i[f]));
    }
    return new Tn(Yn, s, o);
  }
  /**
   *  @_ignore
   */
  map(e, r) {
    const i = [];
    for (let s = 0; s < this.length; s++) {
      const o = this[s];
      o instanceof Error && Pn(`index ${s}`, o), i.push(e.call(r, o, s, this));
    }
    return i;
  }
  /**
   *  Returns the value for %%name%%.
   *
   *  Since it is possible to have a key whose name conflicts with
   *  a method on a [[Result]] or its superclass Array, or any
   *  JavaScript keyword, this ensures all named values are still
   *  accessible by name.
   */
  getValue(e) {
    const r = rn(this).indexOf(e);
    if (r === -1)
      return;
    const i = this[r];
    return i instanceof Error && Pn(`property ${JSON.stringify(e)}`, i.error), i;
  }
  /**
   *  Creates a new [[Result]] for %%items%% with each entry
   *  also accessible by its corresponding name in %%keys%%.
   */
  static fromItems(e, r) {
    return new Tn(Yn, e, r);
  }
};
Nn = new WeakMap();
let Sn = Tn;
function ds(n) {
  let t = hu(n);
  return $(t.length <= Qt, "value out-of-bounds", "BUFFER_OVERRUN", { buffer: t, length: Qt, offset: t.length }), t.length !== Qt && (t = Me(Mn([oi.slice(t.length % Qt), t]))), t;
}
class De {
  constructor(t, e, r, i) {
    // The coder name:
    //   - address, uint256, tuple, array, etc.
    E(this, "name");
    // The fully expanded type, including composite types:
    //   - address, uint256, tuple(address,bytes), uint256[3][4][],  etc.
    E(this, "type");
    // The localName bound in the signature, in this example it is "baz":
    //   - tuple(address foo, uint bar) baz
    E(this, "localName");
    // Whether this type is dynamic:
    //  - Dynamic: bytes, string, address[], tuple(boolean[]), etc.
    //  - Not Dynamic: address, uint256, boolean[3], tuple(address, uint8)
    E(this, "dynamic");
    z(this, { name: t, type: e, localName: r, dynamic: i }, {
      name: "string",
      type: "string",
      localName: "string",
      dynamic: "boolean"
    });
  }
  _throwError(t, e) {
    R(!1, t, this.localName, e);
  }
}
var _e, on, An, sr;
class li {
  constructor() {
    X(this, An);
    // An array of WordSize lengthed objects to concatenation
    X(this, _e);
    X(this, on);
    K(this, _e, []), K(this, on, 0);
  }
  get data() {
    return Mn(I(this, _e));
  }
  get length() {
    return I(this, on);
  }
  appendWriter(t) {
    return tt(this, An, sr).call(this, Me(t.data));
  }
  // Arrayish item; pad on the right to *nearest* WordSize
  writeBytes(t) {
    let e = Me(t);
    const r = e.length % Qt;
    return r && (e = Me(Mn([e, oi.slice(r)]))), tt(this, An, sr).call(this, e);
  }
  // Numeric item; pad on the left *to* WordSize
  writeValue(t) {
    return tt(this, An, sr).call(this, ds(t));
  }
  // Inserts a numeric place-holder, returning a callback that can
  // be used to asjust the value later
  writeUpdatableValue() {
    const t = I(this, _e).length;
    return I(this, _e).push(oi), K(this, on, I(this, on) + Qt), (e) => {
      I(this, _e)[t] = ds(e);
    };
  }
}
_e = new WeakMap(), on = new WeakMap(), An = new WeakSet(), sr = function(t) {
  return I(this, _e).push(t), K(this, on, I(this, on) + t.length), t.length;
};
var ee, ae, un, ln, ze, mn, ci, la;
const Ii = class Ii {
  constructor(t, e, r) {
    X(this, mn);
    // Allows incomplete unpadded data to be read; otherwise an error
    // is raised if attempting to overrun the buffer. This is required
    // to deal with an old Solidity bug, in which event data for
    // external (not public thoguh) was tightly packed.
    E(this, "allowLoose");
    X(this, ee);
    X(this, ae);
    X(this, un);
    X(this, ln);
    X(this, ze);
    z(this, { allowLoose: !!e }), K(this, ee, Me(t)), K(this, un, 0), K(this, ln, null), K(this, ze, r ?? 1024), K(this, ae, 0);
  }
  get data() {
    return Ht(I(this, ee));
  }
  get dataLength() {
    return I(this, ee).length;
  }
  get consumed() {
    return I(this, ae);
  }
  get bytes() {
    return new Uint8Array(I(this, ee));
  }
  // Create a sub-reader with the same underlying data, but offset
  subReader(t) {
    const e = new Ii(I(this, ee).slice(I(this, ae) + t), this.allowLoose, I(this, ze));
    return K(e, ln, this), e;
  }
  // Read bytes
  readBytes(t, e) {
    let r = tt(this, mn, la).call(this, 0, t, !!e);
    return tt(this, mn, ci).call(this, t), K(this, ae, I(this, ae) + r.length), r.slice(0, t);
  }
  // Read a numeric values
  readValue() {
    return ia(this.readBytes(Qt));
  }
  readIndex() {
    return pu(this.readBytes(Qt));
  }
};
ee = new WeakMap(), ae = new WeakMap(), un = new WeakMap(), ln = new WeakMap(), ze = new WeakMap(), mn = new WeakSet(), ci = function(t) {
  var e;
  if (I(this, ln))
    return tt(e = I(this, ln), mn, ci).call(e, t);
  K(this, un, I(this, un) + t), $(I(this, ze) < 1 || I(this, un) <= I(this, ze) * this.dataLength, `compressed ABI data exceeds inflation ratio of ${I(this, ze)} ( see: https://github.com/ethers-io/ethers.js/issues/4537 )`, "BUFFER_OVERRUN", {
    buffer: Me(I(this, ee)),
    offset: I(this, ae),
    length: t,
    info: {
      bytesRead: I(this, un),
      dataLength: this.dataLength
    }
  });
}, la = function(t, e, r) {
  let i = Math.ceil(e / Qt) * Qt;
  return I(this, ae) + i > I(this, ee).length && (this.allowLoose && r && I(this, ae) + e <= I(this, ee).length ? i = e : $(!1, "data out-of-bounds", "BUFFER_OVERRUN", {
    buffer: Me(I(this, ee)),
    length: I(this, ee).length,
    offset: I(this, ae) + i
  })), I(this, ee).slice(I(this, ae), I(this, ae) + i);
};
let fi = Ii;
function ps(n) {
  if (!Number.isSafeInteger(n) || n < 0)
    throw new Error(`Wrong positive integer: ${n}`);
}
function fa(n, ...t) {
  if (!(n instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (t.length > 0 && !t.includes(n.length))
    throw new Error(`Expected Uint8Array of length ${t}, not of length=${n.length}`);
}
function hs(n, t = !0) {
  if (n.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && n.finished)
    throw new Error("Hash#digest() has already been called");
}
function Mu(n, t) {
  fa(n);
  const e = t.outputLen;
  if (n.length < e)
    throw new Error(`digestInto() expects output buffer of length at least ${e}`);
}
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Eu = (n) => n instanceof Uint8Array, Nu = (n) => new Uint32Array(n.buffer, n.byteOffset, Math.floor(n.byteLength / 4)), Au = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!Au)
  throw new Error("Non little-endian hardware is not supported");
function Iu(n) {
  if (typeof n != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof n}`);
  return new Uint8Array(new TextEncoder().encode(n));
}
function ca(n) {
  if (typeof n == "string" && (n = Iu(n)), !Eu(n))
    throw new Error(`expected Uint8Array, got ${typeof n}`);
  return n;
}
class Ru {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function ku(n) {
  const t = (r) => n().update(ca(r)).digest(), e = n();
  return t.outputLen = e.outputLen, t.blockLen = e.blockLen, t.create = () => n(), t;
}
const Qn = /* @__PURE__ */ BigInt(2 ** 32 - 1), ms = /* @__PURE__ */ BigInt(32);
function Ou(n, t = !1) {
  return t ? { h: Number(n & Qn), l: Number(n >> ms & Qn) } : { h: Number(n >> ms & Qn) | 0, l: Number(n & Qn) | 0 };
}
function _u(n, t = !1) {
  let e = new Uint32Array(n.length), r = new Uint32Array(n.length);
  for (let i = 0; i < n.length; i++) {
    const { h: s, l: o } = Ou(n[i], t);
    [e[i], r[i]] = [s, o];
  }
  return [e, r];
}
const Su = (n, t, e) => n << e | t >>> 32 - e, Pu = (n, t, e) => t << e | n >>> 32 - e, Uu = (n, t, e) => t << e - 32 | n >>> 64 - e, Bu = (n, t, e) => n << e - 32 | t >>> 64 - e, [da, pa, ha] = [[], [], []], Cu = /* @__PURE__ */ BigInt(0), Un = /* @__PURE__ */ BigInt(1), Fu = /* @__PURE__ */ BigInt(2), Lu = /* @__PURE__ */ BigInt(7), Du = /* @__PURE__ */ BigInt(256), $u = /* @__PURE__ */ BigInt(113);
for (let n = 0, t = Un, e = 1, r = 0; n < 24; n++) {
  [e, r] = [r, (2 * e + 3 * r) % 5], da.push(2 * (5 * r + e)), pa.push((n + 1) * (n + 2) / 2 % 64);
  let i = Cu;
  for (let s = 0; s < 7; s++)
    t = (t << Un ^ (t >> Lu) * $u) % Du, t & Fu && (i ^= Un << (Un << /* @__PURE__ */ BigInt(s)) - Un);
  ha.push(i);
}
const [Gu, Hu] = /* @__PURE__ */ _u(ha, !0), ys = (n, t, e) => e > 32 ? Uu(n, t, e) : Su(n, t, e), gs = (n, t, e) => e > 32 ? Bu(n, t, e) : Pu(n, t, e);
function Vu(n, t = 24) {
  const e = new Uint32Array(10);
  for (let r = 24 - t; r < 24; r++) {
    for (let o = 0; o < 10; o++)
      e[o] = n[o] ^ n[o + 10] ^ n[o + 20] ^ n[o + 30] ^ n[o + 40];
    for (let o = 0; o < 10; o += 2) {
      const f = (o + 8) % 10, c = (o + 2) % 10, d = e[c], h = e[c + 1], v = ys(d, h, 1) ^ e[f], x = gs(d, h, 1) ^ e[f + 1];
      for (let N = 0; N < 50; N += 10)
        n[o + N] ^= v, n[o + N + 1] ^= x;
    }
    let i = n[2], s = n[3];
    for (let o = 0; o < 24; o++) {
      const f = pa[o], c = ys(i, s, f), d = gs(i, s, f), h = da[o];
      i = n[h], s = n[h + 1], n[h] = c, n[h + 1] = d;
    }
    for (let o = 0; o < 50; o += 10) {
      for (let f = 0; f < 10; f++)
        e[f] = n[o + f];
      for (let f = 0; f < 10; f++)
        n[o + f] ^= ~e[(f + 2) % 10] & e[(f + 4) % 10];
    }
    n[0] ^= Gu[r], n[1] ^= Hu[r];
  }
  e.fill(0);
}
class xi extends Ru {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(t, e, r, i = !1, s = 24) {
    if (super(), this.blockLen = t, this.suffix = e, this.outputLen = r, this.enableXOF = i, this.rounds = s, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, ps(r), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = Nu(this.state);
  }
  keccak() {
    Vu(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(t) {
    hs(this);
    const { blockLen: e, state: r } = this;
    t = ca(t);
    const i = t.length;
    for (let s = 0; s < i; ) {
      const o = Math.min(e - this.pos, i - s);
      for (let f = 0; f < o; f++)
        r[this.pos++] ^= t[s++];
      this.pos === e && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: t, suffix: e, pos: r, blockLen: i } = this;
    t[r] ^= e, e & 128 && r === i - 1 && this.keccak(), t[i - 1] ^= 128, this.keccak();
  }
  writeInto(t) {
    hs(this, !1), fa(t), this.finish();
    const e = this.state, { blockLen: r } = this;
    for (let i = 0, s = t.length; i < s; ) {
      this.posOut >= r && this.keccak();
      const o = Math.min(r - this.posOut, s - i);
      t.set(e.subarray(this.posOut, this.posOut + o), i), this.posOut += o, i += o;
    }
    return t;
  }
  xofInto(t) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(t);
  }
  xof(t) {
    return ps(t), this.xofInto(new Uint8Array(t));
  }
  digestInto(t) {
    if (Mu(t, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(t), this.destroy(), t;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(t) {
    const { blockLen: e, suffix: r, outputLen: i, rounds: s, enableXOF: o } = this;
    return t || (t = new xi(e, r, i, o, s)), t.state32.set(this.state32), t.pos = this.pos, t.posOut = this.posOut, t.finished = this.finished, t.rounds = s, t.suffix = r, t.outputLen = i, t.enableXOF = o, t.destroyed = this.destroyed, t;
  }
}
const zu = (n, t, e) => ku(() => new xi(t, n, e)), qu = /* @__PURE__ */ zu(1, 136, 256 / 8);
let ma = !1;
const ya = function(n) {
  return qu(n);
};
let ga = ya;
function Xe(n) {
  const t = Ce(n, "data");
  return Ht(ga(t));
}
Xe._ = ya;
Xe.lock = function() {
  ma = !0;
};
Xe.register = function(n) {
  if (ma)
    throw new TypeError("keccak256 is locked");
  ga = n;
};
Object.freeze(Xe);
const Zu = BigInt(0), Ku = BigInt(36);
function ws(n) {
  n = n.toLowerCase();
  const t = n.substring(2).split(""), e = new Uint8Array(40);
  for (let i = 0; i < 40; i++)
    e[i] = t[i].charCodeAt(0);
  const r = Ce(Xe(e));
  for (let i = 0; i < 40; i += 2)
    r[i >> 1] >> 4 >= 8 && (t[i] = t[i].toUpperCase()), (r[i >> 1] & 15) >= 8 && (t[i + 1] = t[i + 1].toUpperCase());
  return "0x" + t.join("");
}
const Mi = {};
for (let n = 0; n < 10; n++)
  Mi[String(n)] = String(n);
for (let n = 0; n < 26; n++)
  Mi[String.fromCharCode(65 + n)] = String(10 + n);
const bs = 15;
function Wu(n) {
  n = n.toUpperCase(), n = n.substring(4) + n.substring(0, 2) + "00";
  let t = n.split("").map((r) => Mi[r]).join("");
  for (; t.length >= bs; ) {
    let r = t.substring(0, bs);
    t = parseInt(r, 10) % 97 + t.substring(r.length);
  }
  let e = String(98 - parseInt(t, 10) % 97);
  for (; e.length < 2; )
    e = "0" + e;
  return e;
}
const Ju = function() {
  const n = {};
  for (let t = 0; t < 36; t++) {
    const e = "0123456789abcdefghijklmnopqrstuvwxyz"[t];
    n[e] = BigInt(t);
  }
  return n;
}();
function Xu(n) {
  n = n.toLowerCase();
  let t = Zu;
  for (let e = 0; e < n.length; e++)
    t = t * Ku + Ju[n[e]];
  return t;
}
function Ye(n) {
  if (R(typeof n == "string", "invalid address", "address", n), n.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
    n.startsWith("0x") || (n = "0x" + n);
    const t = ws(n);
    return R(!n.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || t === n, "bad address checksum", "address", n), t;
  }
  if (n.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
    R(n.substring(2, 4) === Wu(n), "bad icap checksum", "address", n);
    let t = Xu(n.substring(4)).toString(16);
    for (; t.length < 40; )
      t = "0" + t;
    return ws("0x" + t);
  }
  R(!1, "invalid address", "address", n);
}
function wa(n) {
  return n && typeof n.getAddress == "function";
}
function Yu(n) {
  try {
    return Ye(n), !0;
  } catch {
  }
  return !1;
}
async function Xr(n, t) {
  const e = await t;
  return (e == null || e === "0x0000000000000000000000000000000000000000") && ($(typeof n != "string", "unconfigured name", "UNCONFIGURED_NAME", { value: n }), R(!1, "invalid AddressLike value; did not resolve to a value address", "target", n)), Ye(e);
}
function Hn(n, t) {
  if (typeof n == "string")
    return n.match(/^0x[0-9a-f]{40}$/i) ? Ye(n) : ($(t != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", { operation: "resolveName" }), Xr(n, t.resolveName(n)));
  if (wa(n))
    return Xr(n, n.getAddress());
  if (n && typeof n.then == "function")
    return Xr(n, n);
  R(!1, "unsupported addressable value", "target", n);
}
const Re = {};
function S(n, t) {
  let e = !1;
  return t < 0 && (e = !0, t *= -1), new Jt(Re, `${e ? "" : "u"}int${t}`, n, { signed: e, width: t });
}
function W(n, t) {
  return new Jt(Re, `bytes${t || ""}`, n, { size: t });
}
const vs = Symbol.for("_ethers_typed");
var fn;
const ke = class ke {
  /**
   *  @_ignore:
   */
  constructor(t, e, r, i) {
    /**
     *  The type, as a Solidity-compatible type.
     */
    E(this, "type");
    /**
     *  The actual value.
     */
    E(this, "value");
    X(this, fn);
    /**
     *  @_ignore:
     */
    E(this, "_typedSymbol");
    i == null && (i = null), wi(Re, t, "Typed"), z(this, { _typedSymbol: vs, type: e, value: r }), K(this, fn, i), this.format();
  }
  /**
   *  Format the type as a Human-Readable type.
   */
  format() {
    if (this.type === "array")
      throw new Error("");
    if (this.type === "dynamicArray")
      throw new Error("");
    return this.type === "tuple" ? `tuple(${this.value.map((t) => t.format()).join(",")})` : this.type;
  }
  /**
   *  The default value returned by this type.
   */
  defaultValue() {
    return 0;
  }
  /**
   *  The minimum value for numeric types.
   */
  minValue() {
    return 0;
  }
  /**
   *  The maximum value for numeric types.
   */
  maxValue() {
    return 0;
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
   */
  isBigInt() {
    return !!this.type.match(/^u?int[0-9]+$/);
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
   */
  isData() {
    return this.type.startsWith("bytes");
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
   */
  isString() {
    return this.type === "string";
  }
  /**
   *  Returns the tuple name, if this is a tuple. Throws otherwise.
   */
  get tupleName() {
    if (this.type !== "tuple")
      throw TypeError("not a tuple");
    return I(this, fn);
  }
  // Returns the length of this type as an array
  // - `null` indicates the length is unforced, it could be dynamic
  // - `-1` indicates the length is dynamic
  // - any other value indicates it is a static array and is its length
  /**
   *  Returns the length of the array type or ``-1`` if it is dynamic.
   *
   *  Throws if the type is not an array.
   */
  get arrayLength() {
    if (this.type !== "array")
      throw TypeError("not an array");
    return I(this, fn) === !0 ? -1 : I(this, fn) === !1 ? this.value.length : null;
  }
  /**
   *  Returns a new **Typed** of %%type%% with the %%value%%.
   */
  static from(t, e) {
    return new ke(Re, t, e);
  }
  /**
   *  Return a new ``uint8`` type for %%v%%.
   */
  static uint8(t) {
    return S(t, 8);
  }
  /**
   *  Return a new ``uint16`` type for %%v%%.
   */
  static uint16(t) {
    return S(t, 16);
  }
  /**
   *  Return a new ``uint24`` type for %%v%%.
   */
  static uint24(t) {
    return S(t, 24);
  }
  /**
   *  Return a new ``uint32`` type for %%v%%.
   */
  static uint32(t) {
    return S(t, 32);
  }
  /**
   *  Return a new ``uint40`` type for %%v%%.
   */
  static uint40(t) {
    return S(t, 40);
  }
  /**
   *  Return a new ``uint48`` type for %%v%%.
   */
  static uint48(t) {
    return S(t, 48);
  }
  /**
   *  Return a new ``uint56`` type for %%v%%.
   */
  static uint56(t) {
    return S(t, 56);
  }
  /**
   *  Return a new ``uint64`` type for %%v%%.
   */
  static uint64(t) {
    return S(t, 64);
  }
  /**
   *  Return a new ``uint72`` type for %%v%%.
   */
  static uint72(t) {
    return S(t, 72);
  }
  /**
   *  Return a new ``uint80`` type for %%v%%.
   */
  static uint80(t) {
    return S(t, 80);
  }
  /**
   *  Return a new ``uint88`` type for %%v%%.
   */
  static uint88(t) {
    return S(t, 88);
  }
  /**
   *  Return a new ``uint96`` type for %%v%%.
   */
  static uint96(t) {
    return S(t, 96);
  }
  /**
   *  Return a new ``uint104`` type for %%v%%.
   */
  static uint104(t) {
    return S(t, 104);
  }
  /**
   *  Return a new ``uint112`` type for %%v%%.
   */
  static uint112(t) {
    return S(t, 112);
  }
  /**
   *  Return a new ``uint120`` type for %%v%%.
   */
  static uint120(t) {
    return S(t, 120);
  }
  /**
   *  Return a new ``uint128`` type for %%v%%.
   */
  static uint128(t) {
    return S(t, 128);
  }
  /**
   *  Return a new ``uint136`` type for %%v%%.
   */
  static uint136(t) {
    return S(t, 136);
  }
  /**
   *  Return a new ``uint144`` type for %%v%%.
   */
  static uint144(t) {
    return S(t, 144);
  }
  /**
   *  Return a new ``uint152`` type for %%v%%.
   */
  static uint152(t) {
    return S(t, 152);
  }
  /**
   *  Return a new ``uint160`` type for %%v%%.
   */
  static uint160(t) {
    return S(t, 160);
  }
  /**
   *  Return a new ``uint168`` type for %%v%%.
   */
  static uint168(t) {
    return S(t, 168);
  }
  /**
   *  Return a new ``uint176`` type for %%v%%.
   */
  static uint176(t) {
    return S(t, 176);
  }
  /**
   *  Return a new ``uint184`` type for %%v%%.
   */
  static uint184(t) {
    return S(t, 184);
  }
  /**
   *  Return a new ``uint192`` type for %%v%%.
   */
  static uint192(t) {
    return S(t, 192);
  }
  /**
   *  Return a new ``uint200`` type for %%v%%.
   */
  static uint200(t) {
    return S(t, 200);
  }
  /**
   *  Return a new ``uint208`` type for %%v%%.
   */
  static uint208(t) {
    return S(t, 208);
  }
  /**
   *  Return a new ``uint216`` type for %%v%%.
   */
  static uint216(t) {
    return S(t, 216);
  }
  /**
   *  Return a new ``uint224`` type for %%v%%.
   */
  static uint224(t) {
    return S(t, 224);
  }
  /**
   *  Return a new ``uint232`` type for %%v%%.
   */
  static uint232(t) {
    return S(t, 232);
  }
  /**
   *  Return a new ``uint240`` type for %%v%%.
   */
  static uint240(t) {
    return S(t, 240);
  }
  /**
   *  Return a new ``uint248`` type for %%v%%.
   */
  static uint248(t) {
    return S(t, 248);
  }
  /**
   *  Return a new ``uint256`` type for %%v%%.
   */
  static uint256(t) {
    return S(t, 256);
  }
  /**
   *  Return a new ``uint256`` type for %%v%%.
   */
  static uint(t) {
    return S(t, 256);
  }
  /**
   *  Return a new ``int8`` type for %%v%%.
   */
  static int8(t) {
    return S(t, -8);
  }
  /**
   *  Return a new ``int16`` type for %%v%%.
   */
  static int16(t) {
    return S(t, -16);
  }
  /**
   *  Return a new ``int24`` type for %%v%%.
   */
  static int24(t) {
    return S(t, -24);
  }
  /**
   *  Return a new ``int32`` type for %%v%%.
   */
  static int32(t) {
    return S(t, -32);
  }
  /**
   *  Return a new ``int40`` type for %%v%%.
   */
  static int40(t) {
    return S(t, -40);
  }
  /**
   *  Return a new ``int48`` type for %%v%%.
   */
  static int48(t) {
    return S(t, -48);
  }
  /**
   *  Return a new ``int56`` type for %%v%%.
   */
  static int56(t) {
    return S(t, -56);
  }
  /**
   *  Return a new ``int64`` type for %%v%%.
   */
  static int64(t) {
    return S(t, -64);
  }
  /**
   *  Return a new ``int72`` type for %%v%%.
   */
  static int72(t) {
    return S(t, -72);
  }
  /**
   *  Return a new ``int80`` type for %%v%%.
   */
  static int80(t) {
    return S(t, -80);
  }
  /**
   *  Return a new ``int88`` type for %%v%%.
   */
  static int88(t) {
    return S(t, -88);
  }
  /**
   *  Return a new ``int96`` type for %%v%%.
   */
  static int96(t) {
    return S(t, -96);
  }
  /**
   *  Return a new ``int104`` type for %%v%%.
   */
  static int104(t) {
    return S(t, -104);
  }
  /**
   *  Return a new ``int112`` type for %%v%%.
   */
  static int112(t) {
    return S(t, -112);
  }
  /**
   *  Return a new ``int120`` type for %%v%%.
   */
  static int120(t) {
    return S(t, -120);
  }
  /**
   *  Return a new ``int128`` type for %%v%%.
   */
  static int128(t) {
    return S(t, -128);
  }
  /**
   *  Return a new ``int136`` type for %%v%%.
   */
  static int136(t) {
    return S(t, -136);
  }
  /**
   *  Return a new ``int144`` type for %%v%%.
   */
  static int144(t) {
    return S(t, -144);
  }
  /**
   *  Return a new ``int52`` type for %%v%%.
   */
  static int152(t) {
    return S(t, -152);
  }
  /**
   *  Return a new ``int160`` type for %%v%%.
   */
  static int160(t) {
    return S(t, -160);
  }
  /**
   *  Return a new ``int168`` type for %%v%%.
   */
  static int168(t) {
    return S(t, -168);
  }
  /**
   *  Return a new ``int176`` type for %%v%%.
   */
  static int176(t) {
    return S(t, -176);
  }
  /**
   *  Return a new ``int184`` type for %%v%%.
   */
  static int184(t) {
    return S(t, -184);
  }
  /**
   *  Return a new ``int92`` type for %%v%%.
   */
  static int192(t) {
    return S(t, -192);
  }
  /**
   *  Return a new ``int200`` type for %%v%%.
   */
  static int200(t) {
    return S(t, -200);
  }
  /**
   *  Return a new ``int208`` type for %%v%%.
   */
  static int208(t) {
    return S(t, -208);
  }
  /**
   *  Return a new ``int216`` type for %%v%%.
   */
  static int216(t) {
    return S(t, -216);
  }
  /**
   *  Return a new ``int224`` type for %%v%%.
   */
  static int224(t) {
    return S(t, -224);
  }
  /**
   *  Return a new ``int232`` type for %%v%%.
   */
  static int232(t) {
    return S(t, -232);
  }
  /**
   *  Return a new ``int240`` type for %%v%%.
   */
  static int240(t) {
    return S(t, -240);
  }
  /**
   *  Return a new ``int248`` type for %%v%%.
   */
  static int248(t) {
    return S(t, -248);
  }
  /**
   *  Return a new ``int256`` type for %%v%%.
   */
  static int256(t) {
    return S(t, -256);
  }
  /**
   *  Return a new ``int256`` type for %%v%%.
   */
  static int(t) {
    return S(t, -256);
  }
  /**
   *  Return a new ``bytes1`` type for %%v%%.
   */
  static bytes1(t) {
    return W(t, 1);
  }
  /**
   *  Return a new ``bytes2`` type for %%v%%.
   */
  static bytes2(t) {
    return W(t, 2);
  }
  /**
   *  Return a new ``bytes3`` type for %%v%%.
   */
  static bytes3(t) {
    return W(t, 3);
  }
  /**
   *  Return a new ``bytes4`` type for %%v%%.
   */
  static bytes4(t) {
    return W(t, 4);
  }
  /**
   *  Return a new ``bytes5`` type for %%v%%.
   */
  static bytes5(t) {
    return W(t, 5);
  }
  /**
   *  Return a new ``bytes6`` type for %%v%%.
   */
  static bytes6(t) {
    return W(t, 6);
  }
  /**
   *  Return a new ``bytes7`` type for %%v%%.
   */
  static bytes7(t) {
    return W(t, 7);
  }
  /**
   *  Return a new ``bytes8`` type for %%v%%.
   */
  static bytes8(t) {
    return W(t, 8);
  }
  /**
   *  Return a new ``bytes9`` type for %%v%%.
   */
  static bytes9(t) {
    return W(t, 9);
  }
  /**
   *  Return a new ``bytes10`` type for %%v%%.
   */
  static bytes10(t) {
    return W(t, 10);
  }
  /**
   *  Return a new ``bytes11`` type for %%v%%.
   */
  static bytes11(t) {
    return W(t, 11);
  }
  /**
   *  Return a new ``bytes12`` type for %%v%%.
   */
  static bytes12(t) {
    return W(t, 12);
  }
  /**
   *  Return a new ``bytes13`` type for %%v%%.
   */
  static bytes13(t) {
    return W(t, 13);
  }
  /**
   *  Return a new ``bytes14`` type for %%v%%.
   */
  static bytes14(t) {
    return W(t, 14);
  }
  /**
   *  Return a new ``bytes15`` type for %%v%%.
   */
  static bytes15(t) {
    return W(t, 15);
  }
  /**
   *  Return a new ``bytes16`` type for %%v%%.
   */
  static bytes16(t) {
    return W(t, 16);
  }
  /**
   *  Return a new ``bytes17`` type for %%v%%.
   */
  static bytes17(t) {
    return W(t, 17);
  }
  /**
   *  Return a new ``bytes18`` type for %%v%%.
   */
  static bytes18(t) {
    return W(t, 18);
  }
  /**
   *  Return a new ``bytes19`` type for %%v%%.
   */
  static bytes19(t) {
    return W(t, 19);
  }
  /**
   *  Return a new ``bytes20`` type for %%v%%.
   */
  static bytes20(t) {
    return W(t, 20);
  }
  /**
   *  Return a new ``bytes21`` type for %%v%%.
   */
  static bytes21(t) {
    return W(t, 21);
  }
  /**
   *  Return a new ``bytes22`` type for %%v%%.
   */
  static bytes22(t) {
    return W(t, 22);
  }
  /**
   *  Return a new ``bytes23`` type for %%v%%.
   */
  static bytes23(t) {
    return W(t, 23);
  }
  /**
   *  Return a new ``bytes24`` type for %%v%%.
   */
  static bytes24(t) {
    return W(t, 24);
  }
  /**
   *  Return a new ``bytes25`` type for %%v%%.
   */
  static bytes25(t) {
    return W(t, 25);
  }
  /**
   *  Return a new ``bytes26`` type for %%v%%.
   */
  static bytes26(t) {
    return W(t, 26);
  }
  /**
   *  Return a new ``bytes27`` type for %%v%%.
   */
  static bytes27(t) {
    return W(t, 27);
  }
  /**
   *  Return a new ``bytes28`` type for %%v%%.
   */
  static bytes28(t) {
    return W(t, 28);
  }
  /**
   *  Return a new ``bytes29`` type for %%v%%.
   */
  static bytes29(t) {
    return W(t, 29);
  }
  /**
   *  Return a new ``bytes30`` type for %%v%%.
   */
  static bytes30(t) {
    return W(t, 30);
  }
  /**
   *  Return a new ``bytes31`` type for %%v%%.
   */
  static bytes31(t) {
    return W(t, 31);
  }
  /**
   *  Return a new ``bytes32`` type for %%v%%.
   */
  static bytes32(t) {
    return W(t, 32);
  }
  /**
   *  Return a new ``address`` type for %%v%%.
   */
  static address(t) {
    return new ke(Re, "address", t);
  }
  /**
   *  Return a new ``bool`` type for %%v%%.
   */
  static bool(t) {
    return new ke(Re, "bool", !!t);
  }
  /**
   *  Return a new ``bytes`` type for %%v%%.
   */
  static bytes(t) {
    return new ke(Re, "bytes", t);
  }
  /**
   *  Return a new ``string`` type for %%v%%.
   */
  static string(t) {
    return new ke(Re, "string", t);
  }
  /**
   *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
   */
  static array(t, e) {
    throw new Error("not implemented yet");
  }
  /**
   *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
   */
  static tuple(t, e) {
    throw new Error("not implemented yet");
  }
  /**
   *  Return a new ``uint8`` type for %%v%%.
   */
  static overrides(t) {
    return new ke(Re, "overrides", Object.assign({}, t));
  }
  /**
   *  Returns true only if %%value%% is a [[Typed]] instance.
   */
  static isTyped(t) {
    return t && typeof t == "object" && "_typedSymbol" in t && t._typedSymbol === vs;
  }
  /**
   *  If the value is a [[Typed]] instance, validates the underlying value
   *  and returns it, otherwise returns value directly.
   *
   *  This is useful for functions that with to accept either a [[Typed]]
   *  object or values.
   */
  static dereference(t, e) {
    if (ke.isTyped(t)) {
      if (t.type !== e)
        throw new Error(`invalid type: expecetd ${e}, got ${t.type}`);
      return t.value;
    }
    return t;
  }
};
fn = new WeakMap();
let Jt = ke;
class Qu extends De {
  constructor(t) {
    super("address", "address", t, !1);
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000";
  }
  encode(t, e) {
    let r = Jt.dereference(e, "string");
    try {
      r = Ye(r);
    } catch (i) {
      return this._throwError(i.message, e);
    }
    return t.writeValue(r);
  }
  decode(t) {
    return Ye(sa(t.readValue(), 20));
  }
}
class ju extends De {
  constructor(e) {
    super(e.name, e.type, "_", e.dynamic);
    E(this, "coder");
    this.coder = e;
  }
  defaultValue() {
    return this.coder.defaultValue();
  }
  encode(e, r) {
    return this.coder.encode(e, r);
  }
  decode(e) {
    return this.coder.decode(e);
  }
}
function ba(n, t, e) {
  let r = [];
  if (Array.isArray(e))
    r = e;
  else if (e && typeof e == "object") {
    let c = {};
    r = t.map((d) => {
      const h = d.localName;
      return $(h, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", { argument: "values", info: { coder: d }, value: e }), $(!c[h], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", { argument: "values", info: { coder: d }, value: e }), c[h] = !0, e[h];
    });
  } else
    R(!1, "invalid tuple value", "tuple", e);
  R(t.length === r.length, "types/value length mismatch", "tuple", e);
  let i = new li(), s = new li(), o = [];
  t.forEach((c, d) => {
    let h = r[d];
    if (c.dynamic) {
      let v = s.length;
      c.encode(s, h);
      let x = i.writeUpdatableValue();
      o.push((N) => {
        x(N + v);
      });
    } else
      c.encode(i, h);
  }), o.forEach((c) => {
    c(i.length);
  });
  let f = n.appendWriter(i);
  return f += n.appendWriter(s), f;
}
function va(n, t) {
  let e = [], r = [], i = n.subReader(0);
  return t.forEach((s) => {
    let o = null;
    if (s.dynamic) {
      let f = n.readIndex(), c = i.subReader(f);
      try {
        o = s.decode(c);
      } catch (d) {
        if (Dn(d, "BUFFER_OVERRUN"))
          throw d;
        o = d, o.baseType = s.name, o.name = s.localName, o.type = s.type;
      }
    } else
      try {
        o = s.decode(n);
      } catch (f) {
        if (Dn(f, "BUFFER_OVERRUN"))
          throw f;
        o = f, o.baseType = s.name, o.name = s.localName, o.type = s.type;
      }
    if (o == null)
      throw new Error("investigate");
    e.push(o), r.push(s.localName || null);
  }), Sn.fromItems(e, r);
}
class tl extends De {
  constructor(e, r, i) {
    const s = e.type + "[" + (r >= 0 ? r : "") + "]", o = r === -1 || e.dynamic;
    super("array", s, i, o);
    E(this, "coder");
    E(this, "length");
    z(this, { coder: e, length: r });
  }
  defaultValue() {
    const e = this.coder.defaultValue(), r = [];
    for (let i = 0; i < this.length; i++)
      r.push(e);
    return r;
  }
  encode(e, r) {
    const i = Jt.dereference(r, "array");
    Array.isArray(i) || this._throwError("expected array value", i);
    let s = this.length;
    s === -1 && (s = i.length, e.writeValue(i.length)), Fs(i.length, s, "coder array" + (this.localName ? " " + this.localName : ""));
    let o = [];
    for (let f = 0; f < i.length; f++)
      o.push(this.coder);
    return ba(e, o, i);
  }
  decode(e) {
    let r = this.length;
    r === -1 && (r = e.readIndex(), $(r * Qt <= e.dataLength, "insufficient data length", "BUFFER_OVERRUN", { buffer: e.bytes, offset: r * Qt, length: e.dataLength }));
    let i = [];
    for (let s = 0; s < r; s++)
      i.push(new ju(this.coder));
    return va(e, i);
  }
}
class el extends De {
  constructor(t) {
    super("bool", "bool", t, !1);
  }
  defaultValue() {
    return !1;
  }
  encode(t, e) {
    const r = Jt.dereference(e, "bool");
    return t.writeValue(r ? 1 : 0);
  }
  decode(t) {
    return !!t.readValue();
  }
}
class Ta extends De {
  constructor(t, e) {
    super(t, t, e, !0);
  }
  defaultValue() {
    return "0x";
  }
  encode(t, e) {
    e = Me(e);
    let r = t.writeValue(e.length);
    return r += t.writeBytes(e), r;
  }
  decode(t) {
    return t.readBytes(t.readIndex(), !0);
  }
}
class nl extends Ta {
  constructor(t) {
    super("bytes", t);
  }
  decode(t) {
    return Ht(super.decode(t));
  }
}
class rl extends De {
  constructor(e, r) {
    let i = "bytes" + String(e);
    super(i, i, r, !1);
    E(this, "size");
    z(this, { size: e }, { size: "number" });
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
  }
  encode(e, r) {
    let i = Me(Jt.dereference(r, this.type));
    return i.length !== this.size && this._throwError("incorrect data length", r), e.writeBytes(i);
  }
  decode(e) {
    return Ht(e.readBytes(this.size));
  }
}
const il = new Uint8Array([]);
class sl extends De {
  constructor(t) {
    super("null", "", t, !1);
  }
  defaultValue() {
    return null;
  }
  encode(t, e) {
    return e != null && this._throwError("not null", e), t.writeBytes(il);
  }
  decode(t) {
    return t.readBytes(0), null;
  }
}
const al = BigInt(0), ol = BigInt(1), ul = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
class ll extends De {
  constructor(e, r, i) {
    const s = (r ? "int" : "uint") + e * 8;
    super(s, s, i, !1);
    E(this, "size");
    E(this, "signed");
    z(this, { size: e, signed: r }, { size: "number", signed: "boolean" });
  }
  defaultValue() {
    return 0;
  }
  encode(e, r) {
    let i = je(Jt.dereference(r, this.type)), s = Xn(ul, Qt * 8);
    if (this.signed) {
      let o = Xn(s, this.size * 8 - 1);
      (i > o || i < -(o + ol)) && this._throwError("value out-of-bounds", r), i = du(i, 8 * Qt);
    } else (i < al || i > Xn(s, this.size * 8)) && this._throwError("value out-of-bounds", r);
    return e.writeValue(i);
  }
  decode(e) {
    let r = Xn(e.readValue(), this.size * 8);
    return this.signed && (r = cu(r, this.size * 8)), r;
  }
}
class fl extends Ta {
  constructor(t) {
    super("string", t);
  }
  defaultValue() {
    return "";
  }
  encode(t, e) {
    return super.encode(t, oa(Jt.dereference(e, "string")));
  }
  decode(t) {
    return Tu(super.decode(t));
  }
}
class jn extends De {
  constructor(e, r) {
    let i = !1;
    const s = [];
    e.forEach((f) => {
      f.dynamic && (i = !0), s.push(f.type);
    });
    const o = "tuple(" + s.join(",") + ")";
    super("tuple", o, r, i);
    E(this, "coders");
    z(this, { coders: Object.freeze(e.slice()) });
  }
  defaultValue() {
    const e = [];
    this.coders.forEach((i) => {
      e.push(i.defaultValue());
    });
    const r = this.coders.reduce((i, s) => {
      const o = s.localName;
      return o && (i[o] || (i[o] = 0), i[o]++), i;
    }, {});
    return this.coders.forEach((i, s) => {
      let o = i.localName;
      !o || r[o] !== 1 || (o === "length" && (o = "_length"), e[o] == null && (e[o] = e[s]));
    }), Object.freeze(e);
  }
  encode(e, r) {
    const i = Jt.dereference(r, "tuple");
    return ba(e, this.coders, i);
  }
  decode(e) {
    return va(e, this.coders);
  }
}
function Vn(n) {
  return Xe(oa(n));
}
function Yr(n, t) {
  return {
    address: Ye(n),
    storageKeys: t.map((e, r) => (R(Pe(e, 32), "invalid slot", `storageKeys[${r}]`, e), e.toLowerCase()))
  };
}
function cl(n) {
  if (Array.isArray(n))
    return n.map((e, r) => Array.isArray(e) ? (R(e.length === 2, "invalid slot set", `value[${r}]`, e), Yr(e[0], e[1])) : (R(e != null && typeof e == "object", "invalid address-slot set", "value", n), Yr(e.address, e.storageKeys)));
  R(n != null && typeof n == "object", "invalid access list", "value", n);
  const t = Object.keys(n).map((e) => {
    const r = n[e].reduce((i, s) => (i[s] = !0, i), {});
    return Yr(e, Object.keys(r).sort());
  });
  return t.sort((e, r) => e.address.localeCompare(r.address)), t;
}
function jt(n) {
  const t = /* @__PURE__ */ new Set();
  return n.forEach((e) => t.add(e)), Object.freeze(t);
}
const dl = "external public payable override", pl = jt(dl.split(" ")), xa = "constant external internal payable private public pure view override", hl = jt(xa.split(" ")), Ma = "constructor error event fallback function receive struct", Ea = jt(Ma.split(" ")), Na = "calldata memory storage payable indexed", ml = jt(Na.split(" ")), yl = "tuple returns", gl = [Ma, Na, yl, xa].join(" "), wl = jt(gl.split(" ")), bl = {
  "(": "OPEN_PAREN",
  ")": "CLOSE_PAREN",
  "[": "OPEN_BRACKET",
  "]": "CLOSE_BRACKET",
  ",": "COMMA",
  "@": "AT"
}, vl = new RegExp("^(\\s*)"), Tl = new RegExp("^([0-9]+)"), xl = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)"), Aa = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$"), Ia = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$");
var zt, de, qn, di;
const mr = class mr {
  constructor(t) {
    X(this, qn);
    X(this, zt);
    X(this, de);
    K(this, zt, 0), K(this, de, t.slice());
  }
  get offset() {
    return I(this, zt);
  }
  get length() {
    return I(this, de).length - I(this, zt);
  }
  clone() {
    return new mr(I(this, de));
  }
  reset() {
    K(this, zt, 0);
  }
  // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
  popKeyword(t) {
    const e = this.peek();
    if (e.type !== "KEYWORD" || !t.has(e.text))
      throw new Error(`expected keyword ${e.text}`);
    return this.pop().text;
  }
  // Pops and returns the value of the next token if it is `type`; throws if out of tokens
  popType(t) {
    if (this.peek().type !== t) {
      const e = this.peek();
      throw new Error(`expected ${t}; got ${e.type} ${JSON.stringify(e.text)}`);
    }
    return this.pop().text;
  }
  // Pops and returns a "(" TOKENS ")"
  popParen() {
    const t = this.peek();
    if (t.type !== "OPEN_PAREN")
      throw new Error("bad start");
    const e = tt(this, qn, di).call(this, I(this, zt) + 1, t.match + 1);
    return K(this, zt, t.match + 1), e;
  }
  // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
  popParams() {
    const t = this.peek();
    if (t.type !== "OPEN_PAREN")
      throw new Error("bad start");
    const e = [];
    for (; I(this, zt) < t.match - 1; ) {
      const r = this.peek().linkNext;
      e.push(tt(this, qn, di).call(this, I(this, zt) + 1, r)), K(this, zt, r);
    }
    return K(this, zt, t.match + 1), e;
  }
  // Returns the top Token, throwing if out of tokens
  peek() {
    if (I(this, zt) >= I(this, de).length)
      throw new Error("out-of-bounds");
    return I(this, de)[I(this, zt)];
  }
  // Returns the next value, if it is a keyword in `allowed`
  peekKeyword(t) {
    const e = this.peekType("KEYWORD");
    return e != null && t.has(e) ? e : null;
  }
  // Returns the value of the next token if it is `type`
  peekType(t) {
    if (this.length === 0)
      return null;
    const e = this.peek();
    return e.type === t ? e.text : null;
  }
  // Returns the next token; throws if out of tokens
  pop() {
    const t = this.peek();
    return Wi(this, zt)._++, t;
  }
  toString() {
    const t = [];
    for (let e = I(this, zt); e < I(this, de).length; e++) {
      const r = I(this, de)[e];
      t.push(`${r.type}:${r.text}`);
    }
    return `<TokenString ${t.join(" ")}>`;
  }
};
zt = new WeakMap(), de = new WeakMap(), qn = new WeakSet(), di = function(t = 0, e = 0) {
  return new mr(I(this, de).slice(t, e).map((r) => Object.freeze(Object.assign({}, r, {
    match: r.match - t,
    linkBack: r.linkBack - t,
    linkNext: r.linkNext - t
  }))));
};
let ye = mr;
function tn(n) {
  const t = [], e = (o) => {
    const f = s < n.length ? JSON.stringify(n[s]) : "$EOI";
    throw new Error(`invalid token ${f} at ${s}: ${o}`);
  };
  let r = [], i = [], s = 0;
  for (; s < n.length; ) {
    let o = n.substring(s), f = o.match(vl);
    f && (s += f[1].length, o = n.substring(s));
    const c = { depth: r.length, linkBack: -1, linkNext: -1, match: -1, type: "", text: "", offset: s, value: -1 };
    t.push(c);
    let d = bl[o[0]] || "";
    if (d) {
      if (c.type = d, c.text = o[0], s++, d === "OPEN_PAREN")
        r.push(t.length - 1), i.push(t.length - 1);
      else if (d == "CLOSE_PAREN")
        r.length === 0 && e("no matching open bracket"), c.match = r.pop(), t[c.match].match = t.length - 1, c.depth--, c.linkBack = i.pop(), t[c.linkBack].linkNext = t.length - 1;
      else if (d === "COMMA")
        c.linkBack = i.pop(), t[c.linkBack].linkNext = t.length - 1, i.push(t.length - 1);
      else if (d === "OPEN_BRACKET")
        c.type = "BRACKET";
      else if (d === "CLOSE_BRACKET") {
        let h = t.pop().text;
        if (t.length > 0 && t[t.length - 1].type === "NUMBER") {
          const v = t.pop().text;
          h = v + h, t[t.length - 1].value = Le(v);
        }
        if (t.length === 0 || t[t.length - 1].type !== "BRACKET")
          throw new Error("missing opening bracket");
        t[t.length - 1].text += h;
      }
      continue;
    }
    if (f = o.match(xl), f) {
      if (c.text = f[1], s += c.text.length, wl.has(c.text)) {
        c.type = "KEYWORD";
        continue;
      }
      if (c.text.match(Ia)) {
        c.type = "TYPE";
        continue;
      }
      c.type = "ID";
      continue;
    }
    if (f = o.match(Tl), f) {
      c.text = f[1], c.type = "NUMBER", s += c.text.length;
      continue;
    }
    throw new Error(`unexpected token ${JSON.stringify(o[0])} at position ${s}`);
  }
  return new ye(t.map((o) => Object.freeze(o)));
}
function Ts(n, t) {
  let e = [];
  for (const r in t.keys())
    n.has(r) && e.push(r);
  if (e.length > 1)
    throw new Error(`conflicting types: ${e.join(", ")}`);
}
function xr(n, t) {
  if (t.peekKeyword(Ea)) {
    const e = t.pop().text;
    if (e !== n)
      throw new Error(`expected ${n}, got ${e}`);
  }
  return t.popType("ID");
}
function Fe(n, t) {
  const e = /* @__PURE__ */ new Set();
  for (; ; ) {
    const r = n.peekType("KEYWORD");
    if (r == null || t && !t.has(r))
      break;
    if (n.pop(), e.has(r))
      throw new Error(`duplicate keywords: ${JSON.stringify(r)}`);
    e.add(r);
  }
  return Object.freeze(e);
}
function Ra(n) {
  let t = Fe(n, hl);
  return Ts(t, jt("constant payable nonpayable".split(" "))), Ts(t, jt("pure view payable nonpayable".split(" "))), t.has("view") ? "view" : t.has("pure") ? "pure" : t.has("payable") ? "payable" : t.has("nonpayable") ? "nonpayable" : t.has("constant") ? "view" : "nonpayable";
}
function Be(n, t) {
  return n.popParams().map((e) => Zt.from(e, t));
}
function ka(n) {
  if (n.peekType("AT")) {
    if (n.pop(), n.peekType("NUMBER"))
      return je(n.pop().text);
    throw new Error("invalid gas");
  }
  return null;
}
function dn(n) {
  if (n.length)
    throw new Error(`unexpected tokens at offset ${n.offset}: ${n.toString()}`);
}
const Ml = new RegExp(/^(.*)\[([0-9]*)\]$/);
function xs(n) {
  const t = n.match(Ia);
  if (R(t, "invalid type", "type", n), n === "uint")
    return "uint256";
  if (n === "int")
    return "int256";
  if (t[2]) {
    const e = parseInt(t[2]);
    R(e !== 0 && e <= 32, "invalid bytes length", "type", n);
  } else if (t[3]) {
    const e = parseInt(t[3]);
    R(e !== 0 && e <= 256 && e % 8 === 0, "invalid numeric width", "type", n);
  }
  return n;
}
const et = {}, ie = Symbol.for("_ethers_internal"), Ms = "_ParamTypeInternal", Es = "_ErrorInternal", Ns = "_EventInternal", As = "_ConstructorInternal", Is = "_FallbackInternal", Rs = "_FunctionInternal", ks = "_StructInternal";
var In, ar;
const le = class le {
  /**
   *  @private
   */
  constructor(t, e, r, i, s, o, f, c) {
    X(this, In);
    /**
     *  The local name of the parameter (or ``""`` if unbound)
     */
    E(this, "name");
    /**
     *  The fully qualified type (e.g. ``"address"``, ``"tuple(address)"``,
     *  ``"uint256[3][]"``)
     */
    E(this, "type");
    /**
     *  The base type (e.g. ``"address"``, ``"tuple"``, ``"array"``)
     */
    E(this, "baseType");
    /**
     *  True if the parameters is indexed.
     *
     *  For non-indexable types this is ``null``.
     */
    E(this, "indexed");
    /**
     *  The components for the tuple.
     *
     *  For non-tuple types this is ``null``.
     */
    E(this, "components");
    /**
     *  The array length, or ``-1`` for dynamic-lengthed arrays.
     *
     *  For non-array types this is ``null``.
     */
    E(this, "arrayLength");
    /**
     *  The type of each child in the array.
     *
     *  For non-array types this is ``null``.
     */
    E(this, "arrayChildren");
    if (wi(t, et, "ParamType"), Object.defineProperty(this, ie, { value: Ms }), o && (o = Object.freeze(o.slice())), i === "array") {
      if (f == null || c == null)
        throw new Error("");
    } else if (f != null || c != null)
      throw new Error("");
    if (i === "tuple") {
      if (o == null)
        throw new Error("");
    } else if (o != null)
      throw new Error("");
    z(this, {
      name: e,
      type: r,
      baseType: i,
      indexed: s,
      components: o,
      arrayLength: f,
      arrayChildren: c
    });
  }
  /**
   *  Return a string representation of this type.
   *
   *  For example,
   *
   *  ``sighash" => "(uint256,address)"``
   *
   *  ``"minimal" => "tuple(uint256,address) indexed"``
   *
   *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
   */
  format(t) {
    if (t == null && (t = "sighash"), t === "json") {
      const r = this.name || "";
      if (this.isArray()) {
        const s = JSON.parse(this.arrayChildren.format("json"));
        return s.name = r, s.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`, JSON.stringify(s);
      }
      const i = {
        type: this.baseType === "tuple" ? "tuple" : this.type,
        name: r
      };
      return typeof this.indexed == "boolean" && (i.indexed = this.indexed), this.isTuple() && (i.components = this.components.map((s) => JSON.parse(s.format(t)))), JSON.stringify(i);
    }
    let e = "";
    return this.isArray() ? (e += this.arrayChildren.format(t), e += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`) : this.isTuple() ? e += "(" + this.components.map((r) => r.format(t)).join(t === "full" ? ", " : ",") + ")" : e += this.type, t !== "sighash" && (this.indexed === !0 && (e += " indexed"), t === "full" && this.name && (e += " " + this.name)), e;
  }
  /**
   *  Returns true if %%this%% is an Array type.
   *
   *  This provides a type gaurd ensuring that [[arrayChildren]]
   *  and [[arrayLength]] are non-null.
   */
  isArray() {
    return this.baseType === "array";
  }
  /**
   *  Returns true if %%this%% is a Tuple type.
   *
   *  This provides a type gaurd ensuring that [[components]]
   *  is non-null.
   */
  isTuple() {
    return this.baseType === "tuple";
  }
  /**
   *  Returns true if %%this%% is an Indexable type.
   *
   *  This provides a type gaurd ensuring that [[indexed]]
   *  is non-null.
   */
  isIndexable() {
    return this.indexed != null;
  }
  /**
   *  Walks the **ParamType** with %%value%%, calling %%process%%
   *  on each type, destructing the %%value%% recursively.
   */
  walk(t, e) {
    if (this.isArray()) {
      if (!Array.isArray(t))
        throw new Error("invalid array value");
      if (this.arrayLength !== -1 && t.length !== this.arrayLength)
        throw new Error("array is wrong length");
      const r = this;
      return t.map((i) => r.arrayChildren.walk(i, e));
    }
    if (this.isTuple()) {
      if (!Array.isArray(t))
        throw new Error("invalid tuple value");
      if (t.length !== this.components.length)
        throw new Error("array is wrong length");
      const r = this;
      return t.map((i, s) => r.components[s].walk(i, e));
    }
    return e(this.type, t);
  }
  /**
   *  Walks the **ParamType** with %%value%%, asynchronously calling
   *  %%process%% on each type, destructing the %%value%% recursively.
   *
   *  This can be used to resolve ENS names by walking and resolving each
   *  ``"address"`` type.
   */
  async walkAsync(t, e) {
    const r = [], i = [t];
    return tt(this, In, ar).call(this, r, t, e, (s) => {
      i[0] = s;
    }), r.length && await Promise.all(r), i[0];
  }
  /**
   *  Creates a new **ParamType** for %%obj%%.
   *
   *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
   *  otherwise the ``indexed`` keyword will throw an error.
   */
  static from(t, e) {
    if (le.isParamType(t))
      return t;
    if (typeof t == "string")
      try {
        return le.from(tn(t), e);
      } catch {
        R(!1, "invalid param type", "obj", t);
      }
    else if (t instanceof ye) {
      let f = "", c = "", d = null;
      Fe(t, jt(["tuple"])).has("tuple") || t.peekType("OPEN_PAREN") ? (c = "tuple", d = t.popParams().map((k) => le.from(k)), f = `tuple(${d.map((k) => k.format()).join(",")})`) : (f = xs(t.popType("TYPE")), c = f);
      let h = null, v = null;
      for (; t.length && t.peekType("BRACKET"); ) {
        const k = t.pop();
        h = new le(et, "", f, c, null, d, v, h), v = k.value, f += k.text, c = "array", d = null;
      }
      let x = null;
      if (Fe(t, ml).has("indexed")) {
        if (!e)
          throw new Error("");
        x = !0;
      }
      const _ = t.peekType("ID") ? t.pop().text : "";
      if (t.length)
        throw new Error("leftover tokens");
      return new le(et, _, f, c, x, d, v, h);
    }
    const r = t.name;
    R(!r || typeof r == "string" && r.match(Aa), "invalid name", "obj.name", r);
    let i = t.indexed;
    i != null && (R(e, "parameter cannot be indexed", "obj.indexed", t.indexed), i = !!i);
    let s = t.type, o = s.match(Ml);
    if (o) {
      const f = parseInt(o[2] || "-1"), c = le.from({
        type: o[1],
        components: t.components
      });
      return new le(et, r || "", s, "array", i, null, f, c);
    }
    if (s === "tuple" || s.startsWith(
      "tuple("
      /* fix: ) */
    ) || s.startsWith(
      "("
      /* fix: ) */
    )) {
      const f = t.components != null ? t.components.map((d) => le.from(d)) : null;
      return new le(et, r || "", s, "tuple", i, f, null, null);
    }
    return s = xs(t.type), new le(et, r || "", s, s, i, null, null, null);
  }
  /**
   *  Returns true if %%value%% is a **ParamType**.
   */
  static isParamType(t) {
    return t && t[ie] === Ms;
  }
};
In = new WeakSet(), ar = function(t, e, r, i) {
  if (this.isArray()) {
    if (!Array.isArray(e))
      throw new Error("invalid array value");
    if (this.arrayLength !== -1 && e.length !== this.arrayLength)
      throw new Error("array is wrong length");
    const o = this.arrayChildren, f = e.slice();
    f.forEach((c, d) => {
      var h;
      tt(h = o, In, ar).call(h, t, c, r, (v) => {
        f[d] = v;
      });
    }), i(f);
    return;
  }
  if (this.isTuple()) {
    const o = this.components;
    let f;
    if (Array.isArray(e))
      f = e.slice();
    else {
      if (e == null || typeof e != "object")
        throw new Error("invalid tuple value");
      f = o.map((c) => {
        if (!c.name)
          throw new Error("cannot use object value with unnamed components");
        if (!(c.name in e))
          throw new Error(`missing value for component ${c.name}`);
        return e[c.name];
      });
    }
    if (f.length !== this.components.length)
      throw new Error("array is wrong length");
    f.forEach((c, d) => {
      var h;
      tt(h = o[d], In, ar).call(h, t, c, r, (v) => {
        f[d] = v;
      });
    }), i(f);
    return;
  }
  const s = r(this.type, e);
  s.then ? t.push(async function() {
    i(await s);
  }()) : i(s);
};
let Zt = le;
class pn {
  /**
   *  @private
   */
  constructor(t, e, r) {
    /**
     *  The type of the fragment.
     */
    E(this, "type");
    /**
     *  The inputs for the fragment.
     */
    E(this, "inputs");
    wi(t, et, "Fragment"), r = Object.freeze(r.slice()), z(this, { type: e, inputs: r });
  }
  /**
   *  Creates a new **Fragment** for %%obj%%, wich can be any supported
   *  ABI frgament type.
   */
  static from(t) {
    if (typeof t == "string") {
      try {
        pn.from(JSON.parse(t));
      } catch {
      }
      return pn.from(tn(t));
    }
    if (t instanceof ye)
      switch (t.peekKeyword(Ea)) {
        case "constructor":
          return Ue.from(t);
        case "error":
          return ne.from(t);
        case "event":
          return Te.from(t);
        case "fallback":
        case "receive":
          return Oe.from(t);
        case "function":
          return xe.from(t);
        case "struct":
          return cn.from(t);
      }
    else if (typeof t == "object") {
      switch (t.type) {
        case "constructor":
          return Ue.from(t);
        case "error":
          return ne.from(t);
        case "event":
          return Te.from(t);
        case "fallback":
        case "receive":
          return Oe.from(t);
        case "function":
          return xe.from(t);
        case "struct":
          return cn.from(t);
      }
      $(!1, `unsupported type: ${t.type}`, "UNSUPPORTED_OPERATION", {
        operation: "Fragment.from"
      });
    }
    R(!1, "unsupported frgament object", "obj", t);
  }
  /**
   *  Returns true if %%value%% is a [[ConstructorFragment]].
   */
  static isConstructor(t) {
    return Ue.isFragment(t);
  }
  /**
   *  Returns true if %%value%% is an [[ErrorFragment]].
   */
  static isError(t) {
    return ne.isFragment(t);
  }
  /**
   *  Returns true if %%value%% is an [[EventFragment]].
   */
  static isEvent(t) {
    return Te.isFragment(t);
  }
  /**
   *  Returns true if %%value%% is a [[FunctionFragment]].
   */
  static isFunction(t) {
    return xe.isFragment(t);
  }
  /**
   *  Returns true if %%value%% is a [[StructFragment]].
   */
  static isStruct(t) {
    return cn.isFragment(t);
  }
}
class Mr extends pn {
  /**
   *  @private
   */
  constructor(e, r, i, s) {
    super(e, r, s);
    /**
     *  The name of the fragment.
     */
    E(this, "name");
    R(typeof i == "string" && i.match(Aa), "invalid identifier", "name", i), s = Object.freeze(s.slice()), z(this, { name: i });
  }
}
function zn(n, t) {
  return "(" + t.map((e) => e.format(n)).join(n === "full" ? ", " : ",") + ")";
}
class ne extends Mr {
  /**
   *  @private
   */
  constructor(t, e, r) {
    super(t, "error", e, r), Object.defineProperty(this, ie, { value: Es });
  }
  /**
   *  The Custom Error selector.
   */
  get selector() {
    return Vn(this.format("sighash")).substring(0, 10);
  }
  /**
   *  Returns a string representation of this fragment as %%format%%.
   */
  format(t) {
    if (t == null && (t = "sighash"), t === "json")
      return JSON.stringify({
        type: "error",
        name: this.name,
        inputs: this.inputs.map((r) => JSON.parse(r.format(t)))
      });
    const e = [];
    return t !== "sighash" && e.push("error"), e.push(this.name + zn(t, this.inputs)), e.join(" ");
  }
  /**
   *  Returns a new **ErrorFragment** for %%obj%%.
   */
  static from(t) {
    if (ne.isFragment(t))
      return t;
    if (typeof t == "string")
      return ne.from(tn(t));
    if (t instanceof ye) {
      const e = xr("error", t), r = Be(t);
      return dn(t), new ne(et, e, r);
    }
    return new ne(et, t.name, t.inputs ? t.inputs.map(Zt.from) : []);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is an
   *  **ErrorFragment**.
   */
  static isFragment(t) {
    return t && t[ie] === Es;
  }
}
class Te extends Mr {
  /**
   *  @private
   */
  constructor(e, r, i, s) {
    super(e, "event", r, i);
    /**
     *  Whether this event is anonymous.
     */
    E(this, "anonymous");
    Object.defineProperty(this, ie, { value: Ns }), z(this, { anonymous: s });
  }
  /**
   *  The Event topic hash.
   */
  get topicHash() {
    return Vn(this.format("sighash"));
  }
  /**
   *  Returns a string representation of this event as %%format%%.
   */
  format(e) {
    if (e == null && (e = "sighash"), e === "json")
      return JSON.stringify({
        type: "event",
        anonymous: this.anonymous,
        name: this.name,
        inputs: this.inputs.map((i) => JSON.parse(i.format(e)))
      });
    const r = [];
    return e !== "sighash" && r.push("event"), r.push(this.name + zn(e, this.inputs)), e !== "sighash" && this.anonymous && r.push("anonymous"), r.join(" ");
  }
  /**
   *  Return the topic hash for an event with %%name%% and %%params%%.
   */
  static getTopicHash(e, r) {
    return r = (r || []).map((s) => Zt.from(s)), new Te(et, e, r, !1).topicHash;
  }
  /**
   *  Returns a new **EventFragment** for %%obj%%.
   */
  static from(e) {
    if (Te.isFragment(e))
      return e;
    if (typeof e == "string")
      try {
        return Te.from(tn(e));
      } catch {
        R(!1, "invalid event fragment", "obj", e);
      }
    else if (e instanceof ye) {
      const r = xr("event", e), i = Be(e, !0), s = !!Fe(e, jt(["anonymous"])).has("anonymous");
      return dn(e), new Te(et, r, i, s);
    }
    return new Te(et, e.name, e.inputs ? e.inputs.map((r) => Zt.from(r, !0)) : [], !!e.anonymous);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is an
   *  **EventFragment**.
   */
  static isFragment(e) {
    return e && e[ie] === Ns;
  }
}
class Ue extends pn {
  /**
   *  @private
   */
  constructor(e, r, i, s, o) {
    super(e, r, i);
    /**
     *  Whether the constructor can receive an endowment.
     */
    E(this, "payable");
    /**
     *  The recommended gas limit for deployment or ``null``.
     */
    E(this, "gas");
    Object.defineProperty(this, ie, { value: As }), z(this, { payable: s, gas: o });
  }
  /**
   *  Returns a string representation of this constructor as %%format%%.
   */
  format(e) {
    if ($(e != null && e !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", { operation: "format(sighash)" }), e === "json")
      return JSON.stringify({
        type: "constructor",
        stateMutability: this.payable ? "payable" : "undefined",
        payable: this.payable,
        gas: this.gas != null ? this.gas : void 0,
        inputs: this.inputs.map((i) => JSON.parse(i.format(e)))
      });
    const r = [`constructor${zn(e, this.inputs)}`];
    return this.payable && r.push("payable"), this.gas != null && r.push(`@${this.gas.toString()}`), r.join(" ");
  }
  /**
   *  Returns a new **ConstructorFragment** for %%obj%%.
   */
  static from(e) {
    if (Ue.isFragment(e))
      return e;
    if (typeof e == "string")
      try {
        return Ue.from(tn(e));
      } catch {
        R(!1, "invalid constuctor fragment", "obj", e);
      }
    else if (e instanceof ye) {
      Fe(e, jt(["constructor"]));
      const r = Be(e), i = !!Fe(e, pl).has("payable"), s = ka(e);
      return dn(e), new Ue(et, "constructor", r, i, s);
    }
    return new Ue(et, "constructor", e.inputs ? e.inputs.map(Zt.from) : [], !!e.payable, e.gas != null ? e.gas : null);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **ConstructorFragment**.
   */
  static isFragment(e) {
    return e && e[ie] === As;
  }
}
class Oe extends pn {
  constructor(e, r, i) {
    super(e, "fallback", r);
    /**
     *  If the function can be sent value during invocation.
     */
    E(this, "payable");
    Object.defineProperty(this, ie, { value: Is }), z(this, { payable: i });
  }
  /**
   *  Returns a string representation of this fallback as %%format%%.
   */
  format(e) {
    const r = this.inputs.length === 0 ? "receive" : "fallback";
    if (e === "json") {
      const i = this.payable ? "payable" : "nonpayable";
      return JSON.stringify({ type: r, stateMutability: i });
    }
    return `${r}()${this.payable ? " payable" : ""}`;
  }
  /**
   *  Returns a new **FallbackFragment** for %%obj%%.
   */
  static from(e) {
    if (Oe.isFragment(e))
      return e;
    if (typeof e == "string")
      try {
        return Oe.from(tn(e));
      } catch {
        R(!1, "invalid fallback fragment", "obj", e);
      }
    else if (e instanceof ye) {
      const r = e.toString(), i = e.peekKeyword(jt(["fallback", "receive"]));
      if (R(i, "type must be fallback or receive", "obj", r), e.popKeyword(jt(["fallback", "receive"])) === "receive") {
        const c = Be(e);
        return R(c.length === 0, "receive cannot have arguments", "obj.inputs", c), Fe(e, jt(["payable"])), dn(e), new Oe(et, [], !0);
      }
      let o = Be(e);
      o.length ? R(o.length === 1 && o[0].type === "bytes", "invalid fallback inputs", "obj.inputs", o.map((c) => c.format("minimal")).join(", ")) : o = [Zt.from("bytes")];
      const f = Ra(e);
      if (R(f === "nonpayable" || f === "payable", "fallback cannot be constants", "obj.stateMutability", f), Fe(e, jt(["returns"])).has("returns")) {
        const c = Be(e);
        R(c.length === 1 && c[0].type === "bytes", "invalid fallback outputs", "obj.outputs", c.map((d) => d.format("minimal")).join(", "));
      }
      return dn(e), new Oe(et, o, f === "payable");
    }
    if (e.type === "receive")
      return new Oe(et, [], !0);
    if (e.type === "fallback") {
      const r = [Zt.from("bytes")], i = e.stateMutability === "payable";
      return new Oe(et, r, i);
    }
    R(!1, "invalid fallback description", "obj", e);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **FallbackFragment**.
   */
  static isFragment(e) {
    return e && e[ie] === Is;
  }
}
class xe extends Mr {
  /**
   *  @private
   */
  constructor(e, r, i, s, o, f) {
    super(e, "function", r, s);
    /**
     *  If the function is constant (e.g. ``pure`` or ``view`` functions).
     */
    E(this, "constant");
    /**
     *  The returned types for the result of calling this function.
     */
    E(this, "outputs");
    /**
     *  The state mutability (e.g. ``payable``, ``nonpayable``, ``view``
     *  or ``pure``)
     */
    E(this, "stateMutability");
    /**
     *  If the function can be sent value during invocation.
     */
    E(this, "payable");
    /**
     *  The recommended gas limit to send when calling this function.
     */
    E(this, "gas");
    Object.defineProperty(this, ie, { value: Rs }), o = Object.freeze(o.slice()), z(this, { constant: i === "view" || i === "pure", gas: f, outputs: o, payable: i === "payable", stateMutability: i });
  }
  /**
   *  The Function selector.
   */
  get selector() {
    return Vn(this.format("sighash")).substring(0, 10);
  }
  /**
   *  Returns a string representation of this function as %%format%%.
   */
  format(e) {
    if (e == null && (e = "sighash"), e === "json")
      return JSON.stringify({
        type: "function",
        name: this.name,
        constant: this.constant,
        stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
        payable: this.payable,
        gas: this.gas != null ? this.gas : void 0,
        inputs: this.inputs.map((i) => JSON.parse(i.format(e))),
        outputs: this.outputs.map((i) => JSON.parse(i.format(e)))
      });
    const r = [];
    return e !== "sighash" && r.push("function"), r.push(this.name + zn(e, this.inputs)), e !== "sighash" && (this.stateMutability !== "nonpayable" && r.push(this.stateMutability), this.outputs && this.outputs.length && (r.push("returns"), r.push(zn(e, this.outputs))), this.gas != null && r.push(`@${this.gas.toString()}`)), r.join(" ");
  }
  /**
   *  Return the selector for a function with %%name%% and %%params%%.
   */
  static getSelector(e, r) {
    return r = (r || []).map((s) => Zt.from(s)), new xe(et, e, "view", r, [], null).selector;
  }
  /**
   *  Returns a new **FunctionFragment** for %%obj%%.
   */
  static from(e) {
    if (xe.isFragment(e))
      return e;
    if (typeof e == "string")
      try {
        return xe.from(tn(e));
      } catch {
        R(!1, "invalid function fragment", "obj", e);
      }
    else if (e instanceof ye) {
      const i = xr("function", e), s = Be(e), o = Ra(e);
      let f = [];
      Fe(e, jt(["returns"])).has("returns") && (f = Be(e));
      const c = ka(e);
      return dn(e), new xe(et, i, o, s, f, c);
    }
    let r = e.stateMutability;
    return r == null && (r = "payable", typeof e.constant == "boolean" ? (r = "view", e.constant || (r = "payable", typeof e.payable == "boolean" && !e.payable && (r = "nonpayable"))) : typeof e.payable == "boolean" && !e.payable && (r = "nonpayable")), new xe(et, e.name, r, e.inputs ? e.inputs.map(Zt.from) : [], e.outputs ? e.outputs.map(Zt.from) : [], e.gas != null ? e.gas : null);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **FunctionFragment**.
   */
  static isFragment(e) {
    return e && e[ie] === Rs;
  }
}
class cn extends Mr {
  /**
   *  @private
   */
  constructor(t, e, r) {
    super(t, "struct", e, r), Object.defineProperty(this, ie, { value: ks });
  }
  /**
   *  Returns a string representation of this struct as %%format%%.
   */
  format() {
    throw new Error("@TODO");
  }
  /**
   *  Returns a new **StructFragment** for %%obj%%.
   */
  static from(t) {
    if (typeof t == "string")
      try {
        return cn.from(tn(t));
      } catch {
        R(!1, "invalid struct fragment", "obj", t);
      }
    else if (t instanceof ye) {
      const e = xr("struct", t), r = Be(t);
      return dn(t), new cn(et, e, r);
    }
    return new cn(et, t.name, t.inputs ? t.inputs.map(Zt.from) : []);
  }
  // @TODO: fix this return type
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **StructFragment**.
   */
  static isFragment(t) {
    return t && t[ie] === ks;
  }
}
const ge = /* @__PURE__ */ new Map();
ge.set(0, "GENERIC_PANIC");
ge.set(1, "ASSERT_FALSE");
ge.set(17, "OVERFLOW");
ge.set(18, "DIVIDE_BY_ZERO");
ge.set(33, "ENUM_RANGE_ERROR");
ge.set(34, "BAD_STORAGE_DATA");
ge.set(49, "STACK_UNDERFLOW");
ge.set(50, "ARRAY_RANGE_ERROR");
ge.set(65, "OUT_OF_MEMORY");
ge.set(81, "UNINITIALIZED_FUNCTION_CALL");
const El = new RegExp(/^bytes([0-9]*)$/), Nl = new RegExp(/^(u?int)([0-9]*)$/);
let Qr = null, Os = 1024;
function Al(n, t, e, r) {
  let i = "missing revert data", s = null;
  const o = null;
  let f = null;
  if (e) {
    i = "execution reverted";
    const d = Ce(e);
    if (e = Ht(e), d.length === 0)
      i += " (no data present; likely require(false) occurred", s = "require(false)";
    else if (d.length % 32 !== 4)
      i += " (could not decode reason; invalid data length)";
    else if (Ht(d.slice(0, 4)) === "0x08c379a0")
      try {
        s = r.decode(["string"], d.slice(4))[0], f = {
          signature: "Error(string)",
          name: "Error",
          args: [s]
        }, i += `: ${JSON.stringify(s)}`;
      } catch {
        i += " (could not decode reason; invalid string data)";
      }
    else if (Ht(d.slice(0, 4)) === "0x4e487b71")
      try {
        const h = Number(r.decode(["uint256"], d.slice(4))[0]);
        f = {
          signature: "Panic(uint256)",
          name: "Panic",
          args: [h]
        }, s = `Panic due to ${ge.get(h) || "UNKNOWN"}(${h})`, i += `: ${s}`;
      } catch {
        i += " (could not decode panic code)";
      }
    else
      i += " (unknown custom error)";
  }
  const c = {
    to: t.to ? Ye(t.to) : null,
    data: t.data || "0x"
  };
  return t.from && (c.from = Ye(t.from)), lr(i, "CALL_EXCEPTION", {
    action: n,
    data: e,
    reason: s,
    transaction: c,
    invocation: o,
    revert: f
  });
}
var qe, wn;
const yr = class yr {
  constructor() {
    X(this, qe);
  }
  /**
   *  Get the default values for the given %%types%%.
   *
   *  For example, a ``uint`` is by default ``0`` and ``bool``
   *  is by default ``false``.
   */
  getDefaultValue(t) {
    const e = t.map((i) => tt(this, qe, wn).call(this, Zt.from(i)));
    return new jn(e, "_").defaultValue();
  }
  /**
   *  Encode the %%values%% as the %%types%% into ABI data.
   *
   *  @returns DataHexstring
   */
  encode(t, e) {
    Fs(e.length, t.length, "types/values length mismatch");
    const r = t.map((o) => tt(this, qe, wn).call(this, Zt.from(o))), i = new jn(r, "_"), s = new li();
    return i.encode(s, e), s.data;
  }
  /**
   *  Decode the ABI %%data%% as the %%types%% into values.
   *
   *  If %%loose%% decoding is enabled, then strict padding is
   *  not enforced. Some older versions of Solidity incorrectly
   *  padded event data emitted from ``external`` functions.
   */
  decode(t, e, r) {
    const i = t.map((o) => tt(this, qe, wn).call(this, Zt.from(o)));
    return new jn(i, "_").decode(new fi(e, r, Os));
  }
  static _setDefaultMaxInflation(t) {
    R(typeof t == "number" && Number.isInteger(t), "invalid defaultMaxInflation factor", "value", t), Os = t;
  }
  /**
   *  Returns the shared singleton instance of a default [[AbiCoder]].
   *
   *  On the first call, the instance is created internally.
   */
  static defaultAbiCoder() {
    return Qr == null && (Qr = new yr()), Qr;
  }
  /**
   *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
   *  result %%data%% for the [[CallExceptionAction]] %%action%% against
   *  the Transaction %%tx%%.
   */
  static getBuiltinCallException(t, e, r) {
    return Al(t, e, r, yr.defaultAbiCoder());
  }
};
qe = new WeakSet(), wn = function(t) {
  if (t.isArray())
    return new tl(tt(this, qe, wn).call(this, t.arrayChildren), t.arrayLength, t.name);
  if (t.isTuple())
    return new jn(t.components.map((r) => tt(this, qe, wn).call(this, r)), t.name);
  switch (t.baseType) {
    case "address":
      return new Qu(t.name);
    case "bool":
      return new el(t.name);
    case "string":
      return new fl(t.name);
    case "bytes":
      return new nl(t.name);
    case "":
      return new sl(t.name);
  }
  let e = t.type.match(Nl);
  if (e) {
    let r = parseInt(e[2] || "256");
    return R(r !== 0 && r <= 256 && r % 8 === 0, "invalid " + e[1] + " bit length", "param", t), new ll(r / 8, e[1] === "int", t.name);
  }
  if (e = t.type.match(El), e) {
    let r = parseInt(e[1]);
    return R(r !== 0 && r <= 32, "invalid bytes length", "param", t), new rl(r, t.name);
  }
  R(!1, "invalid type", "type", t.type);
};
let pr = yr;
class Il {
  /**
   *  @_ignore:
   */
  constructor(t, e, r) {
    /**
     *  The matching fragment for the ``topic0``.
     */
    E(this, "fragment");
    /**
     *  The name of the Event.
     */
    E(this, "name");
    /**
     *  The full Event signature.
     */
    E(this, "signature");
    /**
     *  The topic hash for the Event.
     */
    E(this, "topic");
    /**
     *  The arguments passed into the Event with ``emit``.
     */
    E(this, "args");
    const i = t.name, s = t.format();
    z(this, {
      fragment: t,
      name: i,
      signature: s,
      topic: e,
      args: r
    });
  }
}
class Rl {
  /**
   *  @_ignore:
   */
  constructor(t, e, r, i) {
    /**
     *  The matching fragment from the transaction ``data``.
     */
    E(this, "fragment");
    /**
     *  The name of the Function from the transaction ``data``.
     */
    E(this, "name");
    /**
     *  The arguments passed to the Function from the transaction ``data``.
     */
    E(this, "args");
    /**
     *  The full Function signature from the transaction ``data``.
     */
    E(this, "signature");
    /**
     *  The selector for the Function from the transaction ``data``.
     */
    E(this, "selector");
    /**
     *  The ``value`` (in wei) from the transaction.
     */
    E(this, "value");
    const s = t.name, o = t.format();
    z(this, {
      fragment: t,
      name: s,
      args: r,
      signature: o,
      selector: e,
      value: i
    });
  }
}
class kl {
  /**
   *  @_ignore:
   */
  constructor(t, e, r) {
    /**
     *  The matching fragment.
     */
    E(this, "fragment");
    /**
     *  The name of the Error.
     */
    E(this, "name");
    /**
     *  The arguments passed to the Error with ``revert``.
     */
    E(this, "args");
    /**
     *  The full Error signature.
     */
    E(this, "signature");
    /**
     *  The selector for the Error.
     */
    E(this, "selector");
    const i = t.name, s = t.format();
    z(this, {
      fragment: t,
      name: i,
      args: r,
      signature: s,
      selector: e
    });
  }
}
class _s {
  /**
   *  @_ignore:
   */
  constructor(t) {
    /**
     *  The ``keccak256`` of the value logged.
     */
    E(this, "hash");
    /**
     *  @_ignore:
     */
    E(this, "_isIndexed");
    z(this, { hash: t, _isIndexed: !0 });
  }
  /**
   *  Returns ``true`` if %%value%% is an **Indexed**.
   *
   *  This provides a Type Guard for property access.
   */
  static isIndexed(t) {
    return !!(t && t._isIndexed);
  }
}
const Ss = {
  0: "generic panic",
  1: "assert(false)",
  17: "arithmetic overflow",
  18: "division or modulo by zero",
  33: "enum overflow",
  34: "invalid encoded storage byte array accessed",
  49: "out-of-bounds array access; popping on an empty array",
  50: "out-of-bounds access of an array or bytesN",
  65: "out of memory",
  81: "uninitialized function"
}, Ps = {
  "0x08c379a0": {
    signature: "Error(string)",
    name: "Error",
    inputs: ["string"],
    reason: (n) => `reverted with reason string ${JSON.stringify(n)}`
  },
  "0x4e487b71": {
    signature: "Panic(uint256)",
    name: "Panic",
    inputs: ["uint256"],
    reason: (n) => {
      let t = "unknown panic code";
      return n >= 0 && n <= 255 && Ss[n.toString()] && (t = Ss[n.toString()]), `reverted with panic code 0x${n.toString(16)} (${t})`;
    }
  }
};
var we, be, ve, Wt, Ee, or, ur;
const sn = class sn {
  /**
   *  Create a new Interface for the %%fragments%%.
   */
  constructor(t) {
    X(this, Ee);
    /**
     *  All the Contract ABI members (i.e. methods, events, errors, etc).
     */
    E(this, "fragments");
    /**
     *  The Contract constructor.
     */
    E(this, "deploy");
    /**
     *  The Fallback method, if any.
     */
    E(this, "fallback");
    /**
     *  If receiving ether is supported.
     */
    E(this, "receive");
    X(this, we);
    X(this, be);
    X(this, ve);
    //    #structs: Map<string, StructFragment>;
    X(this, Wt);
    let e = [];
    typeof t == "string" ? e = JSON.parse(t) : e = t, K(this, ve, /* @__PURE__ */ new Map()), K(this, we, /* @__PURE__ */ new Map()), K(this, be, /* @__PURE__ */ new Map());
    const r = [];
    for (const o of e)
      try {
        r.push(pn.from(o));
      } catch (f) {
        console.log(`[Warning] Invalid Fragment ${JSON.stringify(o)}:`, f.message);
      }
    z(this, {
      fragments: Object.freeze(r)
    });
    let i = null, s = !1;
    K(this, Wt, this.getAbiCoder()), this.fragments.forEach((o, f) => {
      let c;
      switch (o.type) {
        case "constructor":
          if (this.deploy) {
            console.log("duplicate definition - constructor");
            return;
          }
          z(this, { deploy: o });
          return;
        case "fallback":
          o.inputs.length === 0 ? s = !0 : (R(!i || o.payable !== i.payable, "conflicting fallback fragments", `fragments[${f}]`, o), i = o, s = i.payable);
          return;
        case "function":
          c = I(this, ve);
          break;
        case "event":
          c = I(this, be);
          break;
        case "error":
          c = I(this, we);
          break;
        default:
          return;
      }
      const d = o.format();
      c.has(d) || c.set(d, o);
    }), this.deploy || z(this, {
      deploy: Ue.from("constructor()")
    }), z(this, { fallback: i, receive: s });
  }
  /**
   *  Returns the entire Human-Readable ABI, as an array of
   *  signatures, optionally as %%minimal%% strings, which
   *  removes parameter names and unneceesary spaces.
   */
  format(t) {
    const e = t ? "minimal" : "full";
    return this.fragments.map((i) => i.format(e));
  }
  /**
   *  Return the JSON-encoded ABI. This is the format Solidiy
   *  returns.
   */
  formatJson() {
    const t = this.fragments.map((e) => e.format("json"));
    return JSON.stringify(t.map((e) => JSON.parse(e)));
  }
  /**
   *  The ABI coder that will be used to encode and decode binary
   *  data.
   */
  getAbiCoder() {
    return pr.defaultAbiCoder();
  }
  /**
   *  Get the function name for %%key%%, which may be a function selector,
   *  function name or function signature that belongs to the ABI.
   */
  getFunctionName(t) {
    const e = tt(this, Ee, or).call(this, t, null, !1);
    return R(e, "no matching function", "key", t), e.name;
  }
  /**
   *  Returns true if %%key%% (a function selector, function name or
   *  function signature) is present in the ABI.
   *
   *  In the case of a function name, the name may be ambiguous, so
   *  accessing the [[FunctionFragment]] may require refinement.
   */
  hasFunction(t) {
    return !!tt(this, Ee, or).call(this, t, null, !1);
  }
  /**
   *  Get the [[FunctionFragment]] for %%key%%, which may be a function
   *  selector, function name or function signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple functions match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single function in
   *  the ABI, this will throw.
   */
  getFunction(t, e) {
    return tt(this, Ee, or).call(this, t, e || null, !0);
  }
  /**
   *  Iterate over all functions, calling %%callback%%, sorted by their name.
   */
  forEachFunction(t) {
    const e = Array.from(I(this, ve).keys());
    e.sort((r, i) => r.localeCompare(i));
    for (let r = 0; r < e.length; r++) {
      const i = e[r];
      t(I(this, ve).get(i), r);
    }
  }
  /**
   *  Get the event name for %%key%%, which may be a topic hash,
   *  event name or event signature that belongs to the ABI.
   */
  getEventName(t) {
    const e = tt(this, Ee, ur).call(this, t, null, !1);
    return R(e, "no matching event", "key", t), e.name;
  }
  /**
   *  Returns true if %%key%% (an event topic hash, event name or
   *  event signature) is present in the ABI.
   *
   *  In the case of an event name, the name may be ambiguous, so
   *  accessing the [[EventFragment]] may require refinement.
   */
  hasEvent(t) {
    return !!tt(this, Ee, ur).call(this, t, null, !1);
  }
  /**
   *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
   *  event name or event signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple events match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single event in
   *  the ABI, this will throw.
   */
  getEvent(t, e) {
    return tt(this, Ee, ur).call(this, t, e || null, !0);
  }
  /**
   *  Iterate over all events, calling %%callback%%, sorted by their name.
   */
  forEachEvent(t) {
    const e = Array.from(I(this, be).keys());
    e.sort((r, i) => r.localeCompare(i));
    for (let r = 0; r < e.length; r++) {
      const i = e[r];
      t(I(this, be).get(i), r);
    }
  }
  /**
   *  Get the [[ErrorFragment]] for %%key%%, which may be an error
   *  selector, error name or error signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple errors match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single error in
   *  the ABI, this will throw.
   */
  getError(t, e) {
    if (Pe(t)) {
      const i = t.toLowerCase();
      if (Ps[i])
        return ne.from(Ps[i].signature);
      for (const s of I(this, we).values())
        if (i === s.selector)
          return s;
      return null;
    }
    if (t.indexOf("(") === -1) {
      const i = [];
      for (const [s, o] of I(this, we))
        s.split(
          "("
          /* fix:) */
        )[0] === t && i.push(o);
      if (i.length === 0)
        return t === "Error" ? ne.from("error Error(string)") : t === "Panic" ? ne.from("error Panic(uint256)") : null;
      if (i.length > 1) {
        const s = i.map((o) => JSON.stringify(o.format())).join(", ");
        R(!1, `ambiguous error description (i.e. ${s})`, "name", t);
      }
      return i[0];
    }
    if (t = ne.from(t).format(), t === "Error(string)")
      return ne.from("error Error(string)");
    if (t === "Panic(uint256)")
      return ne.from("error Panic(uint256)");
    const r = I(this, we).get(t);
    return r || null;
  }
  /**
   *  Iterate over all errors, calling %%callback%%, sorted by their name.
   */
  forEachError(t) {
    const e = Array.from(I(this, we).keys());
    e.sort((r, i) => r.localeCompare(i));
    for (let r = 0; r < e.length; r++) {
      const i = e[r];
      t(I(this, we).get(i), r);
    }
  }
  // Get the 4-byte selector used by Solidity to identify a function
  /*
  getSelector(fragment: ErrorFragment | FunctionFragment): string {
      if (typeof(fragment) === "string") {
          const matches: Array<Fragment> = [ ];
  
          try { matches.push(this.getFunction(fragment)); } catch (error) { }
          try { matches.push(this.getError(<string>fragment)); } catch (_) { }
  
          if (matches.length === 0) {
              logger.throwArgumentError("unknown fragment", "key", fragment);
          } else if (matches.length > 1) {
              logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
          }
  
          fragment = matches[0];
      }
  
      return dataSlice(id(fragment.format()), 0, 4);
  }
      */
  // Get the 32-byte topic hash used by Solidity to identify an event
  /*
  getEventTopic(fragment: EventFragment): string {
      //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
      return id(fragment.format());
  }
  */
  _decodeParams(t, e) {
    return I(this, Wt).decode(t, e);
  }
  _encodeParams(t, e) {
    return I(this, Wt).encode(t, e);
  }
  /**
   *  Encodes a ``tx.data`` object for deploying the Contract with
   *  the %%values%% as the constructor arguments.
   */
  encodeDeploy(t) {
    return this._encodeParams(this.deploy.inputs, t || []);
  }
  /**
   *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
   *  specified error (see [[getError]] for valid values for
   *  %%key%%).
   *
   *  Most developers should prefer the [[parseCallResult]] method instead,
   *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
   *  corresponding error.
   */
  decodeErrorResult(t, e) {
    if (typeof t == "string") {
      const r = this.getError(t);
      R(r, "unknown error", "fragment", t), t = r;
    }
    return R(yn(e, 0, 4) === t.selector, `data signature does not match error ${t.name}.`, "data", e), this._decodeParams(t.inputs, yn(e, 4));
  }
  /**
   *  Encodes the transaction revert data for a call result that
   *  reverted from the the Contract with the sepcified %%error%%
   *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
   *
   *  This is generally not used by most developers, unless trying to mock
   *  a result from a Contract.
   */
  encodeErrorResult(t, e) {
    if (typeof t == "string") {
      const r = this.getError(t);
      R(r, "unknown error", "fragment", t), t = r;
    }
    return Mn([
      t.selector,
      this._encodeParams(t.inputs, e || [])
    ]);
  }
  /**
   *  Decodes the %%data%% from a transaction ``tx.data`` for
   *  the function specified (see [[getFunction]] for valid values
   *  for %%fragment%%).
   *
   *  Most developers should prefer the [[parseTransaction]] method
   *  instead, which will automatically detect the fragment.
   */
  decodeFunctionData(t, e) {
    if (typeof t == "string") {
      const r = this.getFunction(t);
      R(r, "unknown function", "fragment", t), t = r;
    }
    return R(yn(e, 0, 4) === t.selector, `data signature does not match function ${t.name}.`, "data", e), this._decodeParams(t.inputs, yn(e, 4));
  }
  /**
   *  Encodes the ``tx.data`` for a transaction that calls the function
   *  specified (see [[getFunction]] for valid values for %%fragment%%) with
   *  the %%values%%.
   */
  encodeFunctionData(t, e) {
    if (typeof t == "string") {
      const r = this.getFunction(t);
      R(r, "unknown function", "fragment", t), t = r;
    }
    return Mn([
      t.selector,
      this._encodeParams(t.inputs, e || [])
    ]);
  }
  /**
   *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
   *  specified function (see [[getFunction]] for valid values for
   *  %%key%%).
   *
   *  Most developers should prefer the [[parseCallResult]] method instead,
   *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
   *  corresponding error.
   */
  decodeFunctionResult(t, e) {
    if (typeof t == "string") {
      const s = this.getFunction(t);
      R(s, "unknown function", "fragment", t), t = s;
    }
    let r = "invalid length for result data";
    const i = Me(e);
    if (i.length % 32 === 0)
      try {
        return I(this, Wt).decode(t.outputs, i);
      } catch {
        r = "could not decode result data";
      }
    $(!1, r, "BAD_DATA", {
      value: Ht(i),
      info: { method: t.name, signature: t.format() }
    });
  }
  makeError(t, e) {
    const r = Ce(t, "data"), i = pr.getBuiltinCallException("call", e, r);
    if (i.message.startsWith("execution reverted (unknown custom error)")) {
      const f = Ht(r.slice(0, 4)), c = this.getError(f);
      if (c)
        try {
          const d = I(this, Wt).decode(c.inputs, r.slice(4));
          i.revert = {
            name: c.name,
            signature: c.format(),
            args: d
          }, i.reason = i.revert.signature, i.message = `execution reverted: ${i.reason}`;
        } catch {
          i.message = "execution reverted (coult not decode custom error)";
        }
    }
    const o = this.parseTransaction(e);
    return o && (i.invocation = {
      method: o.name,
      signature: o.signature,
      args: o.args
    }), i;
  }
  /**
   *  Encodes the result data (e.g. from an ``eth_call``) for the
   *  specified function (see [[getFunction]] for valid values
   *  for %%fragment%%) with %%values%%.
   *
   *  This is generally not used by most developers, unless trying to mock
   *  a result from a Contract.
   */
  encodeFunctionResult(t, e) {
    if (typeof t == "string") {
      const r = this.getFunction(t);
      R(r, "unknown function", "fragment", t), t = r;
    }
    return Ht(I(this, Wt).encode(t.outputs, e || []));
  }
  /*
      spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
          const promises: Array<Promise<>> = [ ];
          const process = function(type: ParamType, value: any): any {
              if (type.baseType === "array") {
                  return descend(type.child
              }
              if (type. === "address") {
              }
          };
  
          const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
              if (inputs.length !== values.length) { throw new Error("length mismatch"); }
              
          };
  
          const result: Array<any> = [ ];
          values.forEach((value, index) => {
              if (value == null) {
                  topics.push(null);
              } else if (param.baseType === "array" || param.baseType === "tuple") {
                  logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
              } else if (Array.isArray(value)) {
                  topics.push(value.map((value) => encodeTopic(param, value)));
              } else {
                  topics.push(encodeTopic(param, value));
              }
          });
      }
  */
  // Create the filter for the event with search criteria (e.g. for eth_filterLog)
  encodeFilterTopics(t, e) {
    if (typeof t == "string") {
      const s = this.getEvent(t);
      R(s, "unknown event", "eventFragment", t), t = s;
    }
    $(e.length <= t.inputs.length, `too many arguments for ${t.format()}`, "UNEXPECTED_ARGUMENT", { count: e.length, expectedCount: t.inputs.length });
    const r = [];
    t.anonymous || r.push(t.topicHash);
    const i = (s, o) => s.type === "string" ? Vn(o) : s.type === "bytes" ? Xe(Ht(o)) : (s.type === "bool" && typeof o == "boolean" ? o = o ? "0x01" : "0x00" : s.type.match(/^u?int/) ? o = sa(o) : s.type.match(/^bytes/) ? o = fu(o, 32) : s.type === "address" && I(this, Wt).encode(["address"], [o]), lu(Ht(o), 32));
    for (e.forEach((s, o) => {
      const f = t.inputs[o];
      if (!f.indexed) {
        R(s == null, "cannot filter non-indexed parameters; must be null", "contract." + f.name, s);
        return;
      }
      s == null ? r.push(null) : f.baseType === "array" || f.baseType === "tuple" ? R(!1, "filtering with tuples or arrays not supported", "contract." + f.name, s) : Array.isArray(s) ? r.push(s.map((c) => i(f, c))) : r.push(i(f, s));
    }); r.length && r[r.length - 1] === null; )
      r.pop();
    return r;
  }
  encodeEventLog(t, e) {
    if (typeof t == "string") {
      const o = this.getEvent(t);
      R(o, "unknown event", "eventFragment", t), t = o;
    }
    const r = [], i = [], s = [];
    return t.anonymous || r.push(t.topicHash), R(e.length === t.inputs.length, "event arguments/values mismatch", "values", e), t.inputs.forEach((o, f) => {
      const c = e[f];
      if (o.indexed)
        if (o.type === "string")
          r.push(Vn(c));
        else if (o.type === "bytes")
          r.push(Xe(c));
        else {
          if (o.baseType === "tuple" || o.baseType === "array")
            throw new Error("not implemented");
          r.push(I(this, Wt).encode([o.type], [c]));
        }
      else
        i.push(o), s.push(c);
    }), {
      data: I(this, Wt).encode(i, s),
      topics: r
    };
  }
  // Decode a filter for the event and the search criteria
  decodeEventLog(t, e, r) {
    if (typeof t == "string") {
      const N = this.getEvent(t);
      R(N, "unknown event", "eventFragment", t), t = N;
    }
    if (r != null && !t.anonymous) {
      const N = t.topicHash;
      R(Pe(r[0], 32) && r[0].toLowerCase() === N, "fragment/topic mismatch", "topics[0]", r[0]), r = r.slice(1);
    }
    const i = [], s = [], o = [];
    t.inputs.forEach((N, _) => {
      N.indexed ? N.type === "string" || N.type === "bytes" || N.baseType === "tuple" || N.baseType === "array" ? (i.push(Zt.from({ type: "bytes32", name: N.name })), o.push(!0)) : (i.push(N), o.push(!1)) : (s.push(N), o.push(!1));
    });
    const f = r != null ? I(this, Wt).decode(i, Mn(r)) : null, c = I(this, Wt).decode(s, e, !0), d = [], h = [];
    let v = 0, x = 0;
    return t.inputs.forEach((N, _) => {
      let k = null;
      if (N.indexed)
        if (f == null)
          k = new _s(null);
        else if (o[_])
          k = new _s(f[x++]);
        else
          try {
            k = f[x++];
          } catch (G) {
            k = G;
          }
      else
        try {
          k = c[v++];
        } catch (G) {
          k = G;
        }
      d.push(k), h.push(N.name || null);
    }), Sn.fromItems(d, h);
  }
  /**
   *  Parses a transaction, finding the matching function and extracts
   *  the parameter values along with other useful function details.
   *
   *  If the matching function cannot be found, return null.
   */
  parseTransaction(t) {
    const e = Ce(t.data, "tx.data"), r = je(t.value != null ? t.value : 0, "tx.value"), i = this.getFunction(Ht(e.slice(0, 4)));
    if (!i)
      return null;
    const s = I(this, Wt).decode(i.inputs, e.slice(4));
    return new Rl(i, i.selector, s, r);
  }
  parseCallResult(t) {
    throw new Error("@TODO");
  }
  /**
   *  Parses a receipt log, finding the matching event and extracts
   *  the parameter values along with other useful event details.
   *
   *  If the matching event cannot be found, returns null.
   */
  parseLog(t) {
    const e = this.getEvent(t.topics[0]);
    return !e || e.anonymous ? null : new Il(e, e.topicHash, this.decodeEventLog(e, t.data, t.topics));
  }
  /**
   *  Parses a revert data, finding the matching error and extracts
   *  the parameter values along with other useful error details.
   *
   *  If the matching error cannot be found, returns null.
   */
  parseError(t) {
    const e = Ht(t), r = this.getError(yn(e, 0, 4));
    if (!r)
      return null;
    const i = I(this, Wt).decode(r.inputs, yn(e, 4));
    return new kl(r, r.selector, i);
  }
  /**
   *  Creates a new [[Interface]] from the ABI %%value%%.
   *
   *  The %%value%% may be provided as an existing [[Interface]] object,
   *  a JSON-encoded ABI or any Human-Readable ABI format.
   */
  static from(t) {
    return t instanceof sn ? t : typeof t == "string" ? new sn(JSON.parse(t)) : typeof t.formatJson == "function" ? new sn(t.formatJson()) : typeof t.format == "function" ? new sn(t.format("json")) : new sn(t);
  }
};
we = new WeakMap(), be = new WeakMap(), ve = new WeakMap(), Wt = new WeakMap(), Ee = new WeakSet(), // Find a function definition by any means necessary (unless it is ambiguous)
or = function(t, e, r) {
  if (Pe(t)) {
    const s = t.toLowerCase();
    for (const o of I(this, ve).values())
      if (s === o.selector)
        return o;
    return null;
  }
  if (t.indexOf("(") === -1) {
    const s = [];
    for (const [o, f] of I(this, ve))
      o.split(
        "("
        /* fix:) */
      )[0] === t && s.push(f);
    if (e) {
      const o = e.length > 0 ? e[e.length - 1] : null;
      let f = e.length, c = !0;
      Jt.isTyped(o) && o.type === "overrides" && (c = !1, f--);
      for (let d = s.length - 1; d >= 0; d--) {
        const h = s[d].inputs.length;
        h !== f && (!c || h !== f - 1) && s.splice(d, 1);
      }
      for (let d = s.length - 1; d >= 0; d--) {
        const h = s[d].inputs;
        for (let v = 0; v < e.length; v++)
          if (Jt.isTyped(e[v])) {
            if (v >= h.length) {
              if (e[v].type === "overrides")
                continue;
              s.splice(d, 1);
              break;
            }
            if (e[v].type !== h[v].baseType) {
              s.splice(d, 1);
              break;
            }
          }
      }
    }
    if (s.length === 1 && e && e.length !== s[0].inputs.length) {
      const o = e[e.length - 1];
      (o == null || Array.isArray(o) || typeof o != "object") && s.splice(0, 1);
    }
    if (s.length === 0)
      return null;
    if (s.length > 1 && r) {
      const o = s.map((f) => JSON.stringify(f.format())).join(", ");
      R(!1, `ambiguous function description (i.e. matches ${o})`, "key", t);
    }
    return s[0];
  }
  const i = I(this, ve).get(xe.from(t).format());
  return i || null;
}, // Find an event definition by any means necessary (unless it is ambiguous)
ur = function(t, e, r) {
  if (Pe(t)) {
    const s = t.toLowerCase();
    for (const o of I(this, be).values())
      if (s === o.topicHash)
        return o;
    return null;
  }
  if (t.indexOf("(") === -1) {
    const s = [];
    for (const [o, f] of I(this, be))
      o.split(
        "("
        /* fix:) */
      )[0] === t && s.push(f);
    if (e) {
      for (let o = s.length - 1; o >= 0; o--)
        s[o].inputs.length < e.length && s.splice(o, 1);
      for (let o = s.length - 1; o >= 0; o--) {
        const f = s[o].inputs;
        for (let c = 0; c < e.length; c++)
          if (Jt.isTyped(e[c]) && e[c].type !== f[c].baseType) {
            s.splice(o, 1);
            break;
          }
      }
    }
    if (s.length === 0)
      return null;
    if (s.length > 1 && r) {
      const o = s.map((f) => JSON.stringify(f.format())).join(", ");
      R(!1, `ambiguous event description (i.e. matches ${o})`, "key", t);
    }
    return s[0];
  }
  const i = I(this, be).get(Te.from(t).format());
  return i || null;
};
let pi = sn;
const Oa = BigInt(0);
function fe(n) {
  return n == null ? null : n.toString();
}
function Ol(n) {
  const t = {};
  n.to && (t.to = n.to), n.from && (t.from = n.from), n.data && (t.data = Ht(n.data));
  const e = "chainId,gasLimit,gasPrice,maxFeePerBlobGas,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
  for (const i of e)
    !(i in n) || n[i] == null || (t[i] = je(n[i], `request.${i}`));
  const r = "type,nonce".split(/,/);
  for (const i of r)
    !(i in n) || n[i] == null || (t[i] = Le(n[i], `request.${i}`));
  return n.accessList && (t.accessList = cl(n.accessList)), "blockTag" in n && (t.blockTag = n.blockTag), "enableCcipRead" in n && (t.enableCcipRead = !!n.enableCcipRead), "customData" in n && (t.customData = n.customData), "blobVersionedHashes" in n && n.blobVersionedHashes && (t.blobVersionedHashes = n.blobVersionedHashes.slice()), "kzg" in n && (t.kzg = n.kzg), "blobs" in n && n.blobs && (t.blobs = n.blobs.map((i) => uu(i) ? Ht(i) : Object.assign({}, i))), t;
}
class Er {
  /**
   *  @_ignore:
   */
  constructor(t, e) {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */
    E(this, "provider");
    /**
     *  The transaction hash of the transaction this log occurred in. Use the
     *  [[Log-getTransaction]] to get the [[TransactionResponse]].
     */
    E(this, "transactionHash");
    /**
     *  The block hash of the block this log occurred in. Use the
     *  [[Log-getBlock]] to get the [[Block]].
     */
    E(this, "blockHash");
    /**
     *  The block number of the block this log occurred in. It is preferred
     *  to use the [[Block-hash]] when fetching the related [[Block]],
     *  since in the case of an orphaned block, the block at that height may
     *  have changed.
     */
    E(this, "blockNumber");
    /**
     *  If the **Log** represents a block that was removed due to an orphaned
     *  block, this will be true.
     *
     *  This can only happen within an orphan event listener.
     */
    E(this, "removed");
    /**
     *  The address of the contract that emitted this log.
     */
    E(this, "address");
    /**
     *  The data included in this log when it was emitted.
     */
    E(this, "data");
    /**
     *  The indexed topics included in this log when it was emitted.
     *
     *  All topics are included in the bloom filters, so they can be
     *  efficiently filtered using the [[Provider-getLogs]] method.
     */
    E(this, "topics");
    /**
     *  The index within the block this log occurred at. This is generally
     *  not useful to developers, but can be used with the various roots
     *  to proof inclusion within a block.
     */
    E(this, "index");
    /**
     *  The index within the transaction of this log.
     */
    E(this, "transactionIndex");
    this.provider = e;
    const r = Object.freeze(t.topics.slice());
    z(this, {
      transactionHash: t.transactionHash,
      blockHash: t.blockHash,
      blockNumber: t.blockNumber,
      removed: t.removed,
      address: t.address,
      data: t.data,
      topics: r,
      index: t.index,
      transactionIndex: t.transactionIndex
    });
  }
  /**
   *  Returns a JSON-compatible object.
   */
  toJSON() {
    const { address: t, blockHash: e, blockNumber: r, data: i, index: s, removed: o, topics: f, transactionHash: c, transactionIndex: d } = this;
    return {
      _type: "log",
      address: t,
      blockHash: e,
      blockNumber: r,
      data: i,
      index: s,
      removed: o,
      topics: f,
      transactionHash: c,
      transactionIndex: d
    };
  }
  /**
   *  Returns the block that this log occurred in.
   */
  async getBlock() {
    const t = await this.provider.getBlock(this.blockHash);
    return $(!!t, "failed to find transaction", "UNKNOWN_ERROR", {}), t;
  }
  /**
   *  Returns the transaction that this log occurred in.
   */
  async getTransaction() {
    const t = await this.provider.getTransaction(this.transactionHash);
    return $(!!t, "failed to find transaction", "UNKNOWN_ERROR", {}), t;
  }
  /**
   *  Returns the transaction receipt fot the transaction that this
   *  log occurred in.
   */
  async getTransactionReceipt() {
    const t = await this.provider.getTransactionReceipt(this.transactionHash);
    return $(!!t, "failed to find transaction receipt", "UNKNOWN_ERROR", {}), t;
  }
  /**
   *  @_ignore:
   */
  removedEvent() {
    return Sl(this);
  }
}
var Zn;
class _l {
  /**
   *  @_ignore:
   */
  constructor(t, e) {
    /**
     *  The provider connected to the log used to fetch additional details
     *  if necessary.
     */
    E(this, "provider");
    /**
     *  The address the transaction was sent to.
     */
    E(this, "to");
    /**
     *  The sender of the transaction.
     */
    E(this, "from");
    /**
     *  The address of the contract if the transaction was directly
     *  responsible for deploying one.
     *
     *  This is non-null **only** if the ``to`` is empty and the ``data``
     *  was successfully executed as initcode.
     */
    E(this, "contractAddress");
    /**
     *  The transaction hash.
     */
    E(this, "hash");
    /**
     *  The index of this transaction within the block transactions.
     */
    E(this, "index");
    /**
     *  The block hash of the [[Block]] this transaction was included in.
     */
    E(this, "blockHash");
    /**
     *  The block number of the [[Block]] this transaction was included in.
     */
    E(this, "blockNumber");
    /**
     *  The bloom filter bytes that represent all logs that occurred within
     *  this transaction. This is generally not useful for most developers,
     *  but can be used to validate the included logs.
     */
    E(this, "logsBloom");
    /**
     *  The actual amount of gas used by this transaction.
     *
     *  When creating a transaction, the amount of gas that will be used can
     *  only be approximated, but the sender must pay the gas fee for the
     *  entire gas limit. After the transaction, the difference is refunded.
     */
    E(this, "gasUsed");
    /**
     *  The gas used for BLObs. See [[link-eip-4844]].
     */
    E(this, "blobGasUsed");
    /**
     *  The amount of gas used by all transactions within the block for this
     *  and all transactions with a lower ``index``.
     *
     *  This is generally not useful for developers but can be used to
     *  validate certain aspects of execution.
     */
    E(this, "cumulativeGasUsed");
    /**
     *  The actual gas price used during execution.
     *
     *  Due to the complexity of [[link-eip-1559]] this value can only
     *  be caluclated after the transaction has been mined, snce the base
     *  fee is protocol-enforced.
     */
    E(this, "gasPrice");
    /**
     *  The price paid per BLOB in gas. See [[link-eip-4844]].
     */
    E(this, "blobGasPrice");
    /**
     *  The [[link-eip-2718]] transaction type.
     */
    E(this, "type");
    //readonly byzantium!: boolean;
    /**
     *  The status of this transaction, indicating success (i.e. ``1``) or
     *  a revert (i.e. ``0``).
     *
     *  This is available in post-byzantium blocks, but some backends may
     *  backfill this value.
     */
    E(this, "status");
    /**
     *  The root hash of this transaction.
     *
     *  This is no present and was only included in pre-byzantium blocks, but
     *  could be used to validate certain parts of the receipt.
     */
    E(this, "root");
    X(this, Zn);
    K(this, Zn, Object.freeze(t.logs.map((i) => new Er(i, e))));
    let r = Oa;
    t.effectiveGasPrice != null ? r = t.effectiveGasPrice : t.gasPrice != null && (r = t.gasPrice), z(this, {
      provider: e,
      to: t.to,
      from: t.from,
      contractAddress: t.contractAddress,
      hash: t.hash,
      index: t.index,
      blockHash: t.blockHash,
      blockNumber: t.blockNumber,
      logsBloom: t.logsBloom,
      gasUsed: t.gasUsed,
      cumulativeGasUsed: t.cumulativeGasUsed,
      blobGasUsed: t.blobGasUsed,
      gasPrice: r,
      blobGasPrice: t.blobGasPrice,
      type: t.type,
      //byzantium: tx.byzantium,
      status: t.status,
      root: t.root
    });
  }
  /**
   *  The logs for this transaction.
   */
  get logs() {
    return I(this, Zn);
  }
  /**
   *  Returns a JSON-compatible representation.
   */
  toJSON() {
    const {
      to: t,
      from: e,
      contractAddress: r,
      hash: i,
      index: s,
      blockHash: o,
      blockNumber: f,
      logsBloom: c,
      logs: d,
      //byzantium, 
      status: h,
      root: v
    } = this;
    return {
      _type: "TransactionReceipt",
      blockHash: o,
      blockNumber: f,
      //byzantium, 
      contractAddress: r,
      cumulativeGasUsed: fe(this.cumulativeGasUsed),
      from: e,
      gasPrice: fe(this.gasPrice),
      blobGasUsed: fe(this.blobGasUsed),
      blobGasPrice: fe(this.blobGasPrice),
      gasUsed: fe(this.gasUsed),
      hash: i,
      index: s,
      logs: d,
      logsBloom: c,
      root: v,
      status: h,
      to: t
    };
  }
  /**
   *  @_ignore:
   */
  get length() {
    return this.logs.length;
  }
  [Symbol.iterator]() {
    let t = 0;
    return {
      next: () => t < this.length ? { value: this.logs[t++], done: !1 } : { value: void 0, done: !0 }
    };
  }
  /**
   *  The total fee for this transaction, in wei.
   */
  get fee() {
    return this.gasUsed * this.gasPrice;
  }
  /**
   *  Resolves to the block this transaction occurred in.
   */
  async getBlock() {
    const t = await this.provider.getBlock(this.blockHash);
    if (t == null)
      throw new Error("TODO");
    return t;
  }
  /**
   *  Resolves to the transaction this transaction occurred in.
   */
  async getTransaction() {
    const t = await this.provider.getTransaction(this.hash);
    if (t == null)
      throw new Error("TODO");
    return t;
  }
  /**
   *  Resolves to the return value of the execution of this transaction.
   *
   *  Support for this feature is limited, as it requires an archive node
   *  with the ``debug_`` or ``trace_`` API enabled.
   */
  async getResult() {
    return await this.provider.getTransactionResult(this.hash);
  }
  /**
   *  Resolves to the number of confirmations this transaction has.
   */
  async confirmations() {
    return await this.provider.getBlockNumber() - this.blockNumber + 1;
  }
  /**
   *  @_ignore:
   */
  removedEvent() {
    return Sa(this);
  }
  /**
   *  @_ignore:
   */
  reorderedEvent(t) {
    return $(!t || t.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", { operation: "reorderedEvent(other)" }), _a(this, t);
  }
}
Zn = new WeakMap();
var Ze;
const Ri = class Ri {
  /**
   *  @_ignore:
   */
  constructor(t, e) {
    /**
     *  The provider this is connected to, which will influence how its
     *  methods will resolve its async inspection methods.
     */
    E(this, "provider");
    /**
     *  The block number of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */
    E(this, "blockNumber");
    /**
     *  The blockHash of the block that this transaction was included in.
     *
     *  This is ``null`` for pending transactions.
     */
    E(this, "blockHash");
    /**
     *  The index within the block that this transaction resides at.
     */
    E(this, "index");
    /**
     *  The transaction hash.
     */
    E(this, "hash");
    /**
     *  The [[link-eip-2718]] transaction envelope type. This is
     *  ``0`` for legacy transactions types.
     */
    E(this, "type");
    /**
     *  The receiver of this transaction.
     *
     *  If ``null``, then the transaction is an initcode transaction.
     *  This means the result of executing the [[data]] will be deployed
     *  as a new contract on chain (assuming it does not revert) and the
     *  address may be computed using [[getCreateAddress]].
     */
    E(this, "to");
    /**
     *  The sender of this transaction. It is implicitly computed
     *  from the transaction pre-image hash (as the digest) and the
     *  [[signature]] using ecrecover.
     */
    E(this, "from");
    /**
     *  The nonce, which is used to prevent replay attacks and offer
     *  a method to ensure transactions from a given sender are explicitly
     *  ordered.
     *
     *  When sending a transaction, this must be equal to the number of
     *  transactions ever sent by [[from]].
     */
    E(this, "nonce");
    /**
     *  The maximum units of gas this transaction can consume. If execution
     *  exceeds this, the entries transaction is reverted and the sender
     *  is charged for the full amount, despite not state changes being made.
     */
    E(this, "gasLimit");
    /**
     *  The gas price can have various values, depending on the network.
     *
     *  In modern networks, for transactions that are included this is
     *  the //effective gas price// (the fee per gas that was actually
     *  charged), while for transactions that have not been included yet
     *  is the [[maxFeePerGas]].
     *
     *  For legacy transactions, or transactions on legacy networks, this
     *  is the fee that will be charged per unit of gas the transaction
     *  consumes.
     */
    E(this, "gasPrice");
    /**
     *  The maximum priority fee (per unit of gas) to allow a
     *  validator to charge the sender. This is inclusive of the
     *  [[maxFeeFeePerGas]].
     */
    E(this, "maxPriorityFeePerGas");
    /**
     *  The maximum fee (per unit of gas) to allow this transaction
     *  to charge the sender.
     */
    E(this, "maxFeePerGas");
    /**
     *  The [[link-eip-4844]] max fee per BLOb gas.
     */
    E(this, "maxFeePerBlobGas");
    /**
     *  The data.
     */
    E(this, "data");
    /**
     *  The value, in wei. Use [[formatEther]] to format this value
     *  as ether.
     */
    E(this, "value");
    /**
     *  The chain ID.
     */
    E(this, "chainId");
    /**
     *  The signature.
     */
    E(this, "signature");
    /**
     *  The [[link-eip-2930]] access list for transaction types that
     *  support it, otherwise ``null``.
     */
    E(this, "accessList");
    /**
     *  The [[link-eip-4844]] BLOb versioned hashes.
     */
    E(this, "blobVersionedHashes");
    X(this, Ze);
    this.provider = e, this.blockNumber = t.blockNumber != null ? t.blockNumber : null, this.blockHash = t.blockHash != null ? t.blockHash : null, this.hash = t.hash, this.index = t.index, this.type = t.type, this.from = t.from, this.to = t.to || null, this.gasLimit = t.gasLimit, this.nonce = t.nonce, this.data = t.data, this.value = t.value, this.gasPrice = t.gasPrice, this.maxPriorityFeePerGas = t.maxPriorityFeePerGas != null ? t.maxPriorityFeePerGas : null, this.maxFeePerGas = t.maxFeePerGas != null ? t.maxFeePerGas : null, this.maxFeePerBlobGas = t.maxFeePerBlobGas != null ? t.maxFeePerBlobGas : null, this.chainId = t.chainId, this.signature = t.signature, this.accessList = t.accessList != null ? t.accessList : null, this.blobVersionedHashes = t.blobVersionedHashes != null ? t.blobVersionedHashes : null, K(this, Ze, -1);
  }
  /**
   *  Returns a JSON-compatible representation of this transaction.
   */
  toJSON() {
    const { blockNumber: t, blockHash: e, index: r, hash: i, type: s, to: o, from: f, nonce: c, data: d, signature: h, accessList: v, blobVersionedHashes: x } = this;
    return {
      _type: "TransactionResponse",
      accessList: v,
      blockNumber: t,
      blockHash: e,
      blobVersionedHashes: x,
      chainId: fe(this.chainId),
      data: d,
      from: f,
      gasLimit: fe(this.gasLimit),
      gasPrice: fe(this.gasPrice),
      hash: i,
      maxFeePerGas: fe(this.maxFeePerGas),
      maxPriorityFeePerGas: fe(this.maxPriorityFeePerGas),
      maxFeePerBlobGas: fe(this.maxFeePerBlobGas),
      nonce: c,
      signature: h,
      to: o,
      index: r,
      type: s,
      value: fe(this.value)
    };
  }
  /**
   *  Resolves to the Block that this transaction was included in.
   *
   *  This will return null if the transaction has not been included yet.
   */
  async getBlock() {
    let t = this.blockNumber;
    if (t == null) {
      const r = await this.getTransaction();
      r && (t = r.blockNumber);
    }
    if (t == null)
      return null;
    const e = this.provider.getBlock(t);
    if (e == null)
      throw new Error("TODO");
    return e;
  }
  /**
   *  Resolves to this transaction being re-requested from the
   *  provider. This can be used if you have an unmined transaction
   *  and wish to get an up-to-date populated instance.
   */
  async getTransaction() {
    return this.provider.getTransaction(this.hash);
  }
  /**
   *  Resolve to the number of confirmations this transaction has.
   */
  async confirmations() {
    if (this.blockNumber == null) {
      const { tx: e, blockNumber: r } = await jr({
        tx: this.getTransaction(),
        blockNumber: this.provider.getBlockNumber()
      });
      return e == null || e.blockNumber == null ? 0 : r - e.blockNumber + 1;
    }
    return await this.provider.getBlockNumber() - this.blockNumber + 1;
  }
  /**
   *  Resolves once this transaction has been mined and has
   *  %%confirms%% blocks including it (default: ``1``) with an
   *  optional %%timeout%%.
   *
   *  This can resolve to ``null`` only if %%confirms%% is ``0``
   *  and the transaction has not been mined, otherwise this will
   *  wait until enough confirmations have completed.
   */
  async wait(t, e) {
    const r = t ?? 1, i = e ?? 0;
    let s = I(this, Ze), o = -1, f = s === -1;
    const c = async () => {
      if (f)
        return null;
      const { blockNumber: x, nonce: N } = await jr({
        blockNumber: this.provider.getBlockNumber(),
        nonce: this.provider.getTransactionCount(this.from)
      });
      if (N < this.nonce) {
        s = x;
        return;
      }
      if (f)
        return null;
      const _ = await this.getTransaction();
      if (!(_ && _.blockNumber != null))
        for (o === -1 && (o = s - 3, o < I(this, Ze) && (o = I(this, Ze))); o <= x; ) {
          if (f)
            return null;
          const k = await this.provider.getBlock(o, !0);
          if (k == null)
            return;
          for (const G of k)
            if (G === this.hash)
              return;
          for (let G = 0; G < k.length; G++) {
            const U = await k.getTransaction(G);
            if (U.from === this.from && U.nonce === this.nonce) {
              if (f)
                return null;
              const J = await this.provider.getTransactionReceipt(U.hash);
              if (J == null || x - J.blockNumber + 1 < r)
                return;
              let H = "replaced";
              U.data === this.data && U.to === this.to && U.value === this.value ? H = "repriced" : U.data === "0x" && U.from === U.to && U.value === Oa && (H = "cancelled"), $(!1, "transaction was replaced", "TRANSACTION_REPLACED", {
                cancelled: H === "replaced" || H === "cancelled",
                reason: H,
                replacement: U.replaceableTransaction(s),
                hash: U.hash,
                receipt: J
              });
            }
          }
          o++;
        }
    }, d = (x) => {
      if (x == null || x.status !== 0)
        return x;
      $(!1, "transaction execution reverted", "CALL_EXCEPTION", {
        action: "sendTransaction",
        data: null,
        reason: null,
        invocation: null,
        revert: null,
        transaction: {
          to: x.to,
          from: x.from,
          data: ""
          // @TODO: in v7, split out sendTransaction properties
        },
        receipt: x
      });
    }, h = await this.provider.getTransactionReceipt(this.hash);
    if (r === 0)
      return d(h);
    if (h) {
      if (await h.confirmations() >= r)
        return d(h);
    } else if (await c(), r === 0)
      return null;
    return await new Promise((x, N) => {
      const _ = [], k = () => {
        _.forEach((U) => U());
      };
      if (_.push(() => {
        f = !0;
      }), i > 0) {
        const U = setTimeout(() => {
          k(), N(lr("wait for transaction timeout", "TIMEOUT"));
        }, i);
        _.push(() => {
          clearTimeout(U);
        });
      }
      const G = async (U) => {
        if (await U.confirmations() >= r) {
          k();
          try {
            x(d(U));
          } catch (J) {
            N(J);
          }
        }
      };
      if (_.push(() => {
        this.provider.off(this.hash, G);
      }), this.provider.on(this.hash, G), s >= 0) {
        const U = async () => {
          try {
            await c();
          } catch (J) {
            if (Dn(J, "TRANSACTION_REPLACED")) {
              k(), N(J);
              return;
            }
          }
          f || this.provider.once("block", U);
        };
        _.push(() => {
          this.provider.off("block", U);
        }), this.provider.once("block", U);
      }
    });
  }
  /**
   *  Returns ``true`` if this transaction has been included.
   *
   *  This is effective only as of the time the TransactionResponse
   *  was instantiated. To get up-to-date information, use
   *  [[getTransaction]].
   *
   *  This provides a Type Guard that this transaction will have
   *  non-null property values for properties that are null for
   *  unmined transactions.
   */
  isMined() {
    return this.blockHash != null;
  }
  /**
   *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
   *  transaction.
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isLegacy() {
    return this.type === 0;
  }
  /**
   *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
   *  transaction. See [[link-eip-2070]].
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isBerlin() {
    return this.type === 1;
  }
  /**
   *  Returns true if the transaction is a London (i.e. ``type == 2``)
   *  transaction. See [[link-eip-1559]].
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isLondon() {
    return this.type === 2;
  }
  /**
   *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
   *  transaction. See [[link-eip-4844]].
   */
  isCancun() {
    return this.type === 3;
  }
  /**
   *  Returns a filter which can be used to listen for orphan events
   *  that evict this transaction.
   */
  removedEvent() {
    return $(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), Sa(this);
  }
  /**
   *  Returns a filter which can be used to listen for orphan events
   *  that re-order this event against %%other%%.
   */
  reorderedEvent(t) {
    return $(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), $(!t || t.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", { operation: "removeEvent()" }), _a(this, t);
  }
  /**
   *  Returns a new TransactionResponse instance which has the ability to
   *  detect (and throw an error) if the transaction is replaced, which
   *  will begin scanning at %%startBlock%%.
   *
   *  This should generally not be used by developers and is intended
   *  primarily for internal use. Setting an incorrect %%startBlock%% can
   *  have devastating performance consequences if used incorrectly.
   */
  replaceableTransaction(t) {
    R(Number.isInteger(t) && t >= 0, "invalid startBlock", "startBlock", t);
    const e = new Ri(this, this.provider);
    return K(e, Ze, t), e;
  }
};
Ze = new WeakMap();
let hi = Ri;
function _a(n, t) {
  return { orphan: "reorder-transaction", tx: n, other: t };
}
function Sa(n) {
  return { orphan: "drop-transaction", tx: n };
}
function Sl(n) {
  return { orphan: "drop-log", log: {
    transactionHash: n.transactionHash,
    blockHash: n.blockHash,
    blockNumber: n.blockNumber,
    address: n.address,
    data: n.data,
    topics: Object.freeze(n.topics.slice()),
    index: n.index
  } };
}
class Ei extends Er {
  /**
   * @_ignore:
   */
  constructor(e, r, i) {
    super(e, e.provider);
    /**
     *  The Contract Interface.
     */
    E(this, "interface");
    /**
     *  The matching event.
     */
    E(this, "fragment");
    /**
     *  The parsed arguments passed to the event by ``emit``.
     */
    E(this, "args");
    const s = r.decodeEventLog(i, e.data, e.topics);
    z(this, { args: s, fragment: i, interface: r });
  }
  /**
   *  The name of the event.
   */
  get eventName() {
    return this.fragment.name;
  }
  /**
   *  The signature of the event.
   */
  get eventSignature() {
    return this.fragment.format();
  }
}
class Pa extends Er {
  /**
   * @_ignore:
   */
  constructor(e, r) {
    super(e, e.provider);
    /**
     *  The error encounted when trying to decode the log.
     */
    E(this, "error");
    z(this, { error: r });
  }
}
var Rn;
class Pl extends _l {
  /**
   *  @_ignore:
   */
  constructor(e, r, i) {
    super(i, r);
    X(this, Rn);
    K(this, Rn, e);
  }
  /**
   *  The parsed logs for any [[Log]] which has a matching event in the
   *  Contract ABI.
   */
  get logs() {
    return super.logs.map((e) => {
      const r = e.topics.length ? I(this, Rn).getEvent(e.topics[0]) : null;
      if (r)
        try {
          return new Ei(e, I(this, Rn), r);
        } catch (i) {
          return new Pa(e, i);
        }
      return e;
    });
  }
}
Rn = new WeakMap();
var Kn;
class Ni extends hi {
  /**
   *  @_ignore:
   */
  constructor(e, r, i) {
    super(i, r);
    X(this, Kn);
    K(this, Kn, e);
  }
  /**
   *  Resolves once this transaction has been mined and has
   *  %%confirms%% blocks including it (default: ``1``) with an
   *  optional %%timeout%%.
   *
   *  This can resolve to ``null`` only if %%confirms%% is ``0``
   *  and the transaction has not been mined, otherwise this will
   *  wait until enough confirmations have completed.
   */
  async wait(e, r) {
    const i = await super.wait(e, r);
    return i == null ? null : new Pl(I(this, Kn), this.provider, i);
  }
}
Kn = new WeakMap();
class Ua extends mu {
  /**
   *  @_event:
   */
  constructor(e, r, i, s) {
    super(e, r, i);
    /**
     *  The log with no matching events.
     */
    E(this, "log");
    z(this, { log: s });
  }
  /**
   *  Resolves to the block the event occured in.
   */
  async getBlock() {
    return await this.log.getBlock();
  }
  /**
   *  Resolves to the transaction the event occured in.
   */
  async getTransaction() {
    return await this.log.getTransaction();
  }
  /**
   *  Resolves to the transaction receipt the event occured in.
   */
  async getTransactionReceipt() {
    return await this.log.getTransactionReceipt();
  }
}
class Ul extends Ua {
  /**
   *  @_ignore:
   */
  constructor(t, e, r, i, s) {
    super(t, e, r, new Ei(s, t.interface, i));
    const o = t.interface.decodeEventLog(i, this.log.data, this.log.topics);
    z(this, { args: o, fragment: i });
  }
  /**
   *  The event name.
   */
  get eventName() {
    return this.fragment.name;
  }
  /**
   *  The event signature.
   */
  get eventSignature() {
    return this.fragment.format();
  }
}
const Us = BigInt(0);
function Ba(n) {
  return n && typeof n.call == "function";
}
function Ca(n) {
  return n && typeof n.estimateGas == "function";
}
function Nr(n) {
  return n && typeof n.resolveName == "function";
}
function Fa(n) {
  return n && typeof n.sendTransaction == "function";
}
function La(n) {
  if (n != null) {
    if (Nr(n))
      return n;
    if (n.provider)
      return n.provider;
  }
}
var Wn;
class Bl {
  constructor(t, e, r) {
    X(this, Wn);
    E(this, "fragment");
    if (z(this, { fragment: e }), e.inputs.length < r.length)
      throw new Error("too many arguments");
    const i = hn(t.runner, "resolveName"), s = Nr(i) ? i : null;
    K(this, Wn, async function() {
      const o = await Promise.all(e.inputs.map((f, c) => r[c] == null ? null : f.walkAsync(r[c], (h, v) => h === "address" ? Array.isArray(v) ? Promise.all(v.map((x) => Hn(x, s))) : Hn(v, s) : v)));
      return t.interface.encodeFilterTopics(e, o);
    }());
  }
  getTopicFilter() {
    return I(this, Wn);
  }
}
Wn = new WeakMap();
function hn(n, t) {
  return n == null ? null : typeof n[t] == "function" ? n : n.provider && typeof n.provider[t] == "function" ? n.provider : null;
}
function an(n) {
  return n == null ? null : n.provider || null;
}
async function Da(n, t) {
  const e = Jt.dereference(n, "overrides");
  R(typeof e == "object", "invalid overrides parameter", "overrides", n);
  const r = Ol(e);
  return R(r.to == null || (t || []).indexOf("to") >= 0, "cannot override to", "overrides.to", r.to), R(r.data == null || (t || []).indexOf("data") >= 0, "cannot override data", "overrides.data", r.data), r.from && (r.from = r.from), r;
}
async function Cl(n, t, e) {
  const r = hn(n, "resolveName"), i = Nr(r) ? r : null;
  return await Promise.all(t.map((s, o) => s.walkAsync(e[o], (f, c) => (c = Jt.dereference(c, f), f === "address" ? Hn(c, i) : c))));
}
function Fl(n) {
  const t = async function(o) {
    const f = await Da(o, ["data"]);
    f.to = await n.getAddress(), f.from && (f.from = await Hn(f.from, La(n.runner)));
    const c = n.interface, d = je(f.value || Us, "overrides.value") === Us, h = (f.data || "0x") === "0x";
    c.fallback && !c.fallback.payable && c.receive && !h && !d && R(!1, "cannot send data to receive or send value to non-payable fallback", "overrides", o), R(c.fallback || h, "cannot send data to receive-only contract", "overrides.data", f.data);
    const v = c.receive || c.fallback && c.fallback.payable;
    return R(v || d, "cannot send value to non-payable fallback", "overrides.value", f.value), R(c.fallback || h, "cannot send data to receive-only contract", "overrides.data", f.data), f;
  }, e = async function(o) {
    const f = hn(n.runner, "call");
    $(Ba(f), "contract runner does not support calling", "UNSUPPORTED_OPERATION", { operation: "call" });
    const c = await t(o);
    try {
      return await f.call(c);
    } catch (d) {
      throw Ls(d) && d.data ? n.interface.makeError(d.data, c) : d;
    }
  }, r = async function(o) {
    const f = n.runner;
    $(Fa(f), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", { operation: "sendTransaction" });
    const c = await f.sendTransaction(await t(o)), d = an(n.runner);
    return new Ni(n.interface, d, c);
  }, i = async function(o) {
    const f = hn(n.runner, "estimateGas");
    return $(Ca(f), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", { operation: "estimateGas" }), await f.estimateGas(await t(o));
  }, s = async (o) => await r(o);
  return z(s, {
    _contract: n,
    estimateGas: i,
    populateTransaction: t,
    send: r,
    staticCall: e
  }), s;
}
function Ll(n, t) {
  const e = function(...d) {
    const h = n.interface.getFunction(t, d);
    return $(h, "no matching fragment", "UNSUPPORTED_OPERATION", {
      operation: "fragment",
      info: { key: t, args: d }
    }), h;
  }, r = async function(...d) {
    const h = e(...d);
    let v = {};
    if (h.inputs.length + 1 === d.length && (v = await Da(d.pop()), v.from && (v.from = await Hn(v.from, La(n.runner)))), h.inputs.length !== d.length)
      throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
    const x = await Cl(n.runner, h.inputs, d);
    return Object.assign({}, v, await jr({
      to: n.getAddress(),
      data: n.interface.encodeFunctionData(h, x)
    }));
  }, i = async function(...d) {
    const h = await f(...d);
    return h.length === 1 ? h[0] : h;
  }, s = async function(...d) {
    const h = n.runner;
    $(Fa(h), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", { operation: "sendTransaction" });
    const v = await h.sendTransaction(await r(...d)), x = an(n.runner);
    return new Ni(n.interface, x, v);
  }, o = async function(...d) {
    const h = hn(n.runner, "estimateGas");
    return $(Ca(h), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", { operation: "estimateGas" }), await h.estimateGas(await r(...d));
  }, f = async function(...d) {
    const h = hn(n.runner, "call");
    $(Ba(h), "contract runner does not support calling", "UNSUPPORTED_OPERATION", { operation: "call" });
    const v = await r(...d);
    let x = "0x";
    try {
      x = await h.call(v);
    } catch (_) {
      throw Ls(_) && _.data ? n.interface.makeError(_.data, v) : _;
    }
    const N = e(...d);
    return n.interface.decodeFunctionResult(N, x);
  }, c = async (...d) => e(...d).constant ? await i(...d) : await s(...d);
  return z(c, {
    name: n.interface.getFunctionName(t),
    _contract: n,
    _key: t,
    getFragment: e,
    estimateGas: o,
    populateTransaction: r,
    send: s,
    staticCall: i,
    staticCallResult: f
  }), Object.defineProperty(c, "fragment", {
    configurable: !1,
    enumerable: !0,
    get: () => {
      const d = n.interface.getFunction(t);
      return $(d, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: { key: t }
      }), d;
    }
  }), c;
}
function Dl(n, t) {
  const e = function(...i) {
    const s = n.interface.getEvent(t, i);
    return $(s, "no matching fragment", "UNSUPPORTED_OPERATION", {
      operation: "fragment",
      info: { key: t, args: i }
    }), s;
  }, r = function(...i) {
    return new Bl(n, e(...i), i);
  };
  return z(r, {
    name: n.interface.getEventName(t),
    _contract: n,
    _key: t,
    getFragment: e
  }), Object.defineProperty(r, "fragment", {
    configurable: !1,
    enumerable: !0,
    get: () => {
      const i = n.interface.getEvent(t);
      return $(i, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: { key: t }
      }), i;
    }
  }), r;
}
const hr = Symbol.for("_ethersInternal_contract"), $a = /* @__PURE__ */ new WeakMap();
function $l(n, t) {
  $a.set(n[hr], t);
}
function se(n) {
  return $a.get(n[hr]);
}
function Gl(n) {
  return n && typeof n == "object" && "getTopicFilter" in n && typeof n.getTopicFilter == "function" && n.fragment;
}
async function Ai(n, t) {
  let e, r = null;
  if (Array.isArray(t)) {
    const s = function(o) {
      if (Pe(o, 32))
        return o;
      const f = n.interface.getEvent(o);
      return R(f, "unknown fragment", "name", o), f.topicHash;
    };
    e = t.map((o) => o == null ? null : Array.isArray(o) ? o.map(s) : s(o));
  } else t === "*" ? e = [null] : typeof t == "string" ? Pe(t, 32) ? e = [t] : (r = n.interface.getEvent(t), R(r, "unknown fragment", "event", t), e = [r.topicHash]) : Gl(t) ? e = await t.getTopicFilter() : "fragment" in t ? (r = t.fragment, e = [r.topicHash]) : R(!1, "unknown event name", "event", t);
  e = e.map((s) => {
    if (s == null)
      return null;
    if (Array.isArray(s)) {
      const o = Array.from(new Set(s.map((f) => f.toLowerCase())).values());
      return o.length === 1 ? o[0] : (o.sort(), o);
    }
    return s.toLowerCase();
  });
  const i = e.map((s) => s == null ? "null" : Array.isArray(s) ? s.join("|") : s).join("&");
  return { fragment: r, tag: i, topics: e };
}
async function Bn(n, t) {
  const { subs: e } = se(n);
  return e.get((await Ai(n, t)).tag) || null;
}
async function Bs(n, t, e) {
  const r = an(n.runner);
  $(r, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", { operation: t });
  const { fragment: i, tag: s, topics: o } = await Ai(n, e), { addr: f, subs: c } = se(n);
  let d = c.get(s);
  if (!d) {
    const v = { address: f || n, topics: o }, x = (G) => {
      let U = i;
      if (U == null)
        try {
          U = n.interface.getEvent(G.topics[0]);
        } catch {
        }
      if (U) {
        const J = U, H = i ? n.interface.decodeEventLog(i, G.data, G.topics) : [];
        yi(n, e, H, (it) => new Ul(n, it, e, J, G));
      } else
        yi(n, e, [], (J) => new Ua(n, J, e, G));
    };
    let N = [];
    d = { tag: s, listeners: [], start: () => {
      N.length || N.push(r.on(v, x));
    }, stop: async () => {
      if (N.length == 0)
        return;
      let G = N;
      N = [], await Promise.all(G), r.off(v, x);
    } }, c.set(s, d);
  }
  return d;
}
let mi = Promise.resolve();
async function Hl(n, t, e, r) {
  await mi;
  const i = await Bn(n, t);
  if (!i)
    return !1;
  const s = i.listeners.length;
  return i.listeners = i.listeners.filter(({ listener: o, once: f }) => {
    const c = Array.from(e);
    r && c.push(r(f ? null : o));
    try {
      o.call(n, ...c);
    } catch {
    }
    return !f;
  }), i.listeners.length === 0 && (i.stop(), se(n).subs.delete(i.tag)), s > 0;
}
async function yi(n, t, e, r) {
  try {
    await mi;
  } catch {
  }
  const i = Hl(n, t, e, r);
  return mi = i, await i;
}
const tr = ["then"];
var Cs;
Cs = hr;
const Ln = class Ln {
  /**
   *  Creates a new contract connected to %%target%% with the %%abi%% and
   *  optionally connected to a %%runner%% to perform operations on behalf
   *  of.
   */
  constructor(t, e, r, i) {
    /**
     *  The target to connect to.
     *
     *  This can be an address, ENS name or any [[Addressable]], such as
     *  another contract. To get the resovled address, use the ``getAddress``
     *  method.
     */
    E(this, "target");
    /**
     *  The contract Interface.
     */
    E(this, "interface");
    /**
     *  The connected runner. This is generally a [[Provider]] or a
     *  [[Signer]], which dictates what operations are supported.
     *
     *  For example, a **Contract** connected to a [[Provider]] may
     *  only execute read-only operations.
     */
    E(this, "runner");
    /**
     *  All the Events available on this contract.
     */
    E(this, "filters");
    /**
     *  @_ignore:
     */
    E(this, Cs);
    /**
     *  The fallback or receive function if any.
     */
    E(this, "fallback");
    R(typeof t == "string" || wa(t), "invalid value for Contract target", "target", t), r == null && (r = null);
    const s = pi.from(e);
    z(this, { target: t, runner: r, interface: s }), Object.defineProperty(this, hr, { value: {} });
    let o, f = null, c = null;
    if (i) {
      const v = an(r);
      c = new Ni(this.interface, v, i);
    }
    let d = /* @__PURE__ */ new Map();
    if (typeof t == "string")
      if (Pe(t))
        f = t, o = Promise.resolve(t);
      else {
        const v = hn(r, "resolveName");
        if (!Nr(v))
          throw lr("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
            operation: "resolveName"
          });
        o = v.resolveName(t).then((x) => {
          if (x == null)
            throw lr("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
              value: t
            });
          return se(this).addr = x, x;
        });
      }
    else
      o = t.getAddress().then((v) => {
        if (v == null)
          throw new Error("TODO");
        return se(this).addr = v, v;
      });
    $l(this, { addrPromise: o, addr: f, deployTx: c, subs: d });
    const h = new Proxy({}, {
      get: (v, x, N) => {
        if (typeof x == "symbol" || tr.indexOf(x) >= 0)
          return Reflect.get(v, x, N);
        try {
          return this.getEvent(x);
        } catch (_) {
          if (!Dn(_, "INVALID_ARGUMENT") || _.argument !== "key")
            throw _;
        }
      },
      has: (v, x) => tr.indexOf(x) >= 0 ? Reflect.has(v, x) : Reflect.has(v, x) || this.interface.hasEvent(String(x))
    });
    return z(this, { filters: h }), z(this, {
      fallback: s.receive || s.fallback ? Fl(this) : null
    }), new Proxy(this, {
      get: (v, x, N) => {
        if (typeof x == "symbol" || x in v || tr.indexOf(x) >= 0)
          return Reflect.get(v, x, N);
        try {
          return v.getFunction(x);
        } catch (_) {
          if (!Dn(_, "INVALID_ARGUMENT") || _.argument !== "key")
            throw _;
        }
      },
      has: (v, x) => typeof x == "symbol" || x in v || tr.indexOf(x) >= 0 ? Reflect.has(v, x) : v.interface.hasFunction(x)
    });
  }
  /**
   *  Return a new Contract instance with the same target and ABI, but
   *  a different %%runner%%.
   */
  connect(t) {
    return new Ln(this.target, this.interface, t);
  }
  /**
   *  Return a new Contract instance with the same ABI and runner, but
   *  a different %%target%%.
   */
  attach(t) {
    return new Ln(t, this.interface, this.runner);
  }
  /**
   *  Return the resolved address of this Contract.
   */
  async getAddress() {
    return await se(this).addrPromise;
  }
  /**
   *  Return the deployed bytecode or null if no bytecode is found.
   */
  async getDeployedCode() {
    const t = an(this.runner);
    $(t, "runner does not support .provider", "UNSUPPORTED_OPERATION", { operation: "getDeployedCode" });
    const e = await t.getCode(await this.getAddress());
    return e === "0x" ? null : e;
  }
  /**
   *  Resolve to this Contract once the bytecode has been deployed, or
   *  resolve immediately if already deployed.
   */
  async waitForDeployment() {
    const t = this.deploymentTransaction();
    if (t)
      return await t.wait(), this;
    if (await this.getDeployedCode() != null)
      return this;
    const r = an(this.runner);
    return $(r != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", { operation: "waitForDeployment" }), new Promise((i, s) => {
      const o = async () => {
        try {
          if (await this.getDeployedCode() != null)
            return i(this);
          r.once("block", o);
        } catch (f) {
          s(f);
        }
      };
      o();
    });
  }
  /**
   *  Return the transaction used to deploy this contract.
   *
   *  This is only available if this instance was returned from a
   *  [[ContractFactory]].
   */
  deploymentTransaction() {
    return se(this).deployTx;
  }
  /**
   *  Return the function for a given name. This is useful when a contract
   *  method name conflicts with a JavaScript name such as ``prototype`` or
   *  when using a Contract programatically.
   */
  getFunction(t) {
    return typeof t != "string" && (t = t.format()), Ll(this, t);
  }
  /**
   *  Return the event for a given name. This is useful when a contract
   *  event name conflicts with a JavaScript name such as ``prototype`` or
   *  when using a Contract programatically.
   */
  getEvent(t) {
    return typeof t != "string" && (t = t.format()), Dl(this, t);
  }
  /**
   *  @_ignore:
   */
  async queryTransaction(t) {
    throw new Error("@TODO");
  }
  /*
      // @TODO: this is a non-backwards compatible change, but will be added
      //        in v7 and in a potential SmartContract class in an upcoming
      //        v6 release
      async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
          const provider = getProvider(this.runner);
          assert(provider, "contract runner does not have a provider",
              "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });
  
          const receipt = await provider.getTransactionReceipt(hash);
          if (receipt == null) { return null; }
  
          return new ContractTransactionReceipt(this.interface, provider, receipt);
      }
      */
  /**
   *  Provide historic access to event data for %%event%% in the range
   *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
   *  inclusive.
   */
  async queryFilter(t, e, r) {
    e == null && (e = 0), r == null && (r = "latest");
    const { addr: i, addrPromise: s } = se(this), o = i || await s, { fragment: f, topics: c } = await Ai(this, t), d = { address: o, topics: c, fromBlock: e, toBlock: r }, h = an(this.runner);
    return $(h, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", { operation: "queryFilter" }), (await h.getLogs(d)).map((v) => {
      let x = f;
      if (x == null)
        try {
          x = this.interface.getEvent(v.topics[0]);
        } catch {
        }
      if (x)
        try {
          return new Ei(v, this.interface, x);
        } catch (N) {
          return new Pa(v, N);
        }
      return new Er(v, h);
    });
  }
  /**
   *  Add an event %%listener%% for the %%event%%.
   */
  async on(t, e) {
    const r = await Bs(this, "on", t);
    return r.listeners.push({ listener: e, once: !1 }), r.start(), this;
  }
  /**
   *  Add an event %%listener%% for the %%event%%, but remove the listener
   *  after it is fired once.
   */
  async once(t, e) {
    const r = await Bs(this, "once", t);
    return r.listeners.push({ listener: e, once: !0 }), r.start(), this;
  }
  /**
   *  Emit an %%event%% calling all listeners with %%args%%.
   *
   *  Resolves to ``true`` if any listeners were called.
   */
  async emit(t, ...e) {
    return await yi(this, t, e, null);
  }
  /**
   *  Resolves to the number of listeners of %%event%% or the total number
   *  of listeners if unspecified.
   */
  async listenerCount(t) {
    if (t) {
      const i = await Bn(this, t);
      return i ? i.listeners.length : 0;
    }
    const { subs: e } = se(this);
    let r = 0;
    for (const { listeners: i } of e.values())
      r += i.length;
    return r;
  }
  /**
   *  Resolves to the listeners subscribed to %%event%% or all listeners
   *  if unspecified.
   */
  async listeners(t) {
    if (t) {
      const i = await Bn(this, t);
      return i ? i.listeners.map(({ listener: s }) => s) : [];
    }
    const { subs: e } = se(this);
    let r = [];
    for (const { listeners: i } of e.values())
      r = r.concat(i.map(({ listener: s }) => s));
    return r;
  }
  /**
   *  Remove the %%listener%% from the listeners for %%event%% or remove
   *  all listeners if unspecified.
   */
  async off(t, e) {
    const r = await Bn(this, t);
    if (!r)
      return this;
    if (e) {
      const i = r.listeners.map(({ listener: s }) => s).indexOf(e);
      i >= 0 && r.listeners.splice(i, 1);
    }
    return (e == null || r.listeners.length === 0) && (r.stop(), se(this).subs.delete(r.tag)), this;
  }
  /**
   *  Remove all the listeners for %%event%% or remove all listeners if
   *  unspecified.
   */
  async removeAllListeners(t) {
    if (t) {
      const e = await Bn(this, t);
      if (!e)
        return this;
      e.stop(), se(this).subs.delete(e.tag);
    } else {
      const { subs: e } = se(this);
      for (const { tag: r, stop: i } of e.values())
        i(), e.delete(r);
    }
    return this;
  }
  /**
   *  Alias for [on].
   */
  async addListener(t, e) {
    return await this.on(t, e);
  }
  /**
   *  Alias for [off].
   */
  async removeListener(t, e) {
    return await this.off(t, e);
  }
  /**
   *  Create a new Class for the %%abi%%.
   */
  static buildClass(t) {
    class e extends Ln {
      constructor(i, s = null) {
        super(i, t, s);
      }
    }
    return e;
  }
  /**
   *  Create a new BaseContract with a specified Interface.
   */
  static from(t, e, r) {
    return r == null && (r = null), new this(t, e, r);
  }
};
let gi = Ln;
function Vl() {
  return gi;
}
class zl extends Vl() {
}
var Ga = {};
const ql = [
  {
    constant: !0,
    inputs: [],
    name: "name",
    outputs: [
      {
        name: "",
        type: "string"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        name: "_spender",
        type: "address"
      },
      {
        name: "_value",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        name: "_from",
        type: "address"
      },
      {
        name: "_to",
        type: "address"
      },
      {
        name: "_value",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "decimals",
    outputs: [
      {
        name: "",
        type: "uint8"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        name: "_owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        name: "balance",
        type: "uint256"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !0,
    inputs: [],
    name: "symbol",
    outputs: [
      {
        name: "",
        type: "string"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    constant: !1,
    inputs: [
      {
        name: "_to",
        type: "address"
      },
      {
        name: "_value",
        type: "uint256"
      }
    ],
    name: "transfer",
    outputs: [
      {
        name: "",
        type: "bool"
      }
    ],
    payable: !1,
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    constant: !0,
    inputs: [
      {
        name: "_owner",
        type: "address"
      },
      {
        name: "_spender",
        type: "address"
      }
    ],
    name: "allowance",
    outputs: [
      {
        name: "",
        type: "uint256"
      }
    ],
    payable: !1,
    stateMutability: "view",
    type: "function"
  },
  {
    payable: !0,
    stateMutability: "payable",
    type: "fallback"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        name: "spender",
        type: "address"
      },
      {
        indexed: !1,
        name: "value",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        name: "value",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  }
], Zl = {
  ERC20ABI: ql
}, Kl = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string"
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "approved",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], Wl = {
  ERC721ABI: Kl
}, Jl = [
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "AdminApproved",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "AdminRevoked",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "approved",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Approval",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "extension",
        type: "address"
      }
    ],
    name: "ApproveTransferUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "DefaultRoyaltiesUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "enabled",
        type: "bool"
      }
    ],
    name: "ExtensionApproveTransferUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "ExtensionBlacklisted",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "ExtensionRegistered",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "ExtensionRoyaltiesUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "ExtensionUnregistered",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint8",
        name: "version",
        type: "uint8"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "permissions",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "MintPermissionsUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "RoyaltiesUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "Transfer",
    type: "event"
  },
  {
    inputs: [],
    name: "VERSION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      }
    ],
    name: "approveAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      }
    ],
    name: "blacklistExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "getAdmins",
    outputs: [
      {
        internalType: "address[]",
        name: "admins",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getApproveTransfer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getExtensions",
    outputs: [
      {
        internalType: "address[]",
        name: "extensions",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getFeeBps",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getFeeRecipients",
    outputs: [
      {
        internalType: "address payable[]",
        name: "",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getFees",
    outputs: [
      {
        internalType: "address payable[]",
        name: "",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getRoyalties",
    outputs: [
      {
        internalType: "address payable[]",
        name: "",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string"
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      }
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "mintBase",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "string",
        name: "uri",
        type: "string"
      }
    ],
    name: "mintBase",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "string[]",
        name: "uris",
        type: "string[]"
      }
    ],
    name: "mintBaseBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint16",
        name: "count",
        type: "uint16"
      }
    ],
    name: "mintBaseBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "mintExtension",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "string",
        name: "uri",
        type: "string"
      }
    ],
    name: "mintExtension",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "string[]",
        name: "uris",
        type: "string[]"
      }
    ],
    name: "mintExtensionBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint16",
        name: "count",
        type: "uint16"
      }
    ],
    name: "mintExtensionBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        internalType: "string",
        name: "baseURI",
        type: "string"
      }
    ],
    name: "registerExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        internalType: "string",
        name: "baseURI",
        type: "string"
      },
      {
        internalType: "bool",
        name: "baseURIIdentical",
        type: "bool"
      }
    ],
    name: "registerExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      }
    ],
    name: "revokeAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      }
    ],
    name: "setApproveTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "enabled",
        type: "bool"
      }
    ],
    name: "setApproveTransferExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "uri",
        type: "string"
      }
    ],
    name: "setBaseTokenURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "uri",
        type: "string"
      }
    ],
    name: "setBaseTokenURIExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "uri",
        type: "string"
      },
      {
        internalType: "bool",
        name: "identical",
        type: "bool"
      }
    ],
    name: "setBaseTokenURIExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        internalType: "address",
        name: "permissions",
        type: "address"
      }
    ],
    name: "setMintPermissions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "setRoyalties",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "setRoyalties",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "setRoyaltiesExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "uri",
        type: "string"
      }
    ],
    name: "setTokenURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      },
      {
        internalType: "string[]",
        name: "uris",
        type: "string[]"
      }
    ],
    name: "setTokenURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      },
      {
        internalType: "string[]",
        name: "uris",
        type: "string[]"
      }
    ],
    name: "setTokenURIExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "uri",
        type: "string"
      }
    ],
    name: "setTokenURIExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "prefix",
        type: "string"
      }
    ],
    name: "setTokenURIPrefix",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "prefix",
        type: "string"
      }
    ],
    name: "setTokenURIPrefixExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "tokenExtension",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      }
    ],
    name: "unregisterExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], Xl = {
  ERC721CreatorABI: Jl
}, Yl = [
  {
    inputs: [
      {
        internalType: "string",
        name: "uri_",
        type: "string"
      }
    ],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]"
      }
    ],
    name: "TransferBatch",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "TransferSingle",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "string",
        name: "value",
        type: "string"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "URI",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      }
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], Ql = {
  ERC1155ABI: Yl
}, jl = [
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "AdminApproved",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "AdminRevoked",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "ApprovalForAll",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "extension",
        type: "address"
      }
    ],
    name: "ApproveTransferUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "DefaultRoyaltiesUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "enabled",
        type: "bool"
      }
    ],
    name: "ExtensionApproveTransferUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "ExtensionBlacklisted",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "ExtensionRegistered",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "ExtensionRoyaltiesUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "ExtensionUnregistered",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint8",
        name: "version",
        type: "uint8"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "permissions",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "sender",
        type: "address"
      }
    ],
    name: "MintPermissionsUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "RoyaltiesUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]"
      }
    ],
    name: "TransferBatch",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "TransferSingle",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "string",
        name: "value",
        type: "string"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "URI",
    type: "event"
  },
  {
    inputs: [],
    name: "VERSION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      }
    ],
    name: "approveAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      }
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      }
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      }
    ],
    name: "blacklistExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "getAdmins",
    outputs: [
      {
        internalType: "address[]",
        name: "admins",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getApproveTransfer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getExtensions",
    outputs: [
      {
        internalType: "address[]",
        name: "extensions",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getFeeBps",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getFeeRecipients",
    outputs: [
      {
        internalType: "address payable[]",
        name: "",
        type: "address[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getFees",
    outputs: [
      {
        internalType: "address payable[]",
        name: "",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "getRoyalties",
    outputs: [
      {
        internalType: "address payable[]",
        name: "",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string"
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string"
      }
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      }
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address"
      },
      {
        internalType: "address",
        name: "operator",
        type: "address"
      }
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "to",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    name: "mintBaseExisting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "to",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      },
      {
        internalType: "string[]",
        name: "uris",
        type: "string[]"
      }
    ],
    name: "mintBaseNew",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "to",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      }
    ],
    name: "mintExtensionExisting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "to",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      },
      {
        internalType: "string[]",
        name: "uris",
        type: "string[]"
      }
    ],
    name: "mintExtensionNew",
    outputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        internalType: "string",
        name: "baseURI",
        type: "string"
      }
    ],
    name: "registerExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        internalType: "string",
        name: "baseURI",
        type: "string"
      },
      {
        internalType: "bool",
        name: "baseURIIdentical",
        type: "bool"
      }
    ],
    name: "registerExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      }
    ],
    name: "revokeAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256"
      }
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address"
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool"
      }
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      }
    ],
    name: "setApproveTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "enabled",
        type: "bool"
      }
    ],
    name: "setApproveTransferExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "uri_",
        type: "string"
      }
    ],
    name: "setBaseTokenURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "uri_",
        type: "string"
      }
    ],
    name: "setBaseTokenURIExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "uri_",
        type: "string"
      },
      {
        internalType: "bool",
        name: "identical",
        type: "bool"
      }
    ],
    name: "setBaseTokenURIExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        internalType: "address",
        name: "permissions",
        type: "address"
      }
    ],
    name: "setMintPermissions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "setRoyalties",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "setRoyalties",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      },
      {
        internalType: "address payable[]",
        name: "receivers",
        type: "address[]"
      },
      {
        internalType: "uint256[]",
        name: "basisPoints",
        type: "uint256[]"
      }
    ],
    name: "setRoyaltiesExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "uri_",
        type: "string"
      }
    ],
    name: "setTokenURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      },
      {
        internalType: "string[]",
        name: "uris",
        type: "string[]"
      }
    ],
    name: "setTokenURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]"
      },
      {
        internalType: "string[]",
        name: "uris",
        type: "string[]"
      }
    ],
    name: "setTokenURIExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "uri_",
        type: "string"
      }
    ],
    name: "setTokenURIExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "prefix",
        type: "string"
      }
    ],
    name: "setTokenURIPrefix",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "prefix",
        type: "string"
      }
    ],
    name: "setTokenURIPrefixExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "tokenExtension",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "extension",
        type: "address"
      }
    ],
    name: "unregisterExtension",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  }
], tf = {
  ERC1155CreatorABI: jl
}, ef = [
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "caller",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "series",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "maxSupply",
        type: "uint256"
      }
    ],
    name: "SeriesCreated",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4"
      }
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "series",
        type: "uint256"
      }
    ],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "series",
        type: "uint256"
      }
    ],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "maxSupply_",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "prefix",
        type: "string"
      }
    ],
    name: "createSeries",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      }
    ],
    name: "latestSeries",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "series",
        type: "uint256"
      },
      {
        internalType: "string",
        name: "prefix",
        type: "string"
      }
    ],
    name: "setTokenURIPrefix",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256"
      }
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "series",
        type: "uint256"
      },
      {
        internalType: "address[]",
        name: "recipients",
        type: "address[]"
      }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "series",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address"
      },
      {
        internalType: "uint16",
        name: "count",
        type: "uint16"
      }
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], nf = {
  ManifoldERC721EditionABI: ef
};
(function(n) {
  Object.defineProperty(n, "__esModule", { value: !0 }), n.ERC1155CreatorABI = n.ERC721CreatorABI = n.ERC1155ABI = n.ManifoldERC721EditionABI = n.ERC721ABI = n.ERC20ABI = void 0;
  var t = Zl;
  Object.defineProperty(n, "ERC20ABI", { enumerable: !0, get: function() {
    return t.ERC20ABI;
  } });
  var e = Wl;
  Object.defineProperty(n, "ERC721ABI", { enumerable: !0, get: function() {
    return e.ERC721ABI;
  } });
  var r = Xl;
  Object.defineProperty(n, "ERC721CreatorABI", { enumerable: !0, get: function() {
    return r.ERC721CreatorABI;
  } });
  var i = Ql;
  Object.defineProperty(n, "ERC1155ABI", { enumerable: !0, get: function() {
    return i.ERC1155ABI;
  } });
  var s = tf;
  Object.defineProperty(n, "ERC1155CreatorABI", { enumerable: !0, get: function() {
    return s.ERC1155CreatorABI;
  } });
  var o = nf;
  Object.defineProperty(n, "ManifoldERC721EditionABI", { enumerable: !0, get: function() {
    return o.ManifoldERC721EditionABI;
  } });
})(Ga);
class rf extends Error {
  constructor({ message: t, networkId: e }) {
    super(t), this.name = "WrongNetworkError", this.networkId = e;
  }
}
const gn = "0x0000000000000000000000000000000000000000", Ar = {
  APE: {
    coinGeckoId: "apecoin",
    erc20: {
      [O.Mainnet]: {
        address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
        decimals: 18
      },
      [O.Goerli]: {
        address: void 0,
        decimals: 18
      },
      [O.Sepolia]: {
        address: void 0,
        decimals: 18
      },
      [O.Optimism]: {
        address: void 0,
        decimals: 18
      },
      [O.Base]: {
        address: void 0,
        decimals: 18
      },
      [O.Matic]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "APE"
  },
  ASH: {
    coinGeckoId: "ash",
    erc20: {
      [O.Mainnet]: {
        address: "0x64d91f12ece7362f91a6f8e7940cd55f05060b92",
        decimals: 18
      },
      [O.Goerli]: {
        address: void 0,
        decimals: 18
      },
      [O.Sepolia]: {
        address: void 0,
        decimals: 18
      },
      [O.Optimism]: {
        address: void 0,
        decimals: 18
      },
      [O.Base]: {
        address: void 0,
        decimals: 18
      },
      [O.Matic]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "ASH"
  },
  DAI: {
    coinGeckoId: "dai",
    erc20: {
      [O.Mainnet]: {
        address: "0x6b175474e89094c44da98b954eedeac495271d0f",
        decimals: 18
      },
      [O.Goerli]: {
        address: void 0,
        decimals: 18
      },
      [O.Sepolia]: {
        address: void 0,
        decimals: 18
      },
      [O.Optimism]: {
        address: "0xda10009cbd5d07dd0cecc66161fc93d7c9000da1",
        decimals: 18
      },
      [O.Base]: {
        address: "0x50c5725949a6f0c72e6c4a641f24049a917db0cb",
        decimals: 18
      },
      [O.Matic]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "DAI"
  },
  ETH: {
    coinGeckoId: "ethereum",
    erc20: {
      [O.Mainnet]: {
        address: gn,
        decimals: 18
      },
      [O.Goerli]: {
        address: gn,
        decimals: 18
      },
      [O.Sepolia]: {
        address: gn,
        decimals: 18
      },
      [O.Optimism]: {
        address: gn,
        decimals: 18
      },
      [O.Base]: {
        address: gn,
        decimals: 18
      },
      [O.Matic]: {
        address: gn,
        decimals: 18
      }
    },
    name: "ETH"
  },
  LOOKS: {
    coinGeckoId: "looksrare",
    erc20: {
      [O.Mainnet]: {
        address: "0xf4d2888d29d722226fafa5d9b24f9164c092421e",
        decimals: 18
      },
      [O.Goerli]: {
        address: void 0,
        decimals: 18
      },
      [O.Sepolia]: {
        address: void 0,
        decimals: 18
      },
      [O.Optimism]: {
        address: void 0,
        decimals: 18
      },
      [O.Base]: {
        address: void 0,
        decimals: 18
      },
      [O.Matic]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "LOOKS"
  },
  PEPE: {
    coinGeckoId: "pepe",
    erc20: {
      [O.Mainnet]: {
        address: "0x6982508145454ce325ddbe47a25d4ec3d2311933",
        decimals: 18
      },
      [O.Goerli]: {
        address: void 0,
        decimals: 18
      },
      [O.Sepolia]: {
        address: void 0,
        decimals: 18
      },
      [O.Optimism]: {
        address: void 0,
        decimals: 18
      },
      [O.Base]: {
        address: void 0,
        decimals: 18
      },
      [O.Matic]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "PEPE"
  },
  RARE: {
    coinGeckoId: "superrare",
    erc20: {
      [O.Mainnet]: {
        address: "0xba5bde662c17e2adff1075610382b9b691296350",
        decimals: 18
      },
      [O.Goerli]: {
        address: void 0,
        decimals: 18
      },
      [O.Sepolia]: {
        address: void 0,
        decimals: 18
      },
      [O.Optimism]: {
        address: void 0,
        decimals: 18
      },
      [O.Base]: {
        address: void 0,
        decimals: 18
      },
      [O.Matic]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "RARE"
  },
  TURBO: {
    coinGeckoId: "turbo",
    erc20: {
      [O.Mainnet]: {
        address: "0x4d224452801aced8b2f0aebe155379bb5d594381",
        decimals: 18
      },
      [O.Goerli]: {
        address: void 0,
        decimals: 18
      },
      [O.Sepolia]: {
        address: void 0,
        decimals: 18
      },
      [O.Optimism]: {
        address: void 0,
        decimals: 18
      },
      [O.Base]: {
        address: void 0,
        decimals: 18
      },
      [O.Matic]: {
        address: void 0,
        decimals: 18
      }
    },
    name: "TURBO"
  },
  USDC: {
    coinGeckoId: "usd-coin",
    erc20: {
      [O.Mainnet]: {
        address: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
        decimals: 6
      },
      [O.Goerli]: {
        address: void 0,
        decimals: 6
      },
      [O.Sepolia]: {
        address: void 0,
        decimals: 6
      },
      [O.Matic]: {
        address: void 0,
        decimals: 6
      },
      [O.Optimism]: {
        address: "0x0b2c639c533813f4aa9d7837caf62653d097ff85",
        decimals: 6
      },
      [O.Base]: {
        address: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
        decimals: 6
      }
    },
    name: "USDC"
  },
  USDT: {
    coinGeckoId: "tether",
    erc20: {
      [O.Mainnet]: {
        address: "0xdac17f958d2ee523a2206206994597c13d831ec7",
        decimals: 6
      },
      [O.Goerli]: {
        address: void 0,
        decimals: 6
      },
      [O.Sepolia]: {
        address: void 0,
        decimals: 6
      },
      [O.Matic]: {
        address: void 0,
        decimals: 6
      },
      [O.Optimism]: {
        address: "0x94b008aa00579c1307b0ef2c499ad98a8ce58e58",
        decimals: 6
      },
      [O.Base]: {
        address: void 0,
        decimals: 6
      }
    },
    name: "USDT"
  },
  WETH: {
    coinGeckoId: "weth",
    erc20: {
      [O.Mainnet]: {
        address: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
        decimals: 18
      },
      [O.Goerli]: {
        address: void 0,
        decimals: 18
      },
      [O.Sepolia]: {
        address: void 0,
        decimals: 18
      },
      [O.Matic]: {
        address: void 0,
        decimals: 18
      },
      [O.Optimism]: {
        address: "0x4200000000000000000000000000000000000006",
        decimals: 18
      },
      [O.Base]: {
        address: "0x4200000000000000000000000000000000000006",
        decimals: 18
      }
    },
    name: "WETH"
  }
};
function Ha(n, t) {
  return new _n(n).toFixed(t, _n.ROUND_UP);
}
function sf(n, t) {
  return ho(Ha(n, t));
}
function af(n) {
  switch (n) {
    case O.Mainnet:
      return "ETH";
    case O.Goerli:
      return "GoETH";
    case O.Optimism:
      return "OETH";
    case O.Base:
      return "BETH";
    default:
      return "ETH";
  }
}
function Va(n) {
  return n in Ar;
}
const za = (n) => {
  if (!Va(n))
    throw new Error(`Currency ${n} not supported`);
  return Ar[n];
}, of = (n) => Ya(n) ? Object.entries(Ar).filter(([, t]) => t.erc20[n].address).map(([t]) => t) : [];
async function qa(n, t, e) {
  var o, f;
  for (const [c, d] of Object.entries(Ar))
    if (((f = (o = d.erc20[n]) == null ? void 0 : o.address) == null ? void 0 : f.toLowerCase()) === t.toLowerCase())
      return {
        symbol: c,
        decimals: d.erc20[n].decimals
      };
  if (n !== Number(e._network.chainId))
    throw new rf({
      message: "Please switch to the correct network",
      networkId: n
    });
  const r = new zl(t, Ga.ERC20ABI, e), [i, s] = await Promise.all([r.decimals(), r.symbol()]);
  return {
    symbol: s,
    decimals: i
  };
}
async function uf(n, t, e, r) {
  if (n === "0")
    return "Free";
  if (t && e) {
    let i;
    if (Yu(t)) {
      if (!r)
        throw new Error("Provider is required");
      i = await qa(e, t, r);
      const s = Qa(e, t);
      return `${n ? ss(n, i.decimals).toString() : ""} <a href=${s} target="_blank">${i.symbol}</a>`;
    } else
      return i = za(t), `${n ? ss(n, i.erc20[e].decimals).toString() : ""} ${t}`;
  }
  return "";
}
const hf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  commifiedRoundedNumberString: sf,
  ethCurrencyNameForNetwork: af,
  formatCurrency: uf,
  getCurrenciesOnNetwork: of,
  getERC20Metadata: qa,
  getSupportedCurrencyInfo: za,
  isSupportedCurrency: Va,
  numberStringRound: Ha
}, Symbol.toStringTag, { value: "Module" }));
export {
  sf as a,
  of as b,
  hf as c,
  qa as d,
  af as e,
  uf as f,
  za as g,
  Va as i,
  Ha as n
};
